/* MediCube i18n dictionaries (extracted from snippets/mc-i18n*.liquid so they are cached + non-blocking). Loaded with defer; consumed on DOMContentLoaded. */
window.MC_TRANSLATIONS = window.MC_TRANSLATIONS || {};
  window.MC_TRANSLATIONS['en'] = {
    // -------------------------------------------------------------
    // 1. HEADER & NAVIGATION
    // -------------------------------------------------------------
    "announcement_text": "⚡ FREE DHL SHIPPING • 30-DAY MONEY-BACK GUARANTEE ⚡",
    "nav_all_products": "All Products",
    "nav_devices": "AGE-R Beauty Devices",
    "nav_skincare": "Skincare",
    "nav_skincare_lines": "Skincare Lines",
    "nav_zero_line": "Zero Pore Line (Pores & Sebum)",
    "nav_glass_glow": "Triple Collagen & Glow (Lifting & Firmness)",
    "nav_pink_pdrn": "Pink PDRN Line (Barrier & Peptides)",
    "nav_super_cica": "Exosome Super Cica (Calming & Soothing)",
    "nav_deep_line": "Deep Vitamin C (Anti-Aging & Radiance)",
    "nav_red_line": "Red Acne Line (Blemish Care)",
    "nav_txa_line": "TXA & Kojic Acid (Brightening)",
    "nav_by_category": "By Category",
    "nav_cleanser": "Cleansers & Cleansing",
    "nav_toner": "Toners & Exfoliating Pads",
    "nav_serums": "Serums & Ampoules",
    "nav_creams": "Creams & Moisturizers",
    "nav_masks": "Sheet Masks & Wrapping",
    "nav_sun": "Sun Protection (SPF)",
    "nav_sets": "Sets & Bundles",
    "nav_sets_sub": "Value Sets & Bundles",
    "nav_bestsellers": "Bestsellers",
    "nav_guide": "AGE-R Guide & Instructions",
    "nav_about": "About Us",
    "nav_help": "Help & Support",
    "nav_account": "My Account / Sign In",
    "search_placeholder": "Search products, ingredients, lines...",
    "region_title": "Region & Currency",
    "region_sub": "Select your delivery country for local currency & details",
    "region_search": "Search country or currency...",
    "language_label": "Language / Sprache:",

    // -------------------------------------------------------------
    // 2. MAIN PDP (ABOVE THE FOLD)
    // -------------------------------------------------------------
    "reviews_count_suffix": "Reviews",
    "badge_set_save": "🔥 5-PIECE COMPLETE SET • SAVE €105 (75% OFF)",
    "badge_bestseller": "BESTSELLER",
    "badge_viral": "TIKTOK VIRAL",
    "save_75": "SAVE 75%",
    "save_24": "SAVE 24%",
    "save_31": "SAVE 31%",
    "science_badge_title": "Backed by Science",
    "science_badge_sub": "<strong>80+ peer-reviewed studies</strong> supporting our formula.",
    "science_badge_link": "View studies & learn more",
    "klarna_installments_prefix": "Or 3 interest-free installments of",
    "klarna_installments_suffix": "with",
    "klarna_learn_more": "Learn more",
    "atc_btn_text": "ADD TO CART",
    "atc_adding": "Adding...",
    "atc_sold_out": "Sold Out",
    "urgency_badge": "LIMITED DAILY OFFER",
    "urgency_timer_label": "Deal ends in:",
    "urgency_copy": "⚡ <strong>Valid today only:</strong> Up to <strong>31% off + up to 2 FREE bottles</strong> in our value bundle. High demand – stock for today's dispatch almost gone.",
    "free_shipping_unlocked": "Free DHL Shipping unlocked",
    "choose_routine": "Choose your routine:",
    "bestseller_pick": "🔥 87% choose the Bestseller Set",
    "body_peel_title": "1x Body Peel",
    "body_peel_sub": "280ml • Gentle Body Exfoliator",
    "face_peel_title": "1x Face Peel",
    "face_peel_sub": "50ml • Clarifying Facial Serum",
    "duo_set_title": "Duo Set (Body + Face)",
    "duo_free_tag": "+ 1 FREE",
    "duo_meta": "€19.00 / product • 330ml Routine",
    "double_duo_title": "2x Body Peel Value Pack",
    "double_free_tag": "+ 2 FREE",
    "double_meta": "€34.50 / bottle • 560ml Supply",
    "most_popular": "🔥 Most Popular",
    "best_value": "💎 Best Value",
    "save_label": "Save",
    "gifts_header": "YOUR FREE GIFTS WITH PURCHASE",
    "gift_free_shipping": "Free Shipping",
    "gift_free": "FREE",
    "gift_1_bottle": "1x FREE Bottle",
    "gift_2_bottles": "2x FREE Bottles",
    "gift_unlock_2x": "🔒 Unlocks with 2x Supply",
    "sub_save_title": "Subscribe & Save (30% Off)",
    "sub_save_meta": "30% recurring discount on every auto-delivery. Cancel anytime in 1 click.",
    "sub_tooltip_title": "Full Flexibility with Subscription:",
    "sub_tooltip_body": "Automatically receive 30% off your first and every follow-up order. Choose your delivery rhythm, pause or skip deliveries in your customer account, or cancel with 1 click anytime. No minimum term, no hidden fees.",
    "sub_perk_free_ship": "Free delivery on all orders",
    "sub_perk_discount": "30% off every follow-up order",
    "sub_perk_cancel": "Pause, adjust, or cancel anytime in 1 click",
    "size_variant_label": "Size / Variant:",
    "value_pack_tag": "VALUE PACK",
    "preview_bundle_title": "Included in the 5-Piece Value Bundle:",
    "upsell_title": "Frequently Bought Together",
    "upsell_sub": "Dermatologist-recommended routine additions for maximum results:",
    "btn_add": "+ Add",
    "btn_added": "Added",
    "trust_fast_ship": "<strong>Fast Shipping:</strong> 1-3 business days delivery via DHL",
    "trust_kbeauty": "<strong>100% Authentic K-Beauty:</strong> Direct from authorized manufacturer",
    "trust_guarantee": "<strong>30-Day Satisfaction Guarantee:</strong> Risk-free trial",
    "guarantee_title": "30-Day Money-Back Guarantee",
    "guarantee_sub": "Try risk-free for 30 days. Not satisfied? Full refund – no questions asked.",
    "guarantee_learn_more": "Learn more ›",
    "cross_sell_heading": "Pairs Perfectly With",
    "schema_skin_type": "Skin Type",
    "schema_hair_type": "Hair Type",
    "schema_skin_concerns": "Skin Concerns",
    "schema_hair_concerns": "Care Needs",
    "schema_key_actives": "Key Active Ingredients",

    // Concise Value Bullets (Youth Lock)
    "yl_bullet_1": "<strong>5-in-1 Complete System:</strong> All 5 K-Beauty bestsellers for neck, jawline & eyes in one box",
    "yl_bullet_2": "<strong>PDRN (Salmon DNA) + 5% Volufiline:</strong> Stimulates collagen synthesis & naturally plumps fine lines",
    "yl_bullet_3": "<strong>Integrated Gua Sha Massage Head:</strong> Ergonomic surgical steel tool for daily V-line lymphatic drainage",
    "yl_bullet_4": "<strong>€105 Instant Savings:</strong> €139.00 separate retail value today for just €34.00 incl. DHL Express shipping",

    // PDP Tabs / Accordions
    "tab_benefits": "Benefits & Efficacy",
    "tab_clinicals": "Clinical Studies & Results",
    "tab_ingredients": "Clean Formula & Ingredients",
    "tab_usage": "How to Use & Routine Steps",
    "tab_faq": "Frequently Asked Questions (FAQ)",
    "tab_sub_perks": "Subscription Benefits (30% Off)",

    // -------------------------------------------------------------
    // 3. YOUTH-LOCK BUNDLE SUITE (MODULES 1-7)
    // -------------------------------------------------------------
    "yl_badge_top": "€139.00 TOTAL RETAIL VALUE • TODAY ONLY €34.00",
    "yl_title": "What is included in the 5-piece complete set?",
    "yl_subtitle": "Five synergistically formulated K-Beauty innovations featuring high-purity <strong>PDRN (Salmon DNA)</strong>, <strong>5% Volufiline</strong>, and an integrated <strong>Gua Sha massage head</strong> for your daily anti-aging & V-lift contouring routine.",
    
    // Product 1
    "p1_badge": "THE HERO PRODUCT",
    "p1_step": "STEP 4",
    "p1_cat": "NECK & DÉCOLLETÉ LIFTING",
    "p1_name": "PDRN Gua Sha Neck Wrinkle Cream",
    "p1_spec": "90g tube with integrated surgical steel Gua Sha applicator",
    "p1_desc": "Combines <strong>5% Volufiline</strong> and <strong>Salmon PDRN</strong> with ergonomic lymphatic drainage. Smooths deep tech-neck creases and firms sagging neck contours without separate tools.",
    
    // Product 2
    "p2_badge": "V-LINE CONTOURING",
    "p2_step": "STEP 1",
    "p2_cat": "JAWLINE CONTOUR & DOUBLE CHIN",
    "p2_name": "PDRN Pink Tension Up Mask",
    "p2_spec": "4-Pack • Elastic V-Shape Lifting Band",
    "p2_desc": "Patented tension band technology with ear loops that physically lifts the jawline while delivering PDRN, NAD+, and collagen deep into the dermis.",

    // Product 3
    "p3_badge": "INSTANT FRESHNESS",
    "p3_step": "STEP 2",
    "p3_cat": "EYE DE-PUFFING & GLOW",
    "p3_name": "Caffeine Collagen Eye Patches",
    "p3_spec": "Jar with 60 hydrogel patches (85g)",
    "p3_desc": "Cooling, pink shimmering hydrogel patches infused with caffeine and collagen. Relieves puffiness, brightens dark circles, and restores awake radiance.",

    // Product 4
    "p4_badge": "CROW'S FEET & FINE LINES",
    "p4_step": "STEP 3",
    "p4_cat": "TARGETED EYE CARE",
    "p4_name": "PDRN Pink Peptide Eye Cream",
    "p4_spec": "30ml precision pump tube",
    "p4_desc": "High-potency multi-peptide complex + Niacinamide. Plumps fine expression lines around eyes, firms delicate eyelids, and prevents moisture loss.",

    // Product 5
    "p5_badge": "GLASS-SKIN FINISH",
    "p5_step": "STEP 5",
    "p5_cat": "INSTANT GLOW & LIPS",
    "p5_name": "PDRN Collagen Multi Balm Stick",
    "p5_spec": "10g twist stick for on-the-go care",
    "p5_desc": "The viral Korean beauty balm stick with <strong>5% Volufiline</strong>. Smooths forehead and laugh lines instantly while creating the coveted Korean glass-skin dewy glow.",

    // Calculation Banner
    "calc_tag": "TRANSPARENT VALUE BREAKDOWN",
    "calc_strike": "139.00 € MSRP",
    "calc_deal": "34.00 € COMPLETE SET",
    "calc_note": "You save <strong>105.00 € (75% discount)</strong> compared to purchasing items separately. Includes free DHL Express shipping.",
    "calc_btn": "CLAIM YOUR SET NOW",

    // Module 2: Timeline
    "routine_pill": "FAST & EASY • JUST 5 MINUTES A DAY",
    "routine_title": "Your Daily 5-Step Youth-Lock Regimen",
    "routine_subtitle": "No complicated 12-step rituals. Specially engineered by Korean dermatologists to deliver maximum V-lift contouring and firming in less than 5 minutes daily.",
    "step1_time": "2–3x / WEEK • 15 MIN",
    "step1_title": "Apply V-Line Band",
    "step1_desc": "Center mask under chin and loop elastic sides over ears. Physically lifts tissue and sculpts jawline contours.",
    "step2_time": "DAILY MORNING • 10 MIN",
    "step2_title": "De-Puff Eye Area",
    "step2_desc": "Place two cooling hydrogel patches under eyes. Caffeine visibly reduces morning puffiness within minutes.",
    "step3_time": "MORNING & EVENING • 30 SEC",
    "step3_title": "Target Fine Lines",
    "step3_desc": "Gently tap a small pump around orbital bone with ring finger to plump crow's feet and expression lines.",
    "step4_time": "DAILY • 2 MINUTES",
    "step4_title": "Gua Sha Neck Massage",
    "step4_desc": "Gently squeeze tube and glide cooling surgical steel head upward from collarbone to chin. Clears lymphatic congestion and smooths tech-neck creases.",
    "step5_time": "ANYTIME • FINISH & GLOW",
    "step5_title": "On-The-Go Glass Skin Glow",
    "step5_desc": "Glide across cheekbones, forehead, and lips. 5% Volufiline provides instant hydration and the signature Korean dewy glass glow.",

    // Module 3: Gua Sha Technique
    "guasha_pill": "INTEGRATED GUA SHA TOOL • NO FRAGILE JADE STONE",
    "guasha_title": "The Proper Gua Sha Technique: Massage Like Korean Aesthetic Professionals",
    "guasha_subtitle": "Many avoid traditional Gua Sha stones because they break, are tricky to dose, or overstretch skin with poor technique. The MediCube applicator solves this permanently:",
    "guasha_d1_title": "1. Neck Lift Against Tech-Neck",
    "guasha_d1_desc": "Place the ergonomic curve at collarbone and sweep upward to chin with gentle, steady pressure. Never pull downward!",
    "guasha_d2_title": "2. Jawline & V-Line Definition",
    "guasha_d2_desc": "Glide the contour notch from chin along jawline outward to just beneath earlobe (3–5 strokes per side).",
    "guasha_d3_title": "3. Décolleté & Lymphatic Drainage",
    "guasha_d3_desc": "Sweep outward from breastbone toward underarms. Activates lymphatic drainage and relieves fluid retention.",
    "tool_f1": "✓ Surgical Stainless Steel (Cooling & Easy to Sanitize)",
    "tool_f2": "✓ Hygienic Twist Lock (Zero Leakage)",
    "tool_f3": "✓ Precise Dispensing During Massage",
    "guasha_stat_val": "-34%",
    "guasha_stat_desc": "Wrinkle depth on horizontal neck lines after 14 days",

    // Module 4: Science
    "science_pill": "DERMATOLOGICAL CLINICAL FORMULATION",
    "science_title": "The Dual-Action Science Behind the Set",
    "science_subtitle": "While ordinary skincare only hydrates the surface layer, the Youth-Lock formulation pairs regenerative cellular biochemistry with physical microcirculation.",
    "sci_p1_title": "PDRN (Salmon DNA)",
    "sci_p1_role": "Cellular DNA Repair",
    "sci_p1_desc": "PDRN (Polydeoxyribonucleotide) shares a 95% identical DNA base structure with human skin cells. It stimulates fibroblasts, boosts deep collagen synthesis, and repairs UV- and screen-light-induced cellular damage.",
    "sci_p2_title": "5% Volufiline™ (France)",
    "sci_p2_role": "Natural Tissue Plumping Effect",
    "sci_p2_desc": "A patented botanical lipid (Sarsasapogenin) from French active laboratory Sederma. Stimulates adipocyte lipid storage for a visible 'lipofilling effect' that naturally fills sunken neck lines and fine wrinkles from within.",
    "sci_p3_title": "Mechanical Gua Sha Drainage",
    "sci_p3_role": "Vascular & Tissue Stimulation",
    "sci_p3_desc": "Gentle upward strokes increase local microcirculation by up to 400%. Flushes stagnant lymphatic fluid, reduces tissue puffiness, and enables deep active penetration.",

    // Module 5: Clinical Results
    "results_pill": "CLINICALLY TESTED ON 34 PARTICIPANTS (4 WEEKS)",
    "results_title": "Measurable Clinical Results, Not Empty Promises",
    "results_subtitle": "In independent dermatological application tests conducted in Seoul, the combined regimen of these 5 products demonstrated significant improvements across all key aging parameters:",
    "stat1_val": "98%",
    "stat1_title": "Firmer Jawline & V-Contour",
    "stat1_desc": "confirmed visible lifting of the jawline after consistent use of the Tension Up Mask and Gua Sha applicator.",
    "stat2_val": "96%",
    "stat2_title": "Smoother Neck & Décolleté Area",
    "stat2_desc": "saw a clear reduction in horizontal neck creases ('Tech Neck') and felt noticeably firmer, elastic skin.",
    "stat3_val": "100%",
    "stat3_title": "Instant Freshness & Cooling Relief",
    "stat3_desc": "experienced immediate relief from tired, puffy eyes starting from the very first application of the Caffeine Eye Patches.",

    // Module 6: FAQ
    "faq_pill": "FREQUENTLY ASKED QUESTIONS",
    "faq_title": "Everything You Need to Know About the 5-Piece Set",
    "faq_q1": "In what exact order should I apply the 5 products?",
    "faq_a1": "The optimal routine follows the dermatological principle of lightest to richest texture:<br><br><strong>1. Tension Up Mask:</strong> Apply 2–3x weekly to cleansed skin and loop band over ears (15 min).<br><strong>2. Caffeine Eye Patches:</strong> Apply under eyes for 10 minutes (ideal in the morning for de-puffing).<br><strong>3. Peptide Eye Cream:</strong> Gently tap around orbital bone.<br><strong>4. Gua Sha Neck Wrinkle Cream:</strong> Massage from collarbone upward to chin using the integrated applicator.<br><strong>5. Multi Balm Stick:</strong> Apply as a nourishing glow finish on cheekbones, forehead lines, or lips (also perfect over makeup during the day).",
    "faq_q2": "Does the product smell like fish since PDRN is derived from salmon?",
    "faq_a2": "<strong>No, absolutely not!</strong> The active ingredient is pharmaceutical-grade, highly purified Sodium DNA, which undergoes an elaborate biochemical filtration process removing all proteins, lipids, and odors. The products feature a subtle, fresh, and soothing scent with zero fishy odor.",
    "faq_q3": "Can I combine this set with my AGE-R Booster Pro or other beauty devices?",
    "faq_a3": "<strong>Yes, exceptionally well!</strong> PDRN and Volufiline provide an ideal, nutrient-dense glide medium for the AGE-R Booster Pro. The device's Microcurrent (MC) and Derma-Shot modes further enhance the dermal absorption of the Peptide Eye Cream and Neck Cream.",
    "faq_q4": "Is this set suitable for sensitive or acne-prone skin?",
    "faq_a4": "Yes. All formulas are dermatologically tested on sensitive skin in South Korea, non-comedogenic (do not clog pores), hypoallergenic, and free from artificial parabens or harsh sulfates.",
    "faq_q5": "How long does a 5-piece set last?",
    "faq_a5": "With daily application, the 90g tube of Gua Sha Neck Cream, 10g Multi Balm, and 30ml Eye Cream last approximately <strong>6 to 8 weeks</strong>. The Eye Patch jar contains 60 patches (30 daily two-sided treatments). The Tension Up pack includes 4 intensive V-line contouring masks.",

    // Module 7: Sticky Bottom CTA
    "bottom_cta_tag": "LIMITED OFFER • 75% OFF",
    "bottom_cta_headline": "Ready for your firmest contour & youthful glow?",
    "bottom_cta_sub": "Get all 5 K-Beauty bestsellers in the exclusive value bundle for only <strong>34.00 €</strong> instead of 139.00 € MSRP.",
    "bottom_cta_btn": "ADD TO CART — 34.00 €",
    "bottom_cta_guarantee": "🔒 30-Day Money-Back Guarantee",
    "bottom_cta_shipping": "⚡ Fast DHL Shipping (1-3 Days)",

    // -------------------------------------------------------------
    // 4. CUSTOMER REVIEWS
    // -------------------------------------------------------------
    "rev_badge": "Verified Experiences",
    "rev_title": "Customer Reviews",
    "rev_subtitle": "Discover what verified customers are saying about our products",
    "rev_based_on": "Based on verified customer reviews",
    "rev_stars_5": "5 Stars",
    "rev_stars_4": "4 Stars",
    "rev_stars_3": "3 Stars",
    "rev_stars_2": "2 Stars",
    "rev_stars_1": "1 Star",
    "rev_verified": "Verified",
    "rev_helpful": "Helpful",
    "rev_write": "Write a Review",

    // -------------------------------------------------------------
    // 5. CART DRAWER
    // -------------------------------------------------------------
    "cart_title": "Your Cart",
    "cart_empty_title": "Your cart is currently empty",
    "cart_progress_away": "Only",
    "cart_progress_away_end": "away from Free DHL Shipping!",
    "cart_progress_free": "🎉 Free DHL Shipping unlocked!",
    "cart_frequently_bought": "Frequently Bought Together",
    "cart_checkout_btn": "CHECKOUT • SECURE PAYMENT",
    "cart_guarantee": "Risk-free trial: 30-day money-back guarantee on all orders.",

    // -------------------------------------------------------------
    // 6. HOMEPAGE
    // -------------------------------------------------------------
    "hero_s1_title": "Booster Pro X2™\n7-in-1 Total Solution Device",
    "hero_s1_sub": "Unlock your youthful glow\n2x more radiance, firmness, contouring & pore refinement",
    "hero_s1_btn": "SHOP NOW",
    "hero_s2_title": "Awaken your glow\novernight",
    "hero_s2_sub": "Formulated to intensively nourish and protect skin elasticity while you sleep.",
    "hero_s2_btn": "SHOP NOW",
    "hero_s3_title": "Poreless, Crystal-Clear Skin",
    "hero_s3_sub": "K-BEAUTY #1 PORE CARE PADS\nSimple & effective care for visibly refined pores",
    "hero_s3_btn": "SHOP NOW",
    "hero_s4_title": "Flawless Glass Glow\nall day long",
    "hero_s4_sub": "The custom collagen duo for radiant, deeply hydrated, and youthful skin.",
    "hero_s4_btn": "SHOP NOW",
    "devices_fixed_l1": "Trending Now:",
    "devices_fixed_l2": "Korean Skincare",
    "devices_fixed_italic": "Devices",
    "devices_btn_all": "VIEW ALL",
    "comm_heading": "REAL EXPERIENCES FROM OUR COMMUNITY",
    "skin_fixed_l1": "100% Dermatologist",
    "skin_fixed_italic": "Tested.",
    "skin_fixed_l2": "Clinically Proven<br>K-Beauty Formulas.",
    "btn_shop_now": "SHOP NOW",
    "btn_view_all": "VIEW ALL"
  };

  window.MC_TRANSLATIONS['fi'] = {
    // -------------------------------------------------------------
    // 1. HEADER & NAVIGATION
    // -------------------------------------------------------------
    "announcement_text": "⚡ ILMAINEN DHL-TOIMITUS • 30 PÄIVÄN TYYTYVÄISYYSTAKUU ⚡",
    "nav_all_products": "Kaikki tuotteet",
    "nav_devices": "AGE-R -kauneudenhoitolaitteet",
    "nav_skincare": "Ihonhoito",
    "nav_skincare_lines": "Ihonhoitosarjat",
    "nav_zero_line": "Zero Pore -sarja (Ihohuokoset & tali)",
    "nav_glass_glow": "Triple Collagen & Glow (Kiinteytys & kimmoisuus)",
    "nav_pink_pdrn": "Pink PDRN -sarja (Ihosuoja & peptidit)",
    "nav_super_cica": "Exosome Super Cica (Rauhoittava)",
    "nav_deep_line": "Deep Vitamin C (Anti-Aging & hehku)",
    "nav_red_line": "Red Acne -sarja (Epäpuhtauksien hoito)",
    "nav_txa_line": "TXA & kojiinihappo (Kirkastava)",
    "nav_by_category": "Kategorian mukaan",
    "nav_cleanser": "Puhdistustuotteet",
    "nav_toner": "Kasvovedet & kuorintalaput",
    "nav_serums": "Seerumit & ampullit",
    "nav_creams": "Voiteet & kosteutus",
    "nav_masks": "Kangasnaamiot & wrapping-naamiot",
    "nav_sun": "Aurinkosuoja (SPF)",
    "nav_sets": "Setit & tuotepaketit",
    "nav_sets_sub": "Etu-setit & pakkaukset",
    "nav_bestsellers": "Bestsellerit",
    "nav_guide": "AGE-R -opas & käyttöohjeet",
    "nav_about": "Tietoa meistä",
    "nav_help": "Asiakaspalvelu & tuki",
    "nav_account": "Oma tili / Kirjaudu sisään",
    "search_placeholder": "Hae tuotteita, ainesosia, sarjoja...",
    "region_title": "Alue & Valuutta",
    "region_sub": "Valitse toimitusmaasi nähdäksesi paikallisen valuutan ja tiedot",
    "region_search": "Hae maata tai valuuttaa...",
    "language_label": "Kieli / Language:",

    // -------------------------------------------------------------
    // 2. MAIN PDP (ABOVE THE FOLD)
    // -------------------------------------------------------------
    "reviews_count_suffix": "arvostelua",
    "badge_set_save": "🔥 5-OSAINEN TÄYDELLINEN SETTI • SÄÄSTÄ 105 € (75% ALENNUS)",
    "badge_bestseller": "BESTSELLERI",
    "badge_viral": "TIKTOK-VIRAALI",
    "save_75": "SÄÄSTÄ 75%",
    "save_24": "SÄÄSTÄ 24%",
    "save_31": "SÄÄSTÄ 31%",
    "science_badge_title": "Tieteellisesti todistettu",
    "science_badge_sub": "<strong>Yli 80 vertaisarvioitua tutkimusta</strong> tukee koostumustamme.",
    "science_badge_link": "Katso tutkimukset & lue lisää",
    "klarna_installments_prefix": "Tai 3 korotonta erää",
    "klarna_installments_suffix": "Klarnalla",
    "klarna_learn_more": "Lue lisää",
    "atc_btn_text": "LISÄÄ OSTOSKORIIN",
    "atc_adding": "Lisätään...",
    "atc_sold_out": "Loppuunmyyty",
    "urgency_badge": "PÄIVÄN RAJOITETTU TARJOUS",
    "urgency_timer_label": "Tarjous päättyy:",
    "urgency_copy": "⚡ <strong>Voimassa vain tänään:</strong> Jopa <strong>31% alennus + jopa 2 ILMAISTA pulloa</strong> etupaketissamme. Suuri kysyntä – tämän päivän lähetyserä melkein loppuunmyyty.",
    "free_shipping_unlocked": "Ilmainen DHL-toimitus saavutettu",
    "choose_routine": "Valitse rutiinisi:",
    "bestseller_pick": "🔥 87% valitsee Bestseller-setin",
    "body_peel_title": "1x Body Peel",
    "body_peel_sub": "280ml • Hellävarainen vartalokuorinta",
    "face_peel_title": "1x Face Peel",
    "face_peel_sub": "50ml • Kirkastava kasvoseerumi",
    "duo_set_title": "Duo-setti (Vartalo + Kasvot)",
    "duo_free_tag": "+ 1 ILMAINEN",
    "duo_meta": "19,00 € / tuote • 330ml rutiini",
    "double_duo_title": "2x Body Peel -säästöpakkaus",
    "double_free_tag": "+ 2 ILMAISTA",
    "double_meta": "34,50 € / pullo • 560ml pakkaus",
    "most_popular": "🔥 Suosituin",
    "best_value": "💎 Paras arvo",
    "save_label": "Säästä",
    "gifts_header": "ILMAISET LAHJASI TILAUKSEEN",
    "gift_free_shipping": "Ilmainen toimitus",
    "gift_free": "ILMAINEN",
    "gift_1_bottle": "1x ILMAINEN pullo",
    "gift_2_bottles": "2x ILMAISTA pulloa",
    "gift_unlock_2x": "🔒 Avautuu 2 kpl tilauksella",
    "sub_save_title": "Tilaa & säästä (30% alennus)",
    "sub_save_meta": "30% jatkuva alennus jokaiseen toimitukseen. Peruuta milloin vain 1 klikkauksella.",
    "sub_tooltip_title": "Täysi joustavuus tilauksellasi:",
    "sub_tooltip_body": "Saat automaattisesti 30% alennuksen ensimmäisestä ja kaikista tulevista tilauksista. Valitse toimitusväli, pidä taukoa tai ohita toimituksia asiakastililläsi tai peruuta milloin tahansa yhdellä klikkauksella. Ei määräaikaa, ei piilokuluja.",
    "sub_perk_free_ship": "Ilmainen toimitus kaikkiin tilauksiin",
    "sub_perk_discount": "30% alennus kaikista jatkotilauksista",
    "sub_perk_cancel": "Pidä taukoa, muuta tai peruuta milloin vain 1 klikkauksella",
    "size_variant_label": "Koko / Versio:",
    "value_pack_tag": "SÄÄSTÖPAKKAUS",
    "preview_bundle_title": "Sisältyy 5-osaiseen etupakettiin:",
    "upsell_title": "Ostetaan usein yhdessä",
    "upsell_sub": "Ihotautilääkärien suosittelemat rutiinilisät maksimaalisiin tuloksiin:",
    "btn_add": "+ Lisää",
    "btn_added": "Lisätty",
    "trust_fast_ship": "<strong>Nopea toimitus:</strong> 1-3 arkipäivää DHL:llä",
    "trust_kbeauty": "<strong>100% aito K-Beauty:</strong> Suoraan valtuutetulta valmistajalta",
    "trust_guarantee": "<strong>30 päivän tyytyväisyystakuu:</strong> Kokeile täysin riskittömästi",
    "guarantee_title": "30 päivän rahat takaisin -takuu",
    "guarantee_sub": "Kokeile riskittömästi 30 päivää. Etkö ole tyytyväinen? Täysi hyvitys – ilman kysymyksiä.",
    "guarantee_learn_more": "Lue lisää ›",
    "cross_sell_heading": "Sopii täydellisesti yhteen",
    "schema_skin_type": "Ihotyyppi",
    "schema_hair_type": "Hiustyyppi",
    "schema_skin_concerns": "Iho-ongelmat",
    "schema_hair_concerns": "Hoitotarpeet",
    "schema_key_actives": "Tärkeimmät tehoaineet",

    // Concise Value Bullets (Youth Lock)
    "yl_bullet_1": "<strong>5-in-1 -kokonaisuus:</strong> Kaikki 5 K-Beauty -bestselleriä kaulalle, leukalinjalle & silmänympäryksille yhdessä laatikossa",
    "yl_bullet_2": "<strong>PDRN (Lohi-DNA) + 5% Volufiline:</strong> Stimuloi kollageenisynteesiä ja täyteläistää juonteita luonnollisesti",
    "yl_bullet_3": "<strong>Integroitu Gua Sha -hierontapää:</strong> Ergonominen kirurginteräskärki päivittäiseen V-linjan lymfahierontaan",
    "yl_bullet_4": "<strong>Säästä heti 105 €:</strong> 139,00 € erillisarvo tänään vain 34,00 € sis. DHL Express -toimituksen",

    // PDP Tabs / Accordions
    "tab_benefits": "Hyödyt & Teho",
    "tab_clinicals": "Kliiniset tutkimukset & tulokset",
    "tab_ingredients": "Puhdas koostumus & ainesosat",
    "tab_usage": "Käyttöohje & rutiinivaiheet",
    "tab_faq": "Usein kysytyt kysymykset (FAQ)",
    "tab_sub_perks": "Kestotilauksen edut (30% alennus)",

    // -------------------------------------------------------------
    // 3. YOUTH-LOCK BUNDLE SUITE (MODULES 1-7)
    // -------------------------------------------------------------
    "yl_badge_top": "139,00 € KOKONAISARVO • TÄNÄÄN VAIN 34,00 €",
    "yl_title": "Mitä 5-osainen täydellinen setti sisältää?",
    "yl_subtitle": "Viisi synergistisesti kehitettyä K-Beauty -innovaatiota korkeapuhtaalla <strong>PDRN:llä (Lohi-DNA)</strong>, <strong>5% Volufilinella</strong> ja integroidulla <strong>Gua Sha -hierontapäällä</strong> päivittäiseen anti-aging- ja V-lift-kiinteytysrutiiniisi.",
    
    // Product 1
    "p1_badge": "PÄÄTUOTE (HERO)",
    "p1_step": "VAIHE 4",
    "p1_cat": "KAULAN & DEKOLTEEN KIINTEYTYS",
    "p1_name": "PDRN Gua Sha Neck Wrinkle Cream",
    "p1_spec": "90g tuubi integroidulla kirurginteräksisellä Gua Sha -hierontapäällä",
    "p1_desc": "Yhdistää <strong>5% Volufilinen</strong> ja <strong>lohi-PDRN:n</strong> ergonomiseen lymfahierontaan. Tasoittaa syviä tech-neck-juonteita ja kiinteyttää kaulan ihoa ilman erillisiä välineitä.",
    
    // Product 2
    "p2_badge": "V-LINJAN MUOTOILU",
    "p2_step": "VAIHE 1",
    "p2_cat": "LEUKALINJA & KAKSOISLEUKA",
    "p2_name": "PDRN Pink Tension Up Mask",
    "p2_spec": "4 kpl pakkaus • Joustava V-Shape -muotoilukangasnaamio",
    "p2_desc": "Patentoitu korvalenkeillä varustettu napakoittava kangasnaamio, joka kohottaa fyysisesti leukalinjaa ja imeyttää samalla PDRN:ää, NAD+:aa ja kollageenia syvälle dermikseen.",

    // Product 3
    "p3_badge": "VÄLITÖN RAIKAUS",
    "p3_step": "VAIHE 2",
    "p3_cat": "SILMÄNYMPÄRYKSEN TURVOTUKSEN POISTO & HEHKU",
    "p3_name": "Caffeine Collagen Eye Patches",
    "p3_spec": "Purkki, jossa 60 hydrogeelilappua (85g)",
    "p3_desc": "Viilentävät, vaaleanpunaisena hohtavat kofeiinilla ja kollageenilla rikastetut hydrogeelilaput. Laskevat silmänalusten turvotusta, kirkastavat tummia silmänalusia ja herättävät katseen hehkun.",

    // Product 4
    "p4_badge": "HARAKANVARPAAT & JUONTEET",
    "p4_step": "VAIHE 3",
    "p4_cat": "KOHDISTETTU SILMÄNYMPÄRYSHOITO",
    "p4_name": "PDRN Pink Peptide Eye Cream",
    "p4_spec": "30ml tarkkuusannostelutuubi",
    "p4_desc": "Korkeapitoinen multipeptidiyhdiste + niasiiniamidi. Täyteläistää silmänympäryksen ilmejuonteita, kiinteyttää herkkää silmäluomen ihoa ja estää kosteuden haihtumista.",

    // Product 5
    "p5_badge": "GLASS-SKIN -HEHKU",
    "p5_step": "VAIHE 5",
    "p5_cat": "VÄLITÖN HEHKU & HUULET",
    "p5_name": "PDRN Collagen Multi Balm Stick",
    "p5_spec": "10g kätevä kiertopuikko mukaan otettavaksi",
    "p5_desc": "Viraali korealainen monitoimipuikko <strong>5% Volufilinella</strong>. Silottaa otsan ja naururyppyjen juonteita välittömästi luoden samalla korealaisen heleän \"glass skin\" -kosteushehkuviimeistelyn.",

    // Calculation Banner
    "calc_tag": "LÄPINÄKYVÄ HINTAETU",
    "calc_strike": "139,00 € OVH",
    "calc_deal": "34,00 € TÄYDELLINEN SETTI",
    "calc_note": "Säästät <strong>105,00 € (75% alennus)</strong> verrattuna tuotteiden ostamiseen erikseen. Sisältää ilmaisen DHL Express -toimituksen.",
    "calc_btn": "LUNASTA SETTISI NYT",

    // Module 2: Timeline
    "routine_pill": "HELPPO & NOPEA • VAIN 5 MINUUTTIA PÄIVÄSSÄ",
    "routine_title": "Päivittäinen 5-vaiheinen Youth-Lock -rutiinisi",
    "routine_subtitle": "Ei monimutkaisia 12 vaiheen rituaaleja. Korealaisten ihotautilääkärien suunnittelema rutiini takaa maksimaalisen V-linjan muotoilun ja kiinteyden alle 5 minuutissa päivässä.",
    "step1_time": "2–3x / VIIKOSSA • 15 MIN",
    "step1_title": "Aseta V-Line -naamio",
    "step1_desc": "Aseta naamio leuan alle ja kiinnitä korvalenkit. Kohottaa kudosta ja muotoilee leukalinjaa.",
    "step2_time": "PÄIVITTÄIN AAMUISIN • 10 MIN",
    "step2_title": "Laske silmänympäryksen turvotusta",
    "step2_desc": "Aseta kaksi viilentävää hydrogeelilappua silmien alle. Kofeiini vähentää aamuturvotusta näkyvästi muutamassa minuutissa.",
    "step3_time": "AAMUIN JA ILLOIN • 30 SEK",
    "step3_title": "Tasoita juonteet tarkasti",
    "step3_desc": "Taputtele pieni määrä nimettömällä silmäkuopan luun ympärille silottamaan harakanvarpaita ja ilmejuonteita.",
    "step4_time": "PÄIVITTÄIN • 2 MINUUTTIA",
    "step4_title": "Gua Sha -kaulahieronta",
    "step4_desc": "Purista kevyesti tuubia ja liu'uta viilentävää kirurginteräspäätä ylöspäin solisluusta leukaa kohti. Vapauttaa lymfanestettä ja silottaa tech-neck-juonteita.",
    "step5_time": "MILLOIN VAIN • VIIMEISTELYYN & HEHKUUN",
    "step5_title": "Glass-Skin -hehkua mukaan",
    "step5_desc": "Sivele poskipäille, otsalle ja huulille. 5% Volufiline antaa välitöntä kosteutta ja korealaisen lasi-ihon heleän hehkun.",

    // Module 3: Gua Sha Technique
    "guasha_pill": "INTEGROITU GUA SHA -TYÖKALU • EI HELPOSTI SÄRKYVÄÄ JADEKIVEÄ",
    "guasha_title": "Oikea Gua Sha -tekniikka: Hiero kuin K-Beauty -ammattilaiset",
    "guasha_subtitle": "Monet välttelevät perinteisiä Gua Sha -kiviä, koska ne särkyvät helposti, niitä on hankala annostella tai väärällä tekniikalla venytetään ihoa. MediCube-annostelija ratkaisee tämän pysyvästi:",
    "guasha_d1_title": "1. Kaulan kohotus tech-neck-juonteita vastaan",
    "guasha_d1_desc": "Aseta ergonominen kaari solisluulle ja liu'uta tasaisella, kevyellä paineella ylös leukaan saakka. Älä koskaan vedä alaspäin!",
    "guasha_d2_title": "2. Leukalinjan & V-linjan muotoilu",
    "guasha_d2_desc": "Liu'uta muotoilulovea leuasta leukaluuta pitkin korvannipukan alapuolelle (3–5 vetoa per puoli).",
    "guasha_d3_title": "3. Dekoltee & lymfaattinen hieronta",
    "guasha_d3_desc": "Sivele rintalastalta ulospäin kohti kainaloita. Aktivoi lymfanesteen virtausta ja poistaa nestekertymiä.",
    "tool_f1": "✓ Kirurgista ruostumatonta terästä (Viilentävä & helppo desinfioida)",
    "tool_f2": "✓ Hygieeninen kääntölukitus (Ei vuotoja)",
    "tool_f3": "✓ Tarkka annostelu hieronnan aikana",
    "guasha_stat_val": "-34%",
    "guasha_stat_desc": "Vaakasuuntaisten kaulajuonteiden syvyys 14 päivän jälkeen",

    // Module 4: Science
    "science_pill": "DERMATOLOGINEN KLIININEN KOOSTUMUS",
    "science_title": "Kaksoisvaikutteinen tiede setin taustalla",
    "science_subtitle": "Siinä missä tavallinen ihonhoito kosteuttaa vain pintakerrosta, Youth-Lock -koostumus yhdistää soluja uudistavan biokemian ja fyysisen mikroverenkierron stimuloinnin.",
    "sci_p1_title": "PDRN (Lohi-DNA)",
    "sci_p1_role": "Solutason DNA-korjaus",
    "sci_p1_desc": "PDRN (polydeoksiribonukleotidi) jakaa 95-prosenttisesti identtisen DNA-emäsrakenteen ihmisen ihosolujen kanssa. Se stimuloi fibroblasteja, tehostaa syvää kollageenisynteesiä ja korjaa UV-säteilyn ja näyttöjen valon aiheuttamia soluvaurioita.",
    "sci_p2_title": "5% Volufiline™ (Ranska)",
    "sci_p2_role": "Luonnollinen täyteläistävä kudosvaikutus",
    "sci_p2_desc": "Patentoitu kasviperäinen lipidi (sarsasapogeniini) ranskalaiselta Sederma-laboratoriolta. Stimuloi rasvasolujen lipidien varastoitumista luoden näkyvän \"lipofilling-vaikutuksen\", joka täyttää juonteita ja kaulan uurteita luonnollisesti sisältäpäin.",
    "sci_p3_title": "Mekaaninen Gua Sha -lymfahieronta",
    "sci_p3_role": "Verisuoniston ja kudosten stimulointi",
    "sci_p3_desc": "Hellävaraiset ylöspäin suuntautuvat vedot parantavat paikallista mikroverenkiertoa jopa 400%. Poistaa pysähtynyttä lymfanestettä, vähentää turvotusta ja mahdollistaa tehoaineiden syvän imeytymisen.",

    // Module 5: Clinical Results
    "results_pill": "KLIINISESTI TESTATTU 34 OSALLISTUjALLA (4 VIIKKOA)",
    "results_title": "Mitattavia kliinisiä tuloksia, ei tyhjiä lupauksia",
    "results_subtitle": "Soulissa suoritetuissa riippumattomissa dermatologisissa käyttökokeissa näiden 5 tuotteen yhdistelmä osoitti merkittäviä parannuksia kaikissa keskeisissä ikääntymismittareissa:",
    "stat1_val": "98%",
    "stat1_title": "Napakampi leukalinja & V-muoto",
    "stat1_desc": "vahvisti leukalinjan näkyvän kiinteytymisen Tension Up Maskin ja Gua Sha -annostelijan säännöllisen käytön jälkeen.",
    "stat2_val": "96%",
    "stat2_title": "Sileämpi kaula & dekoltee",
    "stat2_desc": "havaitsi vaakasuorien kaulajuonteiden (\"Tech Neck\") selkeän vähenemisen ja huomasi ihon tuntuvan kimmoisammalta ja napakammalta.",
    "stat3_val": "100%",
    "stat3_title": "Välitön raikkaus & viilennys",
    "stat3_desc": "koki välitöntä helpotusta väsyneille ja turvonneille silmille heti ensimmäisestä Caffeine Eye Patches -käyttökerrasta alkaen.",

    // Module 6: FAQ
    "faq_pill": "USEIN KYSYTYT KYSYMYKSET",
    "faq_title": "Kaikki mitä sinun tarvitsee tietää 5-osaisesta setistä",
    "faq_q1": "Missä järjestyksessä tuotteita tulee käyttää?",
    "faq_a1": "Ihanteellinen rutiini noudattaa dermatologista periaatetta kevyimmästä koostumuksesta täyteläisimpään:<br><br><strong>1. Tension Up Mask:</strong> Käytä 2–3 kertaa viikossa puhtaalle iholle ja aseta korvalenkit (15 min).<br><strong>2. Caffeine Eye Patches:</strong> Aseta silmien alle 10 minuutiksi (ihanteellinen aamuisin laskemaan turvotusta).<br><strong>3. Peptide Eye Cream:</strong> Taputtele kevyesti silmänympärysluuaukon ympärille.<br><strong>4. Gua Sha Neck Wrinkle Cream:</strong> Hiero solisluusta ylöspäin kohti leukaa integroidulla hierontapäällä.<br><strong>5. Multi Balm Stick:</strong> Levitä hoitavana hehkuviimeistelynä poskipäille, otsajuonteille tai huulille (sopii erinomaisesti myös meikin päälle päivän aikana).",
    "faq_q2": "Tuoksuuko tuote kalalta, koska PDRN on peräisin lohesta?",
    "faq_a2": "<strong>Ei, ehdottomasti ei!</strong> Tehoaine on lääkelaatuista, erittäin puhdistettua natrium-DNA:ta, joka käy läpi monivaiheisen biokemiallisen suodatusprosessin, jossa poistetaan kaikki proteiinit, lipidit ja hajut. Tuotteissa on mieto, raikas ja miellyttävä tuoksu ilman minkäänlaista kalan hajua.",
    "faq_q3": "Voinko yhdistää tämän setin AGE-R Booster Prohon tai muihin kauneudenhoitolaitteisiin?",
    "faq_a3": "<strong>Kyllä, erittäin hyvin!</strong> PDRN ja Volufiline tarjoavat ihanteellisen, ravinteikkaan liukuvoiteen AGE-R Booster Prolle. Laitteen mikrovirta- (MC) ja Derma-Shot-tilat tehostavat peptidivoiteen ja kaulavoiteen imeytymistä entisestään.",
    "faq_q4": "Sopiiko setti herkälle tai epäpuhtauksiin taipuvaiselle iholle?",
    "faq_a4": "Kyllä. Kaikki koostumukset on dermatologisesti testattu herkällä iholla Etelä-Koreassa. Ne ovat ei-komedogeenisiä (eivät tuki huokosia), hypoallergeenisia eivätkä sisällä keinotekoisia parabeeneja tai voimakkaita sulfaatteja.",
    "faq_q5": "Kuinka pitkäksi aikaa 5-osainen setti riittää?",
    "faq_a5": "Päivittäisessä käytössä 90g Gua Sha -kaulavoide, 10g Multi Balm ja 30ml silmänympärysvoide kestävät noin <strong>6–8 viikkoa</strong>. Silmälappupurkki sisältää 60 lappua (30 päivittäistä hoitokertaa). Tension Up -pakkaus sisältää 4 intensiivistä V-linjan muotoilukangasnaamiota.",

    // Module 7: Sticky Bottom CTA
    "bottom_cta_tag": "RAJOITETTU TARJOUS • 75% ALENNUS",
    "bottom_cta_headline": "Oletko valmis kiinteimpään leukalinjaan & nuorekkaaseen hehkuun?",
    "bottom_cta_sub": "Hanki kaikki 5 K-Beauty -bestselleriä ylellisessä etupaketissa vain hintaan <strong>34,00 €</strong> (norm. 139,00 € OVH).",
    "bottom_cta_btn": "LISÄÄ OSTOSKORIIN — 34,00 €",
    "bottom_cta_guarantee": "🔒 30 päivän rahat takaisin -takuu",
    "bottom_cta_shipping": "⚡ Nopea DHL-toimitus (1-3 päivää)",

    // -------------------------------------------------------------
    // 4. CUSTOMER REVIEWS
    // -------------------------------------------------------------
    "rev_badge": "Vahvistetut kokemukset",
    "rev_title": "Asiakasarvostelut",
    "rev_subtitle": "Katso mitä vahvistetut asiakkaamme sanovat tuotteistamme",
    "rev_based_on": "Perustuu vahvistettuihin asiakasarvosteluihin",
    "rev_stars_5": "5 tähteä",
    "rev_stars_4": "4 tähteä",
    "rev_stars_3": "3 tähteä",
    "rev_stars_2": "2 tähteä",
    "rev_stars_1": "1 tähti",
    "rev_verified": "Vahvistettu",
    "rev_helpful": "Hyödyllinen",
    "rev_write": "Kirjoita arvostelu",

    // -------------------------------------------------------------
    // 5. CART DRAWER
    // -------------------------------------------------------------
    "cart_title": "Ostoskorisi",
    "cart_empty_title": "Ostoskorisi on tällä hetkellä tyhjä",
    "cart_progress_away": "Vain",
    "cart_progress_away_end": "päässä ilmaisesta DHL-toimituksesta!",
    "cart_progress_free": "🎉 Ilmainen DHL-toimitus saavutettu!",
    "cart_frequently_bought": "Ostetaan usein yhdessä",
    "cart_checkout_btn": "KASSALLE • TURVALLINEN MAKSU",
    "cart_guarantee": "Riskitön kokeilu: 30 päivän tyytyväisyystakuu kaikille tilauksille.",

    // -------------------------------------------------------------
    // 6. HOMEPAGE
    // -------------------------------------------------------------
    "hero_s1_title": "Booster Pro X2™\n7-in-1 Total Solution -laite",
    "hero_s1_sub": "Vapauta nuorekas hehkusi\n2x enemmän hehkua, kiinteyttä, muotoilua & ihohuokosten supistumista",
    "hero_s1_btn": "OSTA NYT",
    "hero_s2_title": "Herätä hehkusi\nyön aikana",
    "hero_s2_sub": "Kehitetty ravitsemaan ihoa intensiivisesti ja suojaamaan kimmoisuutta nukkuessasi.",
    "hero_s2_btn": "OSTA NYT",
    "hero_s3_title": "Virheetön, kristallinkirkas iho",
    "hero_s3_sub": "K-BEAUTY #1 HUOKOSTEN HOITOLAPUT\nYksinkertainen & tehokas hoito näkyvästi supistuneille ihohuokosille",
    "hero_s3_btn": "OSTA NYT",
    "hero_s4_title": "Täydellinen Glass Glow\nkoko päivän",
    "hero_s4_sub": "Räätälöity kollageeniduo säteilevälle, syväkosteutetulle ja nuorekkaalle iholle.",
    "hero_s4_btn": "OSTA NYT",
    "devices_fixed_l1": "Nyt trendeissä:",
    "devices_fixed_l2": "Korealainen ihonhoito",
    "devices_fixed_italic": "Laitteet",
    "devices_btn_all": "KATSO KAIKKI",
    "comm_heading": "AITOJA KOKEMUKSIA YHTEISÖLTÄMME",
    "skin_fixed_l1": "100% ihotautilääkärien",
    "skin_fixed_italic": "testaama.",
    "skin_fixed_l2": "Kliinisesti todistetut<br>K-Beauty -koostumukset.",
    "btn_shop_now": "OSTA NYT",
    "btn_view_all": "KATSO KAIKKI"
  };

  window.MC_TRANSLATIONS['da'] = {
    // -------------------------------------------------------------
    // 1. HEADER & NAVIGATION
    // -------------------------------------------------------------
    "announcement_text": "⚡ GRATIS DHL-LEVERING • 30 DAGES TILFREDSHEDSGARANTI ⚡",
    "nav_all_products": "Alle produkter",
    "nav_devices": "AGE-R Beauty Tech Enheder",
    "nav_skincare": "Hudpleje",
    "nav_skincare_lines": "Hudplejeserier",
    "nav_zero_line": "Zero Pore-serien (Porominimering & Sebum)",
    "nav_glass_glow": "Triple Collagen & Glow (Løft & Fasthed)",
    "nav_pink_pdrn": "Pink PDRN-serien (Barriere & Peptider)",
    "nav_super_cica": "Exosome Super Cica (Beroligende & Lindrende)",
    "nav_deep_line": "Deep Vitamin C (Anti-Aging & Glød)",
    "nav_red_line": "Red Acne-serien (Uren hud)",
    "nav_txa_line": "TXA & Kojisukker (Lysnende)",
    "nav_by_category": "Efter kategori",
    "nav_cleanser": "Renseprodukter & Cleansers",
    "nav_toner": "Tonere & Eksfolierende pads",
    "nav_serums": "Sera & Ampuller",
    "nav_creams": "Cremer & Fugtgivende pleje",
    "nav_masks": "Sheet-masker & Natindpakning",
    "nav_sun": "Solbeskyttelse (SPF)",
    "nav_sets": "Sæt & Fordelspakker",
    "nav_sets_sub": "Fordelssæt & Pakker",
    "nav_bestsellers": "Bestsellere",
    "nav_guide": "AGE-R Vejledning & Instruktioner",
    "nav_about": "Om os",
    "nav_help": "Hjælp & Kundeservice",
    "nav_account": "Min konto / Log ind",
    "search_placeholder": "Søg efter produkter, ingredienser, serier...",
    "region_title": "Region & Valuta",
    "region_sub": "Vælg dit leveringsland for lokal valuta og detaljer",
    "region_search": "Søg efter land eller valuta...",
    "language_label": "Sprog / Language:",

    // -------------------------------------------------------------
    // 2. MAIN PDP (ABOVE THE FOLD)
    // -------------------------------------------------------------
    "reviews_count_suffix": "anmeldelser",
    "badge_set_save": "🔥 5-DELT KOMPLET SÆT • SPAR 105 € (75% RABAT)",
    "badge_bestseller": "BESTSELLER",
    "badge_viral": "TIKTOK VIRAL",
    "save_75": "SPAR 75%",
    "save_24": "SPAR 24%",
    "save_31": "SPAR 31%",
    "science_badge_title": "Videnskabeligt dokumenteret",
    "science_badge_sub": "<strong>80+ fagfællebedømte studier</strong> understøtter vores formel.",
    "science_badge_link": "Se studier & lær mere",
    "klarna_installments_prefix": "Eller 3 rentefri rater på",
    "klarna_installments_suffix": "med Klarna",
    "klarna_learn_more": "Læs mere",
    "atc_btn_text": "LÆG I KURV",
    "atc_adding": "Tilføjer...",
    "atc_sold_out": "Udsolgt",
    "urgency_badge": "BEGRÆNSET DAGSTILBUD",
    "urgency_timer_label": "Tilbuddet udløber om:",
    "urgency_copy": "⚡ <strong>Gælder kun i dag:</strong> Op til <strong>31% rabat + op til 2 GRATIS flasker</strong> i vores fordelspakke. Stor efterspørgsel – dagens forsendelsesparti er næsten udsolgt.",
    "free_shipping_unlocked": "Gratis DHL-levering opnået",
    "choose_routine": "Vælg din rutine:",
    "bestseller_pick": "🔥 87% vælger Bestseller-sættet",
    "body_peel_title": "1x Body Peel",
    "body_peel_sub": "280ml • Skånsom kropseksfoliering",
    "face_peel_title": "1x Face Peel",
    "face_peel_sub": "50ml • Rensende ansigtsserum",
    "duo_set_title": "Duo-sæt (Krop + Ansigt)",
    "duo_free_tag": "+ 1 GRATIS",
    "duo_meta": "19,00 € / produkt • 330ml rutine",
    "double_duo_title": "2x Body Peel Dobbeltpakke",
    "double_free_tag": "+ 2 GRATIS",
    "double_meta": "34,50 € / flaske • 560ml forsyning",
    "most_popular": "🔥 Mest populær",
    "best_value": "💎 Bedste værdi",
    "save_label": "Spar",
    "gifts_header": "DINE GRATIS GAVER MED ORDREN",
    "gift_free_shipping": "Gratis levering",
    "gift_free": "GRATIS",
    "gift_1_bottle": "1x GRATIS flaske",
    "gift_2_bottles": "2x GRATIS flasker",
    "gift_unlock_2x": "🔒 Låses op ved 2x forsyning",
    "sub_save_title": "Abonnér & spar (30% rabat)",
    "sub_save_meta": "30% fast rabat på hver efterfølgende levering. Opsig når som helst med 1 klik.",
    "sub_tooltip_title": "Fuld fleksibilitet med abonnement:",
    "sub_tooltip_body": "Få automatisk 30% rabat på din første og alle efterfølgende ordrer. Vælg leveringsinterval, sæt på pause eller spring over på din kundekonto, eller opsig når som helst med ét klik. Ingen bindingsperiode, ingen skjulte gebyrer.",
    "sub_perk_free_ship": "Gratis levering på alle ordrer",
    "sub_perk_discount": "30% rabat på enhver genbestilling",
    "sub_perk_cancel": "Sæt på pause, tilpas eller opsig når som helst med 1 klik",
    "size_variant_label": "Størrelse / Variant:",
    "value_pack_tag": "FORDELSPAKKE",
    "preview_bundle_title": "Indeholdt i det 5-delte fordelssæt:",
    "upsell_title": "Købes ofte sammen",
    "upsell_sub": "Hudlægeanbefalede rutinetilføjelser for maksimale resultater:",
    "btn_add": "+ Tilføj",
    "btn_added": "Tilføjet",
    "trust_fast_ship": "<strong>Hurtig levering:</strong> 1-3 hverdage med DHL",
    "trust_kbeauty": "<strong>100% Ægte K-Beauty:</strong> Direkte fra autoriseret producent",
    "trust_guarantee": "<strong>30 dages tilfredshedsgaranti:</strong> Prøv helt risikofrit",
    "guarantee_title": "30 dages pengene-tilbage-garanti",
    "guarantee_sub": "Prøv risikofrit i 30 dage. Ikke tilfreds? Fuld refusion – uden spørgsmål.",
    "guarantee_learn_more": "Læs mere ›",
    "cross_sell_heading": "Passer perfekt sammen med",
    "schema_skin_type": "Hudtype",
    "schema_hair_type": "Hårtype",
    "schema_skin_concerns": "Hudtilstande",
    "schema_hair_concerns": "Plejebehov",
    "schema_key_actives": "Vigtigste aktive ingredienser",

    // Concise Value Bullets (Youth Lock)
    "yl_bullet_1": "<strong>5-i-1 Komplet system:</strong> Alle 5 K-Beauty bestsellere til hals, kæbelinje og øjenomgivelser i én boks",
    "yl_bullet_2": "<strong>PDRN (Lakse-DNA) + 5% Volufiline:</strong> Stimulerer kollagensyntesen og udfylder fine linjer naturligt",
    "yl_bullet_3": "<strong>Integreret Gua Sha massagehoved:</strong> Ergonomisk kirurgisk stålhoved til daglig V-linje lymfedrænage",
    "yl_bullet_4": "<strong>Spar 105 € med det samme:</strong> 139,00 € separat værdi i dag til kun 34,00 € inkl. DHL Express levering",

    // PDP Tabs / Accordions
    "tab_benefits": "Fordele & Virkning",
    "tab_clinicals": "Kliniske studier & Resultater",
    "tab_ingredients": "Ren formel & Ingredienser",
    "tab_usage": "Anvendelse & Rutinetrin",
    "tab_faq": "Ofte stillede spørgsmål (FAQ)",
    "tab_sub_perks": "Abonnementsfordele (30% rabat)",

    // -------------------------------------------------------------
    // 3. YOUTH-LOCK BUNDLE SUITE (MODULES 1-7)
    // -------------------------------------------------------------
    "yl_badge_top": "139,00 € SAMLET VÆRDI • I DAG KUN 34,00 €",
    "yl_title": "Hvad indeholder det 5-delte komplette sæt?",
    "yl_subtitle": "Fem synergistisk udviklede K-Beauty innovationer med højren <strong>PDRN (Lakse-DNA)</strong>, <strong>5% Volufiline</strong> og et integreret <strong>Gua Sha massagehoved</strong> til din daglige anti-aging & V-løft kontureringsrutine.",

    // Product 1
    "p1_badge": "HERO-PRODUKTET",
    "p1_step": "TRIN 4",
    "p1_cat": "HALS & DEKOLLETÉ LØFT",
    "p1_name": "PDRN Gua Sha Neck Wrinkle Cream",
    "p1_spec": "90g tube med integreret Gua Sha kirurgisk stålhoved",
    "p1_desc": "Koreas gennembrud mod \"Tech Neck\" og slap halshud. Kæmper med <strong>højren lakse-PDRN</strong>, <strong>5% fransk Volufiline</strong> og et ergonomisk kirurgisk stålmassagehoved for at stimulere dyb kollagendannelse og opstramme slap hud med det samme.",

    // Product 2
    "p2_step": "TRIN 1",
    "p2_cat": "KÆBELINJE & DOBBELTHAGE",
    "p2_name": "Collagen V-Line Tension Up Lifting Mask",
    "p2_spec": "4x hydrogel-indpakningsmasker med øreløkker",
    "p2_desc": "Specialiseret kompressionsmaske med øreløkker, der strammer og løfter kæbelinjen fysisk. Hydrogel-matrixen frigiver hydrolyseret kollagen og koffein direkte til underhuden for en skarp, defineret V-linje.",

    // Product 3
    "p3_step": "TRIN 2",
    "p3_cat": "MOD HÆVEDE ØJNE & GLØD",
    "p3_name": "PDRN Caffeine Brightening Eye Patches",
    "p3_spec": "60 kølende hydrogel øjenpatches (30 dages behandling)",
    "p3_desc": "Intensiv øjenbehandling med koffein og lakse-PDRN. Reducerer synligt morgenhævelser, mørke rande og træthedstegn på kun 10 minutter.",

    // Product 4
    "p4_step": "TRIN 3",
    "p4_cat": "MÅLRETTET ØJENPLEJE",
    "p4_name": "PDRN Peptide Wrinkle Care Eye Cream",
    "p4_spec": "30ml præcisionstube mod fine linjer",
    "p4_desc": "Koncentreret peptid- og PDRN-øjencreme. Glatter smilerynker og fine linjer uden at tynge eller fedte den sarte hud omkring øjnene.",

    // Product 5
    "p5_step": "TRIN 5",
    "p5_cat": "ØJEBLIKKELIG GLØD & LÆBER",
    "p5_name": "PDRN Collagen Multi Balm Stick",
    "p5_spec": "10g praktisk stift til tasken",
    "p5_desc": "Viral koreansk multi-balm med <strong>5% Volufiline</strong>. Udfylder panderynker og fine linjer øjeblikkeligt og efterlader huden med en krystalklar koreansk \"glass skin\" fugtglød.",

    // Calculation Banner
    "calc_tag": "GENNEMSKUELIG PRISFORDEL",
    "calc_strike": "139,00 € VEJL.",
    "calc_deal": "34,00 € KOMPLET SÆT",
    "calc_note": "Du sparer <strong>105,00 € (75% rabat)</strong> i forhold til at købe produkterne enkeltvis. Inkluderer gratis DHL Express levering.",
    "calc_btn": "SIKR DIG DIT SÆT NU",

    // Module 2: Timeline
    "routine_pill": "HURTIGT & NEMT • KUN 5 MINUTTER OM DAGEN",
    "routine_title": "Din daglige 5-trins Youth-Lock rutine",
    "routine_subtitle": "Ingen komplicerede 12-trins ritualer. Udviklet af koreanske hudlæger til at sikre maksimal V-linje løft og fasthed på under 5 minutter om dagen.",
    "step1_time": "2–3x / UGE • 15 MIN",
    "step1_title": "Påfør V-Line maske",
    "step1_desc": "Placér masken under hagen og fastgør øreløkkerne. Løfter vævet og opstrammer kæbelinjen.",
    "step2_time": "DAGLIGT MORGEN • 10 MIN",
    "step2_title": "Dæmp hævelser omkring øjnene",
    "step2_desc": "Placér to kølende hydrogel patches under øjnene. Koffein reducerer morgenhævelser synligt på få minutter.",
    "step3_time": "MORGEN & AFTEN • 30 SEK",
    "step3_title": "Udjævn fine linjer præcist",
    "step3_desc": "Dup forsigtigt en lille mængde langs øjenomgivelserne med ringfingeren for at udglatte smilerynker.",
    "step4_time": "DAGLIGT • 2 MINUTTER",
    "step4_title": "Gua Sha halsmassage",
    "step4_desc": "Tryk let på tuben og før det kølende kirurgiske stålhoved opad fra kravebenet mod hagen for lymfedrænage.",
    "step5_time": "NÅR SOM HELST • FINISH & GLØD",
    "step5_title": "Glass-Skin glød på farten",
    "step5_desc": "Stryg over kindben, pande og læber. 5% Volufiline tilfører øjeblikkelig fugt og en strålende koreansk glass skin-glød.",

    // Module 3: Gua Sha Technique
    "guasha_pill": "INTEGRERET GUA SHA VÆRKTØJ • INGEN SKØR JADESTEN",
    "guasha_title": "Den korrekte Gua Sha teknik: Massér som K-Beauty eksperterne",
    "guasha_subtitle": "Mange undgår traditionelle Gua Sha sten, fordi de nemt går i stykker, er besværlige at dosere eller kan overstrække huden. MediCube-dispenseren løser dette én gang for alle:",
    "guasha_d1_title": "1. Halsløft mod Tech-Neck",
    "guasha_d1_desc": "Placér den ergonomiske bue på kravebenet og før den opad mod hagen med et blidt, jævnt tryk. Træk aldrig nedad!",
    "guasha_d2_title": "2. Kæbelinje & V-linje definition",
    "guasha_d2_desc": "Før konturudskæringen fra hagen langs kæbeknoglen op mod øreflippen (3–5 strøg pr. side).",
    "guasha_d3_title": "3. Dekolleté & lymfatisk drænage",
    "guasha_d3_desc": "Stryg fra brystbenet udad mod armhulerne. Aktiverer lymfestrømmen og reducerer væskeophobninger.",
    "tool_f1": "✓ Kirurgisk rustfrit stål (Kølende & hygiejnisk)",
    "tool_f2": "✓ Hygiejnisk drejelås (Ingen lækager)",
    "tool_f3": "✓ Præcis dosering under massagen",
    "guasha_stat_val": "-34%",
    "guasha_stat_desc": "Dybde af tværgående halsrynker efter 14 dage",

    // Module 4: Science
    "science_pill": "DERMATOLOGISK KLINISK FORMEL",
    "science_title": "Den dobbelte videnskab bag sættet",
    "science_subtitle": "Hvor almindelig hudpleje kun fugter overfladen, kombinerer Youth-Lock formlen cellefornyende biokemi med fysisk mikrocirkulationsstimulering.",
    "sci_p1_title": "PDRN (Lakse-DNA)",
    "sci_p1_role": "Cellulær DNA-reparation",
    "sci_p1_desc": "PDRN (polydeoxyribonukleotid) deler 95% identisk DNA-basestruktur med menneskelige hudceller. Det stimulerer fibroblaster, fremmer dyb kollagensyntese og reparerer cellulære skader forårsaget af UV-stråling og skærmlys.",
    "sci_p2_title": "5% Volufiline™ (Frankrig)",
    "sci_p2_role": "Naturlig volumenopbyggende vævseffekt",
    "sci_p2_desc": "Et patenteret plantebaseret lipid (sarsasapogenin) fra det franske laboratorie Sederma. Stimulerer fedtcellernes lipidlagring og skaber en synlig \"lipofilling-effekt\", der udfylder rynker og halsfurer indefra helt naturligt.",
    "sci_p3_title": "Mekanisk Gua Sha lymfedrænage",
    "sci_p3_role": "Stimulering af mikrocirkulation & væv",
    "sci_p3_desc": "Blide opadgående strøg forbedrer den lokale mikrocirkulation med op til 400%. Fjerner ophobet lymfevæske, dæmper hævelser og sikrer dyb absorption af de aktive stoffer.",

    // Module 5: Clinical Results
    "results_pill": "KLINISK TESTET PÅ 34 DELTAGERE (4 UGER)",
    "results_title": "Målbare kliniske resultater, ikke tomme løfter",
    "results_subtitle": "I uafhængige dermatologiske forsøg udført i Seoul viste kombinationen af disse 5 produkter markante forbedringer på tværs af alle centrale aldringsindikatorer:",
    "stat1_val": "98%",
    "stat1_title": "Mere defineret kæbelinje & V-form",
    "stat1_desc": "bekræftede en synligt opstrammet kæbelinje efter regelmæssig brug af Tension Up Mask og Gua Sha dispenseren.",
    "stat2_val": "96%",
    "stat2_title": "Glatte hals- & dekolletélinjer",
    "stat2_desc": "oplevede en markant reduktion i vandrette halsrynker (\"Tech Neck\") og mere spændstig, elastisk hud.",
    "stat3_val": "100%",
    "stat3_title": "Øjeblikkelig friskhed & køling",
    "stat3_desc": "oplevede øjeblikkelig lindring af trætte og hævede øjne allerede fra første brug af Caffeine Eye Patches.",

    // Module 6: FAQ
    "faq_pill": "OFTE STILLEDE SPØRGSMÅL",
    "faq_title": "Alt hvad du behøver at vide om det 5-delte sæt",
    "faq_q1": "I hvilken rækkefølge skal produkterne anvendes?",
    "faq_a1": "Den optimale rutine følger det dermatologiske princip fra letteste til rigeste tekstur:<br><br><strong>1. Tension Up Mask:</strong> Anvendes 2–3 gange om ugen på ren hud og fastgøres bag ørerne (15 min).<br><strong>2. Caffeine Eye Patches:</strong> Påføres under øjnene i 10 minutter (ideelt om morgenen mod hævelser).<br><strong>3. Peptide Eye Cream:</strong> Dup forsigtigt omkring øjenomgivelserne.<br><strong>4. Gua Sha Neck Wrinkle Cream:</strong> Massér opad fra kravebenet mod hagen med det integrerede massagehoved.<br><strong>5. Multi Balm Stick:</strong> Stryg over kindben, pandelinjer eller læber for nærende fugt og glød (også perfekt ovenpå makeup i løbet af dagen).",
    "faq_q2": "Lugter produktet af fisk, da PDRN stammer fra laks?",
    "faq_a2": "<strong>Nej, overhovedet ikke!</strong> Den aktive ingrediens er farmaceutisk renset natrium-DNA, der gennemgår en avanceret biokemisk filtreringsproces, hvor alle proteiner, lipider og lugte fjernes fuldstændigt. Produkterne har en mild, frisk og behagelig duft uden spor af fiskelugt.",
    "faq_q3": "Kan jeg kombinere dette sæt med AGE-R Booster Pro eller andre skønhedsapparater?",
    "faq_a3": "<strong>Ja, helt sikkert!</strong> PDRN og Volufiline udgør en ideel, nærende glidebase til AGE-R Booster Pro. Apparatets mikrostrøm (MC) og Derma-Shot tilstande forstærker absorptionen af peptid- og halscremen yderligere.",
    "faq_q4": "Er sættet velegnet til følsom eller uren hud?",
    "faq_a4": "Ja. Alle formler er dermatologisk testet på sart hud i Sydkorea. De er non-comedogene (tilstopper ikke porerne), allergivenlige og fri for syntetiske parabener og skrappe sulfater.",
    "faq_q5": "Hvor længe rækker det 5-delte sæt?",
    "faq_a5": "Ved daglig brug holder 90g Gua Sha halscreme, 10g Multi Balm og 30ml øjencreme i cirka <strong>6–8 uger</strong>. Øjenpatch-krukken indeholder 60 patches (30 daglige behandlinger). Tension Up pakken indeholder 4 intensive V-Line formende masker.",

    // Module 7: Sticky Bottom CTA
    "bottom_cta_tag": "BEGRÆNSET TILBUD • SPAR 75%",
    "bottom_cta_headline": "Er du klar til din mest definerede kæbelinje og ungdommelige glød?",
    "bottom_cta_sub": "Få alle 5 K-Beauty bestsellere i en eksklusiv fordelspakke til kun <strong>34,00 €</strong> (vejl. pris 139,00 €).",
    "bottom_cta_btn": "LÆG I KURV — 34,00 €",
    "bottom_cta_guarantee": "🔒 30 dages pengene-tilbage-garanti",
    "bottom_cta_shipping": "⚡ Hurtig DHL-levering (1-3 hverdage)",

    // -------------------------------------------------------------
    // 4. CUSTOMER REVIEWS
    // -------------------------------------------------------------
    "rev_badge": "Verificerede oplevelser",
    "rev_title": "Kundeanmeldelser",
    "rev_subtitle": "Se hvad vores verificerede kunder siger om produkterne",
    "rev_based_on": "Baseret på verificerede kundeanmeldelser",
    "rev_stars_5": "5 stjerner",
    "rev_stars_4": "4 stjerner",
    "rev_stars_3": "3 stjerner",
    "rev_stars_2": "2 stjerner",
    "rev_stars_1": "1 stjerne",
    "rev_verified": "Verificeret",
    "rev_helpful": "Nyttig",
    "rev_write": "Skriv en anmeldelse",

    // -------------------------------------------------------------
    // 5. CART DRAWER
    // -------------------------------------------------------------
    "cart_title": "Din indkøbskurv",
    "cart_empty_title": "Din indkøbskurv er tom i øjeblikket",
    "cart_progress_away": "Kun",
    "cart_progress_away_end": "fra gratis DHL-levering!",
    "cart_progress_free": "🎉 Gratis DHL-levering opnået!",
    "cart_frequently_bought": "Købes ofte sammen",
    "cart_checkout_btn": "GÅ TIL KASSEN • SIKKER BETALING",
    "cart_guarantee": "Risikofri prøveperiode: 30 dages tilfredshedsgaranti på alle ordrer.",

    // -------------------------------------------------------------
    // 6. HOMEPAGE
    // -------------------------------------------------------------
    "hero_s1_title": "Booster Pro X2™\n7-i-1 Total Solution Enhed",
    "hero_s1_sub": "Udløs din ungdommelige glød\n2x mere glød, fasthed, konturering og porominimering",
    "hero_s1_btn": "KØB NU",
    "hero_s2_title": "Væk din glød\ni løbet af natten",
    "hero_s2_sub": "Udviklet til at nære huden intensivt og bevare elasticiteten, mens du sover.",
    "hero_s2_btn": "KØB NU",
    "hero_s3_title": "Fejlfri, krystalklar hud",
    "hero_s3_sub": "K-BEAUTY #1 POREPLEJEPADS\nEnkel og effektiv pleje til synligt minimerede porer",
    "hero_s3_btn": "KØB NU",
    "hero_s4_title": "Perfekt Glass Glow\nhele dagen",
    "hero_s4_sub": "Skræddersyet kollagenduo til strålende, dybdefugtet og ungdommelig hud.",
    "hero_s4_btn": "KØB NU",
    "devices_fixed_l1": "Trender lige nu:",
    "devices_fixed_l2": "Koreansk hudpleje",
    "devices_fixed_italic": "Enheder",
    "devices_btn_all": "SE ALLE",
    "comm_heading": "ÆGTE OPLEVELSER FRA VORES FÆLLESSKAB",
    "skin_fixed_l1": "100% testet af",
    "skin_fixed_italic": "hudlæger.",
    "skin_fixed_l2": "Klinisk dokumenterede<br>K-Beauty formler.",
    "btn_shop_now": "KØB NU",
    "btn_view_all": "SE ALLE"
  };
window.MC_TRANSLATIONS = window.MC_TRANSLATIONS || {};
window.MC_TRANSLATIONS['sv'] = {
    "announcement_text": "⚡ FRI DHL-FRAKT • 30 DAGARS NÖJDHETSGARANTI ⚡",
    "nav_all_products": "Alla produkter",
    "nav_devices": "AGE-R Skönhetsteknologi",
    "nav_skincare": "Hudvård",
    "nav_skincare_lines": "Hudvårdslinjer",
    "nav_zero_line": "Zero Pore-linjen (Porminimering & Sebum)",
    "nav_glass_glow": "Triple Collagen & Glow (Lyft & Fasthet)",
    "nav_pink_pdrn": "Pink PDRN-linjen (Barriär & Peptider)",
    "nav_super_cica": "Exosome Super Cica (Lugnande & Lindrande)",
    "nav_deep_line": "Deep Vitamin C (Anti-Aging & Lyster)",
    "nav_red_line": "Red Acne-linjen (Finnvård & Orenheter)",
    "nav_txa_line": "TXA & Kojicsyra (Uppljusande)",
    "nav_by_category": "Efter kategori",
    "nav_cleanser": "Rengöringsprodukter & Cleansers",
    "nav_toner": "Ansiktsvatten & Exfolierande pads",
    "nav_serums": "Serum & Ampuller",
    "nav_creams": "Krämer & Återfuktande vård",
    "nav_masks": "Sheet masks & Nattinpackning",
    "nav_sun": "Solskydd (SPF)",
    "nav_sets": "Paket & Fördelserbjudanden",
    "nav_sets_sub": "Fördelspaket & Duos",
    "nav_bestsellers": "Bästsäljare",
    "nav_guide": "AGE-R Guide & Instruktioner",
    "nav_about": "Om oss",
    "nav_help": "Hjälp & Kundservice",
    "nav_account": "Mitt konto / Logga in",
    "search_placeholder": "Sök efter produkter, ingredienser, linjer...",
    "region_title": "Land & Språk",
    "region_sub": "Välj ditt leveransland och önskat språk",
    "region_search": "Sök land eller valuta...",
    "language_label": "Språk / Language:",
    "reviews_count_suffix": "recensioner",
    "badge_set_save": "🔥 5-DELAT KOMPLETT SYSTEM • SPARA 105 € (75% RABATT)",
    "badge_bestseller": "BÄSTSÄLJARE",
    "badge_viral": "TIKTOK VIRAL",
    "save_75": "SPARA 75%",
    "save_24": "SPARA 24%",
    "save_31": "SPARA 31%",
    "science_badge_title": "Vetenskapligt dokumenterat",
    "science_badge_sub": "<strong>80+ peer-reviewed studier</strong> stödjer vår formula.",
    "science_badge_link": "Se studier och läs mer",
    "klarna_installments_prefix": "Eller 3 räntefria delbetalningar på",
    "klarna_installments_suffix": "med Klarna",
    "klarna_learn_more": "Läs mer",
    "atc_btn_text": "LÄGG I VARUKORGEN",
    "atc_adding": "Lägger till...",
    "atc_sold_out": "Slutsåld",
    "urgency_badge": "BEGRÄNSAT DAGSERBJUDANDE",
    "urgency_timer_label": "Erbjudandet slutar om:",
    "urgency_copy": "⚡ <strong>Gäller endast idag:</strong> Upp till <strong>31% rabatt + upp till 2 GRATIS flaskor</strong> i vårt fördelspaket. Hög efterfrågan – dagens lager är nästan slutsålt.",
    "free_shipping_unlocked": "Gratis DHL-frakt uppnådd",
    "choose_routine": "Välj din rutin:",
    "bestseller_pick": "🔥 87% väljer Bästsäljar-paketet",
    "body_peel_title": "1x Body Peel",
    "body_peel_sub": "280ml • Skonsam kroppspeeling",
    "face_peel_title": "1x Face Peel",
    "face_peel_sub": "50ml • Rengörande ansiktsserum",
    "duo_set_title": "Duo-paket (Kropp + Ansikte)",
    "duo_free_tag": "+ 1 GRATIS",
    "duo_meta": "19,00 € / produkt • 330ml rutin",
    "double_duo_title": "2x Body Peel Dubbelpaket",
    "double_free_tag": "+ 2 GRATIS",
    "double_meta": "34,50 € / flaska • 560ml förråd",
    "most_popular": "🔥 Mest populär",
    "best_value": "💎 Bästa värde",
    "save_label": "Spara",
    "gifts_header": "DINA GRATIS GÅVOR MED BESTÄLLNINGEN",
    "gift_free_shipping": "Fri frakt",
    "gift_free": "GRATIS",
    "gift_1_bottle": "1x GRATIS Flaska",
    "gift_2_bottles": "2x GRATIS Flaskor",
    "gift_unlock_2x": "🔒 Låses upp med 2x Förråd",
    "sub_save_title": "Prenumerera & Spara (30% Rabatt)",
    "sub_save_meta": "30% återkommande rabatt på varje automatisk leverans. Avsluta när som helst med 1 klick.",
    "sub_tooltip_title": "Full flexibilitet med prenumeration:",
    "sub_tooltip_body": "Få automatiskt 30% rabatt på din första och alla framtida leveranser. Välj leveransintervall, pausa eller hoppa över leveranser i kundkontot, eller avsluta när som helst med 1 klick. Ingen bindningstid, inga dolda avgifter.",
    "sub_perk_free_ship": "Fri frakt på alla beställningar",
    "sub_perk_discount": "30% rabatt på varje efterföljande beställning",
    "sub_perk_cancel": "Pausa, ändra eller avsluta när som helst med 1 klick",
    "size_variant_label": "Storlek / Variant:",
    "value_pack_tag": "FÖRDELSPAKET",
    "preview_bundle_title": "Ingår i det 5-delade fördelspaketet:",
    "upsell_title": "Köps ofta tillsammans",
    "upsell_sub": "Dermatologiskt rekommenderade rutintillägg för maximala resultat:",
    "btn_add": "+ Lägg till",
    "btn_added": "Tillagd",
    "trust_fast_ship": "<strong>Snabb leverans:</strong> 1-3 vardagar med DHL",
    "trust_kbeauty": "<strong>100% Äkta K-Beauty:</strong> Direkt från auktoriserad tillverkare",
    "trust_guarantee": "<strong>30 dagars nöjdhetsgaranti:</strong> Riskfri provperiod",
    "guarantee_title": "30 dagars pengarna-tillbaka-garanti",
    "guarantee_sub": "Prova riskfritt i 30 dagar. Inte nöjd? Full återbetalning – inga frågor ställs.",
    "guarantee_learn_more": "Läs mer ›",
    "cross_sell_heading": "Passar perfekt till din rutin:",
    "schema_skin_type": "Alla hudtyper, inklusive känslig hud",
    "schema_hair_type": "Kropp & Ansikte",
    "schema_skin_concerns": "Orenheter, knottrig hud (keratosis pilaris), ojämn hudton, rodnad",
    "schema_hair_concerns": "Döda hudceller, tilltäppta porer",
    "schema_key_actives": "Underklorsyra (Hypochlorous Acid), Risextrakt (Oryza Sativa), Cica-komplex",
    "yl_bullet_1": "<strong>5-i-1 Komplett system:</strong> Alla 5 K-Beauty bästsäljare för hals, käklinje och ögonområde i en låda",
    "yl_bullet_2": "<strong>PDRN (Lax-DNA) + 5% Volufiline:</strong> Stimulerar kollagensyntesen och fyller ut fina linjer naturligt",
    "yl_bullet_3": "<strong>Integrerat Gua Sha massagehuvud:</strong> Ergonomiskt kirurgiskt stålhuvud för daglig V-linje lymfdränage",
    "yl_bullet_4": "<strong>Spara 105 € direkt:</strong> 139,00 € separat värde idag för endast 34,00 € inkl. DHL Express-frakt",
    "tab_benefits": "Fördelar",
    "tab_clinicals": "Kliniska resultat",
    "tab_ingredients": "Ingredienser",
    "tab_usage": "Användning",
    "tab_faq": "Vanliga frågor",
    "tab_sub_perks": "Prenumerationsfördelar",
    "yl_badge_top": "KLINISKT ANTI-AGING GENOMBROTT",
    "yl_title": "Youth-Lock 5-delat Komplett System",
    "yl_subtitle": "Designat för att lyfta slapp hals, definiera käklinjen och släta ut kråksparkar – helt utan kirurgi.",
    "p1_badge": "STEG 1: RENGÖRING & FÖRBEREDELSE",
    "p1_step": "01",
    "p1_cat": "FÖRBEREDANDE RENGÖRING",
    "p1_name": "Collagen Peptide Gentle Cleanser",
    "p1_spec": "120ml • pH 5.5 Balanserad",
    "p1_desc": "Skonsam rengöringsemulsion som rengör porer på djupet utan att torka ut huden. Förbereder huden optimalt för efterföljande aktiva ämnen.",
    "p2_badge": "STEG 2: VOLYM & LYFT",
    "p2_step": "02",
    "p2_cat": "VOLUMISERANDE SERUM",
    "p2_name": "Volufiline 5% Plumping Ampoule",
    "p2_spec": "30ml • Patenterad Volufiline™",
    "p2_desc": "Kliniskt bevisat franskt aktivt ämne som stimulerar lipidlagringen i vävnaden och återställer förlorad volym i kinder och hals.",
    "p3_badge": "STEG 3: LYMFDRÄNAGE & KÄKLINJE",
    "p3_step": "03",
    "p3_cat": "KÄKLINJE & HALS",
    "p3_name": "PDRN Gua Sha Lifting Roller Serum",
    "p3_spec": "50ml • Inbyggt metallhuvud",
    "p3_desc": "Kombinerar medicinskt rent lax-DNA med ett ergonomiskt kylande Gua Sha-rullhuvud för intensiv lymfdränage och V-linjekontur.",
    "p4_badge": "STEG 4: ÖGONOMRÅDE & FINA LINJER",
    "p4_step": "04",
    "p4_cat": "ÖGONVÅRD",
    "p4_name": "Triple Retinol Eye Tightening Cream",
    "p4_spec": "20ml • Inkapslad Retinol",
    "p4_desc": "Tre former av stabiliserad retinol och koffein minskar mörka ringar, svullnad och kråksparkar utan att irritera det känsliga ögonområdet.",
    "p5_badge": "STEG 5: FUKTLÅS & BARRIÄR",
    "p5_step": "05",
    "p5_cat": "NATTINPACKNING",
    "p5_name": "Collagen Night Wrapping Mask",
    "p5_spec": "75ml • Ocklusiv membranfilm",
    "p5_desc": "Bildar en ventilerande kollagenfilm över natten som låser in alla applicerade aktiva ämnen och ger en slående glass-skin lyster på morgonen.",
    "calc_tag": "EXKLUSIVT SPARPAKET",
    "calc_strike": "139,00 € separat värde",
    "calc_deal": "Idag endast 34,00 €",
    "calc_note": "Du sparar över 75% (105,00 €) jämfört med separat köp.",
    "calc_btn": "HÄMTA ALLA 5 FÖR 34,00 €",
    "routine_pill": "DAGLIG RUTIN",
    "routine_title": "Din 3-minuters morgon- & kvällsrutin",
    "routine_subtitle": "Enkla steg för maximala kliniska resultat hemma.",
    "step1_time": "Morgon & Kväll • 30 sek",
    "step1_title": "Rengör & Förbered",
    "step1_desc": "Fukta ansiktet med ljummet vatten och massera försiktigt in Cleanser med cirkulära rörelser. Skölj noggrant.",
    "step2_time": "Morgon & Kväll • 45 sek",
    "step2_title": "Volufiline Ampull",
    "step2_desc": "Applicera 3-4 droppar på kinder, panna och hals. Klappa försiktigt in tills formulan har absorberats helt.",
    "step3_time": "Kväll • 60 sek",
    "step3_title": "Gua Sha Roller V-Linje",
    "step3_desc": "Rulla Gua Sha-huvudet med lätt tryck från hakan uppåt längs käklinjen mot öronen och ner längs halsen.",
    "step4_time": "Morgon & Kväll • 30 sek",
    "step4_title": "Ögonkräm mot rynkor",
    "step4_desc": "Dutta en ärtstor mängd runt ögonbenet och klappa varsamt in med ringfingret.",
    "step5_time": "Endast Kväll • 30 sek",
    "step5_title": "Collagen Wrapping Mask",
    "step5_desc": "Applicera ett jämnt lager som sista steg på kvällen. Låt verka över natten och dra av eller skölj på morgonen.",
    "guasha_pill": "INNOVATIV TEKNOLOGI",
    "guasha_title": "Det integrerade kirurgiska Gua Sha-huvudet",
    "guasha_subtitle": "Varför professionell lymfmassage gör hela skillnaden för din käklinje.",
    "guasha_d1_title": "Ergonomisk V-kontur",
    "guasha_d1_desc": "Utformad för att passa ansiktets naturliga benstruktur och käklinje perfekt.",
    "guasha_d2_title": "Kylande kirurgiskt stål",
    "guasha_d2_desc": "Medicinskt rostfritt stål svalkar huden omedelbart, minskar morgonsvullnad och stramar upp huden.",
    "guasha_d3_title": "Djupare absorption av PDRN",
    "guasha_d3_desc": "Rullrörelsen pressar lax-DNA djupt in i hudens dermala lager för maximal effekt.",
    "tool_f1": "Hypoallergent medicinskt stål",
    "tool_f2": "360° Rulltrycksteknik",
    "tool_f3": "Enkel rengöring med vatten",
    "guasha_stat_val": "+340%",
    "guasha_stat_desc": "ökad upptagning av aktiva ämnen jämfört med manuell applicering.",
    "science_pill": "BIO-TEKNOLOGI",
    "science_title": "Kliniskt bevisade nyckelingredienser",
    "science_subtitle": "Inga utfyllnadsämnen. Endast högkoncentrerade, verksamma substanser med bevisad effekt.",
    "sci_p1_title": "Lax-DNA (PDRN)",
    "sci_p1_role": "Cellulär regenerering & Kollagenuppbyggnad",
    "sci_p1_desc": "PDRN matchar mänskligt DNA till 95% och stimulerar fibroblaster att producera nytt kollagen och elastin.",
    "sci_p2_title": "Volufiline™ (5%)",
    "sci_p2_role": "Naturlig volym & Fyllighet",
    "sci_p2_desc": "Patenterat extrakt från Anemarrhena Asphodeloides som ökar fettvävnadens volym och fyller ut ihåliga partier.",
    "sci_p3_title": "Triple Retinol Komplex",
    "sci_p3_role": "Cellförnyelse & Rynkreduktion",
    "sci_p3_desc": "Tre former av inkapslad retinol för maximal effekt med minimal irritation – perfekt även för känslig hud.",
    "results_pill": "DOKUMENTERADE RESULTAT",
    "results_title": "Kliniskt bevisade resultat efter 4 veckor",
    "results_subtitle": "Baserat på en oberoende dermatologisk studie med 48 deltagare.",
    "stat1_val": "94%",
    "stat1_title": "FIRMERE HUD PÅ HALSEN",
    "stat1_desc": "Deltagarna upplevde en märkbar uppstramning och minskad slapphet längs halsen.",
    "stat2_val": "89%",
    "stat2_title": "MER DEFINIERAD KÄKLINJE",
    "stat2_desc": "Tydlig förbättring av V-linjekonturen och minskad vätskesvullnad runt käken.",
    "stat3_val": "91%",
    "stat3_title": "FÄRRE KRÅKSPARKAR",
    "stat3_desc": "Mätbar minskning av rynkdjup runt ögonområdet efter 28 dagars regelbunden användning.",
    "faq_pill": "FAQ",
    "faq_title": "Vanliga frågor och svar",
    "faq_q1": "När kan jag förvänta mig de första resultaten?",
    "faq_a1": "Många märker en omedelbar fuktboost och kylande lymfdränage redan efter första användningen. Synlig uppstramning av hals och käklinje syns vanligtvis efter 2-3 veckors daglig användning.",
    "faq_q2": "Passar produkterna för känslig hud?",
    "faq_a2": "Ja! Alla 5 formler är dermatologiskt testade, alkoholfria, parfymfria och formulerade vid ett hudvänligt pH-värde. Även ögonkrämen med Retinol är inkapslad för att förhindra irritation.",
    "faq_q3": "Hur länge räcker ett komplett set?",
    "faq_a3": "Vid rekommenderad användning 1-2 gånger dagligen räcker hela setet i cirka 8 till 10 veckor.",
    "faq_q4": "Hur fungerar 30 dagars garantin?",
    "faq_a4": "Om du av någon anledning inte är 100% nöjd inom 30 dagar, kontakta vår support för att få full återbetalning – utan krångel.",
    "faq_q5": "Varifrån skickas min beställning?",
    "faq_a5": "Alla beställningar skickas direkt från vårt tyska centrallager via DHL Express med spårningsnummer. Leveranstid är 1-3 vardagar.",
    "bottom_cta_tag": "BEGRÄNSAT ERBJUDANDE IDAG",
    "bottom_cta_headline": "Börja din hudförvandling idag",
    "bottom_cta_sub": "Få alla 5 K-Beauty bästsäljare i ett exklusivt fördelspaket för endast <strong>34,00 €</strong> (ord. pris 139,00 €).",
    "bottom_cta_btn": "LÄGG 5-DELAT SYSTEM I VARUKORGEN",
    "bottom_cta_guarantee": "30 dagars pengarna-tillbaka-garanti",
    "bottom_cta_shipping": "Gratis DHL-frakt inkluderad",
    "rev_badge": "VERIFIERADE KUNDRECENSIONER",
    "rev_title": "Vad våra kunder säger",
    "rev_subtitle": "Över 100 000 nöjda kunder i Europa litar på MediCube.",
    "rev_based_on": "Baserat på 1 420 recensioner",
    "rev_stars_5": "5 stjärnor",
    "rev_stars_4": "4 stjärnor",
    "rev_stars_3": "3 stjärnor",
    "rev_stars_2": "2 stjärnor",
    "rev_stars_1": "1 stjärna",
    "rev_verified": "Verifierad köpare",
    "rev_helpful": "Var denna recension till hjälp?",
    "rev_write": "Skriv en recension",
    "cart_title": "Din varukorg",
    "cart_empty_title": "Din varukorg är tom",
    "cart_progress_away": "Bara",
    "cart_progress_away_end": "kvar till fri frakt!",
    "cart_progress_free": "Du har fri DHL-frakt!",
    "cart_frequently_bought": "Populära tillägg för din rutin:",
    "cart_checkout_btn": "TILL KASSAN",
    "cart_guarantee": "30 dagars riskfri garanti • Säker krypterad betalning",
    "hero_s1_title": "KLINISK K-BEAUTY\nFÖR HEMMABRUK",
    "hero_s1_sub": "Upptäck prisbelönt koreansk hudvårdsteknologi.",
    "hero_s1_btn": "UTFORSKA NU",
    "hero_s2_title": "BOOSTER PRO X2™\nNY GENERATION",
    "hero_s2_sub": "6-i-1 Skönhetsapparat med elektroporation och EMS.",
    "hero_s2_btn": "UPPTÄCK APPARATER",
    "hero_s3_title": "PDRN & VOLUFILINE\nINTENSIVT LYFT",
    "hero_s3_sub": "Återställ hudens volym och elasticitet naturligt.",
    "hero_s3_btn": "SE KOLLEKTIONEN",
    "hero_s4_title": "HYPOCHLOROUS ACID\nKLARARE HUD",
    "hero_s4_sub": "Effektiv body peel mot finnar och ojämnheter.",
    "hero_s4_btn": "KÖP BODY PEEL",
    "devices_fixed_l1": "Ledande skönhetsteknologi",
    "devices_fixed_italic": "för synliga",
    "devices_fixed_l2": "kliniska resultat.",
    "devices_btn_all": "SE ALLA APPARATER",
    "comm_heading": "Över 100 000 nöjda kunder",
    "skin_fixed_l1": "Innovativ dermo-kosmetik.",
    "skin_fixed_italic": "Kliniskt bevisade",
    "skin_fixed_l2": "K-Beauty formler.",
    "btn_shop_now": "KÖP NU",
    "btn_view_all": "SE ALLA"
  };

  window.MC_TRANSLATIONS['no'] = {
    "announcement_text": "⚡ GRATIS DHL-FRAKT • 30 DAGERS FORNØYDHETSGARANTI ⚡",
    "nav_all_products": "Alle produkter",
    "nav_devices": "AGE-R Skjønnhetsteknologi",
    "nav_skincare": "Hudpleie",
    "nav_skincare_lines": "Hudpleielinjer",
    "nav_zero_line": "Zero Pore-linjen (Poreminimering & Sebum)",
    "nav_glass_glow": "Triple Collagen & Glow (Løft & Fasthet)",
    "nav_pink_pdrn": "Pink PDRN-linjen (Barriere & Peptider)",
    "nav_super_cica": "Exosome Super Cica (Beroligende & Lindrende)",
    "nav_deep_line": "Deep Vitamin C (Anti-Aging & Glød)",
    "nav_red_line": "Red Acne-linjen (Urenheter & Kviser)",
    "nav_txa_line": "TXA & Kojicsyre (Lysnende)",
    "nav_by_category": "Etter kategori",
    "nav_cleanser": "Renseprodukter & Cleansers",
    "nav_toner": "Tonere & Eksfolierende pads",
    "nav_serums": "Serum & Ampuller",
    "nav_creams": "Kremer & Fuktighetspleie",
    "nav_masks": "Sheet-masker & Nattinnpakning",
    "nav_sun": "Solbeskyttelse (SPF)",
    "nav_sets": "Sett & Fordelspakker",
    "nav_sets_sub": "Fordelspakker & Duos",
    "nav_bestsellers": "Bestsellere",
    "nav_guide": "AGE-R Veiledning & Instruksjoner",
    "nav_about": "Om oss",
    "nav_help": "Hjelp & Kundeservice",
    "nav_account": "Min konto / Logg inn",
    "search_placeholder": "Søk etter produkter, ingredienser, serier...",
    "region_title": "Land og Språk",
    "region_sub": "Velg leveringsland og foretrukket språk",
    "region_search": "Søk etter land eller valuta...",
    "language_label": "Språk / Language:",
    "reviews_count_suffix": "anmeldelser",
    "badge_set_save": "🔥 5-DELERS KOMPLETT SETT • SPAR 105 € (75% RABATT)",
    "badge_bestseller": "BESTSELGER",
    "badge_viral": "TIKTOK VIRAL",
    "save_75": "SPAR 75%",
    "save_24": "SPAR 24%",
    "save_31": "SPAR 31%",
    "science_badge_title": "Vitenskapelig dokumentert",
    "science_badge_sub": "<strong>80+ fagfellevurderte studier</strong> støtter vår formel.",
    "science_badge_link": "Se studier og lær mer",
    "klarna_installments_prefix": "Eller 3 rentefrie avdrag på",
    "klarna_installments_suffix": "med Klarna",
    "klarna_learn_more": "Les mer",
    "atc_btn_text": "LEGG I HANDLEKURV",
    "atc_adding": "Legger til...",
    "atc_sold_out": "Utsolgt",
    "urgency_badge": "BEGRENSET DAGSTILBUD",
    "urgency_timer_label": "Tilbudet utløper om:",
    "urgency_copy": "⚡ <strong>Gjelder kun i dag:</strong> Opptil <strong>31% rabatt + opptil 2 GRATIS flasker</strong> i vår fordelspakke. Stor etterspørsel – dagens parti er nesten utsolgt.",
    "free_shipping_unlocked": "Gratis DHL-frakt oppnådd",
    "choose_routine": "Velg din rutine:",
    "bestseller_pick": "🔥 87% velger Bestselger-settet",
    "body_peel_title": "1x Body Peel",
    "body_peel_sub": "280ml • Skånsom kroppspeeling",
    "face_peel_title": "1x Face Peel",
    "face_peel_sub": "50ml • Rensende ansiktsserum",
    "duo_set_title": "Duo-sett (Kropp + Ansikt)",
    "duo_free_tag": "+ 1 GRATIS",
    "duo_meta": "19,00 € / produkt • 330ml rutine",
    "double_duo_title": "2x Body Peel Dobbeltpakke",
    "double_free_tag": "+ 2 GRATIS",
    "double_meta": "34,50 € / flaske • 560ml forråd",
    "most_popular": "🔥 Mest populær",
    "best_value": "💎 Beste verdi",
    "save_label": "Spar",
    "gifts_header": "DINE GRATIS GAVER MED BESTILLINGEN",
    "gift_free_shipping": "Gratis frakt",
    "gift_free": "GRATIS",
    "gift_1_bottle": "1x GRATIS Flaske",
    "gift_2_bottles": "2x GRATIS Flasker",
    "gift_unlock_2x": "🔒 Låses opp med 2x Forråd",
    "sub_save_title": "Abonner & Spar (30% Rabatt)",
    "sub_save_meta": "30% fast rabatt på hver automatiske levering. Avslutt når som helst med 1 klikk.",
    "sub_tooltip_title": "Full fleksibilitet med abonnement:",
    "sub_tooltip_body": "Motta automatisk 30% rabatt på din første og alle fremtidige leveranser. Velg leveringsintervall, pause eller hopp over leveranser i kundekontoen, eller avslutt når som helst med 1 klikk. Ingen bindingstid, ingen skjulte gebyrer.",
    "sub_perk_free_ship": "Gratis frakt på alle bestillinger",
    "sub_perk_discount": "30% rabatt på hver påfølgende bestilling",
    "sub_perk_cancel": "Pause, juster eller avslutt når som helst med 1 klikk",
    "size_variant_label": "Størrelse / Variant:",
    "value_pack_tag": "FORDELSPAKKE",
    "preview_bundle_title": "Inkludert i den 5-delte fordelspakken:",
    "upsell_title": "Kjøpes ofte sammen",
    "upsell_sub": "Dermatologisk anbefalte rutinetillegg for maksimale resultater:",
    "btn_add": "+ Legg til",
    "btn_added": "Lagt til",
    "trust_fast_ship": "<strong>Rask levering:</strong> 1-3 virkedager med DHL",
    "trust_kbeauty": "<strong>100% Ekte K-Beauty:</strong> Direkte fra autorisert produsent",
    "trust_guarantee": "<strong>30 dagers fornøydhetsgaranti:</strong> Risikofri prøveperiode",
    "guarantee_title": "30 dagers pengene-tilbake-garanti",
    "guarantee_sub": "Prøv risikofritt i 30 dager. Ikke fornøyd? Full refusjon – ingen spørsmål stilt.",
    "guarantee_learn_more": "Lær mer ›",
    "cross_sell_heading": "Passer perfekt til din rutine:",
    "schema_skin_type": "Alle hudtyper, inkludert sensitiv hud",
    "schema_hair_type": "Kropp & Ansikt",
    "schema_skin_concerns": "Urenheter, ujevn hudtekstur (keratosis pilaris), rødhet",
    "schema_hair_concerns": "Døde hudceller, tette porer",
    "schema_key_actives": "Underklorsyre (Hypochlorous Acid), Risekstrakt (Oryza Sativa), Cica-kompleks",
    "yl_bullet_1": "<strong>5-i-1 Komplett system:</strong> Alle 5 K-Beauty bestselgere for hals, kjevelinje og øyeparti i én boks",
    "yl_bullet_2": "<strong>PDRN (Lakse-DNA) + 5% Volufiline:</strong> Stimulerer kollagensyntesen og fyller ut fine linjer naturlig",
    "yl_bullet_3": "<strong>Integrert Gua Sha massasjehode:</strong> Ergonomisk kirurgisk stålhode for daglig V-linje lymfedrenasje",
    "yl_bullet_4": "<strong>Spar 105 € direkte:</strong> 139,00 € separat verdi i dag for kun 34,00 € inkl. DHL Express-frakt",
    "tab_benefits": "Fordeler",
    "tab_clinicals": "Kliniske resultater",
    "tab_ingredients": "Ingredienser",
    "tab_usage": "Bruk",
    "tab_faq": "Ofte stilte spørsmål",
    "tab_sub_perks": "Abonnementsfordeler",
    "yl_badge_top": "KLINISK ANTI-AGING GJENNOMBRUDD",
    "yl_title": "Youth-Lock 5-delers Komplett System",
    "yl_subtitle": "Utviklet for å stramme opp slapp hals, definere kjevelinjen og jevne ut linjer – helt uten inngrep.",
    "p1_badge": "TRINN 1: RENS & FORBEREDELSE",
    "p1_step": "01",
    "p1_cat": "FORBEREDENDE RENS",
    "p1_name": "Collagen Peptide Gentle Cleanser",
    "p1_spec": "120ml • pH 5.5 Balansert",
    "p1_desc": "Skånsom renseemulsjon som renser porer i dybden uten å tørke ut huden. Forbereder huden optimalt på etterfølgende aktive stoffer.",
    "p2_badge": "TRINN 2: VOLUM & LØFT",
    "p2_step": "02",
    "p2_cat": "VOLUMISERENDE SERUM",
    "p2_name": "Volufiline 5% Plumping Ampoule",
    "p2_spec": "30ml • Patentert Volufiline™",
    "p2_desc": "Klinisk bevist fransk virkestoff som stimulerer lipidlagringen i vevet og gjenoppretter tapt volum i kinn og hals.",
    "p3_badge": "TRINN 3: LYMFEDRENASJE & KJEVELINJE",
    "p3_step": "03",
    "p3_cat": "KJEVELINJE & HALS",
    "p3_name": "PDRN Gua Sha Lifting Roller Serum",
    "p3_spec": "50ml • Innebygd metallhode",
    "p3_desc": "Kombinerer medisinsk rent lakse-DNA med et ergonomisk kjølende Gua Sha-rullhode for intensiv lymfedrenasje og definert V-linje.",
    "p4_badge": "TRINN 4: ØYEPARTI & LINJER",
    "p4_step": "04",
    "p4_cat": "ØYEPLEIE",
    "p4_name": "Triple Retinol Eye Tightening Cream",
    "p4_spec": "20ml • Inkapslet Retinol",
    "p4_desc": "Tre former for stabilisert retinol og koffein reduserer mørke ringer, hevelser og linjer uten å irritere det sensitive øyepartiet.",
    "p5_badge": "TRINN 5: FUKTLÅS & BARRIERE",
    "p5_step": "05",
    "p5_cat": "NATTINNP傢KNING",
    "p5_name": "Collagen Night Wrapping Mask",
    "p5_spec": "75ml • Okklusiv membranfilm",
    "p5_desc": "Danner en pustende kollagenfilm over natten som låser inne alle påførte virkestoffer og gir en fantastisk glass-skin glød om morgenen.",
    "calc_tag": "EKSKLUSIV FORDELSPAKKE",
    "calc_strike": "139,00 € separat verdi",
    "calc_deal": "I dag kun 34,00 €",
    "calc_note": "Du sparer over 75% (105,00 €) sammenlignet med enkeltkjøp.",
    "calc_btn": "HENT ALLE 5 FOR 34,00 €",
    "routine_pill": "DAGLIG RUTINE",
    "routine_title": "Din 3-minutters morgen- og kveldsrutine",
    "routine_subtitle": "Enkle trinn for maksimale kliniske resultater hjemme.",
    "step1_time": "Morgen & Kveld • 30 sek",
    "step1_title": "Rens & Forbered",
    "step1_desc": "Fukt ansiktet med lunkent vann og masser forsiktig inn Cleanser med sirkulære bevegelser. Skyll grundig.",
    "step2_time": "Morgen & Kveld • 45 sek",
    "step2_title": "Volufiline Ampulle",
    "step2_desc": "Påfør 3-4 dråper på kinn, panne og hals. Klapp forsiktig inn til formelen er helt absorbert.",
    "step3_time": "Kveld • 60 sek",
    "step3_title": "Gua Sha Roller V-Linje",
    "step3_desc": "Rull Gua Sha-hodet med lett trykk fra haken oppover langs kjevelinjen mot ørene og ned langs halsen.",
    "step4_time": "Morgen & Kveld • 30 sek",
    "step4_title": "Øyekrem mot linjer",
    "step4_desc": "Klapp en ertestor mengde forsiktig rundt øyebenet med ringfingeren.",
    "step5_time": "Kun Kveld • 30 sek",
    "step5_title": "Collagen Wrapping Mask",
    "step5_desc": "Påfør et jevnt lag som siste trinn om kvelden. La virke over natten og dra av eller skyll om morgenen.",
    "guasha_pill": "INNOVATIV TEKNOLOGI",
    "guasha_title": "Det integrerte kirurgiske Gua Sha-hodet",
    "guasha_subtitle": "Hvorfor profesjonell lymfemassasje gjør hele forskjellen for din kjevelinje.",
    "guasha_d1_title": "Ergonomisk V-kontur",
    "guasha_d1_desc": "Utviklet for å passe perfekt til ansiktets naturlige benstruktur og kjevelinje.",
    "guasha_d2_title": "Kjølende kirurgisk stål",
    "guasha_d2_desc": "Medisinsk rustfritt stål kjøler huden umiddelbart, reduserer morgenhevelser og strammer opp.",
    "guasha_d3_title": "Dypere opptak av PDRN",
    "guasha_d3_desc": "Rullebevegelsen presser lakse-DNA dypt inn i hudens dermale lag for maksimal effekt.",
    "tool_f1": "Hypoallergent medisinsk stål",
    "tool_f2": "360° Rulletrykksteknikk",
    "tool_f3": "Enkel rengjøring med vann",
    "guasha_stat_val": "+340%",
    "guasha_stat_desc": "økt opptak av virkestoffer sammenlignet med manuell påføring.",
    "science_pill": "BIO-TEKNOLOGI",
    "science_title": "Klinisk dokumenterte nøkkelingredienser",
    "science_subtitle": "Ingen fyllstoffer. Kun høykonsentrerte virkestoffer med dokumentert effekt.",
    "sci_p1_title": "Lakse-DNA (PDRN)",
    "sci_p1_role": "Cellulær regenerering & Kollagenoppbygging",
    "sci_p1_desc": "PDRN matcher humant DNA til 95% og stimulerer fibroblaster til å produsere nytt kollagen og elastin.",
    "sci_p2_title": "Volufiline™ (5%)",
    "sci_p2_role": "Naturlig volum & Fylde",
    "sci_p2_desc": "Patentert ekstrakt fra Anemarrhena Asphodeloides som øker fettvevets volum og fyller ut innsunkne partier.",
    "sci_p3_title": "Triple Retinol Kompleks",
    "sci_p3_role": "Cellefornyelse & Rynkereduksjon",
    "sci_p3_desc": "Tre former for innkapslet retinol for maksimal effekt med minimal irritasjon – perfekt også for sensitiv hud.",
    "results_pill": "DOKUMENTERTE RESULTATER",
    "results_title": "Klinisk dokumenterte resultater etter 4 uker",
    "results_subtitle": "Basert på en uavhengig dermatologisk studie med 48 deltakere.",
    "stat1_val": "94%",
    "stat1_title": "FASTERE HUD PÅ HALSEN",
    "stat1_desc": "Deltakerne opplevde en merkbar oppstramming og redusert slapphet langs halsen.",
    "stat2_val": "89%",
    "stat2_title": "MER DEFINERT KJEVELINJE",
    "stat2_desc": "Tydelig forbedring av V-linjekonturen og redusert væskeansamling rundt kjeven.",
    "stat3_val": "91%",
    "stat3_title": "FÆRRE LINJER RUNDT ØYNENE",
    "stat3_desc": "Målbar reduksjon av rynkedybde rundt øyepartiet etter 28 dagers regelmessig bruk.",
    "faq_pill": "FAQ",
    "faq_title": "Ofte stilte spørsmål og svar",
    "faq_q1": "Når kan jeg forvente de første resultatene?",
    "faq_a1": "Mange merker en umiddelbar fuktboost og kjølende lymfedrenasje allerede etter første gangs bruk. Synlig oppstramming av hals og kjevelinje sees vanligvis etter 2-3 ukers daglig bruk.",
    "faq_q2": "Passer produktene for sensitiv hud?",
    "faq_a2": "Ja! Alle 5 formlene er dermatologisk testet, alkoholfrie, parfymefrie og formulert ved en hudvennlig pH-verdi. Selv øyekremen med Retinol er innkapslet for å unngå irritasjon.",
    "faq_q3": "Hvor lenge varer et komplett sett?",
    "faq_a3": "Ved anbefalt bruk 1-2 ganger daglig varer hele settet i cirka 8 til 10 uker.",
    "faq_q4": "Hvordan fungerer 30 dagers garantien?",
    "faq_a4": "Hvis du av en eller annen grunn ikke er 100% fornøyd innen 30 dager, ta kontakt med vår kundeservice for full refusjon – uten spørsmål.",
    "faq_q5": "Hvor sendes bestillingen min fra?",
    "faq_a5": "Alle bestillinger sendes direkte fra vårt tyske sentrallager via DHL Express med sporingsnummer. Leveringstid er 1-3 virkedager.",
    "bottom_cta_tag": "BEGRENSET TILBUD I DAG",
    "bottom_cta_headline": "Start din hudforvandling i dag",
    "bottom_cta_sub": "Få alle 5 K-Beauty bestselgere i en eksklusiv fordelspakke til kun <strong>34,00 €</strong> (vejl. pris 139,00 €).",
    "bottom_cta_btn": "LEGG 5-DELERS SYSTEM I HANDLEKURV",
    "bottom_cta_guarantee": "30 dagers pengene-tilbake-garanti",
    "bottom_cta_shipping": "Gratis DHL-frakt inkludert",
    "rev_badge": "VERIFISERTE KUNDEANMELDELSER",
    "rev_title": "Hva kundene våre sier",
    "rev_subtitle": "Over 100 000 fornøyde kunder i Europa stoler på MediCube.",
    "rev_based_on": "Basert på 1 420 anmeldelser",
    "rev_stars_5": "5 stjerner",
    "rev_stars_4": "4 stjerner",
    "rev_stars_3": "3 stjerner",
    "rev_stars_2": "2 stjerner",
    "rev_stars_1": "1 stjerne",
    "rev_verified": "Verifisert kjøper",
    "rev_helpful": "Var denne anmeldelsen til hjelp?",
    "rev_write": "Skriv en anmeldelse",
    "cart_title": "Din handlekurv",
    "cart_empty_title": "Handlekurven din er tom",
    "cart_progress_away": "Bare",
    "cart_progress_away_end": "igjen til gratis frakt!",
    "cart_progress_free": "Du har gratis DHL-frakt!",
    "cart_frequently_bought": "Populære tillegg for rutinen din:",
    "cart_checkout_btn": "TIL KASSEN",
    "cart_guarantee": "30 dagers risikofri garanti • Sikker kryptert betaling",
    "hero_s1_title": "KLINISK K-BEAUTY\nFOR HJEMMEBRUK",
    "hero_s1_sub": "Oppdag prisbelønt koreansk hudpleieteknologi.",
    "hero_s1_btn": "UTFORSK NÅ",
    "hero_s2_title": "BOOSTER PRO X2™\nNY GENERASJON",
    "hero_s2_sub": "6-i-1 Skjønnhetsapparat med elektroporasjon og EMS.",
    "hero_s2_btn": "OPPDAG APPARATER",
    "hero_s3_title": "PDRN & VOLUFILINE\nINTENSIVT LØFT",
    "hero_s3_sub": "Gjenopprett hudens volum og elastisitet naturlig.",
    "hero_s3_btn": "SE KOLLEKSJONEN",
    "hero_s4_title": "HYPOCHLOROUS ACID\nKLARERE HUD",
    "hero_s4_sub": "Effektiv body peel mot urenheter og kviser.",
    "hero_s4_btn": "KJØP BODY PEEL",
    "devices_fixed_l1": "Ledende skjønnhetsteknologi",
    "devices_fixed_italic": "for synlige",
    "devices_fixed_l2": "kliniske resultater.",
    "devices_btn_all": "SE ALLE APPARATER",
    "comm_heading": "Over 100 000 fornøyde kunder",
    "skin_fixed_l1": "Innovativ dermo-kosmetikk.",
    "skin_fixed_italic": "Klinisk dokumenterte",
    "skin_fixed_l2": "K-Beauty formler.",
    "btn_shop_now": "KJØP NÅ",
    "btn_view_all": "SE ALLE"
  };

  // ---------------------------------------------------------------
  // HIGH-PRECISION TEXT REPLACEMENT TABLE (PHRASE MAP)
  // Replaces exact strings and common phrases across the entire DOM
  // ---------------------------------------------------------------
  window.MC_EN_PHRASES = [
    // General E-Commerce & Guarantees
    ['Lieferung bis', 'Delivery by'],
    ['bei Bestellung heute', 'if ordered today'],
    ['DEIN VORTEIL', 'YOUR ADVANTAGE'],
    ['Wähle dein K-Beauty System.', 'Choose your K-Beauty System.'],
    ['Maximiere deine Ergebnisse mit dem optimalen Pflege-Set. Mit dem Bestseller-Duo sparst du 20 % und erhältst die abgestimmte Pflege für Gesicht & Körper.', 'Maximize your results with the optimal skincare set. With our Bestseller Duo you save 20% and receive matching care for face & body.'],
    ['Kostenloser DHL Express-Versand (1–3 Werktage)', 'Free Express Shipping (1–3 business days)'],
    ['30-Tage risikofreie Geld-zurück-Garantie', '30-Day Risk-Free Money-Back Guarantee'],
    ['Sicher bezahlen mit Klarna, PayPal, Apple Pay & Kreditkarte', 'Secure payment with Klarna, PayPal, Apple Pay & Credit Card'],
    ['Sicher bezahlen mit Klarna, PayPal, Apple Pay &amp; Kreditkarte', 'Secure payment with Klarna, PayPal, Apple Pay & Credit Card'],
    ['Kostenloser DHL-Versand nach Deutschland', 'Free DHL Shipping to Germany'],
    ['freigeschaltet', 'unlocked'],
    ['Wird weitergeleitet...', 'Redirecting...'],
    ['IN DEN WARENKORB —', 'ADD TO CART —'],
    ['IN DEN WARENKORB', 'ADD TO CART'],
    ['In den Warenkorb', 'Add to Cart'],
    ['+ In den Warenkorb', '+ Add to cart'],
    ['PRODUKTE', 'PRODUCTS'],
    ['SORTIEREN NACH:', 'SORT BY:'],
    ['Kollektionen', 'Collections'],
    ['Empfohlen', 'Featured'],
    ['Preis: aufsteigend', 'Price: Low to High'],
    ['Preis: absteigend', 'Price: High to Low'],
    ['Neuheiten', 'New Arrivals'],
    ['Variante wählen', 'Select variant'],
    ['Ausverkauft', 'Sold Out'],
    ['(Ausverkauft)', '(Sold Out)'],

    // Booster Pro & Guide
    ['Without Skincare', 'Without Skincare'],
    ['Ohne Hautpflege', 'Without Skincare'],
    ['Mit Hautpflege', 'With Skincare'],
    ['Mit Tuchmaske', 'With Sheet Mask'],
    ['2–3x wöchentlich', '2–3x weekly'],
    ['2–3-mal wöchentlich', '2–3x weekly'],
    ['1–3x täglich', '1–3x daily'],
    ['1–3-mal täglich', '1–3x daily'],
    ['1x täglich', '1x daily'],
    ['1-mal täglich', '1x daily'],
    ['7 Modi', '7 Modes'],
    ['6 Intensitätsstufen', '6 Intensity Levels'],
    ['*Basierend auf kumulierten weltweiten Amazon- und Direktverkäufen aller Booster Pro Varianten seit Launch.', '*Based on cumulative worldwide Amazon and direct sales of all Booster Pro variants since launch.'],
    ['Anleitungen', 'Guides'],
    ['ANLEITUNG.', 'HOW TO USE.'],
    ['Von Dermatologen empfohlen – Höchste Sicherheit trifft auf maximale Leistung.', 'Dermatologist recommended – Maximum safety meets clinical performance.'],
    ['Kurzanleitung für jeden Modus', 'Quick Guide for Every Mode'],
    ['Wie verwende ich den Booster Pro X2™?', 'How do I use the Booster Pro X2™?'],
    ['Wie verwende ich<br>den Booster Pro X2™?', 'How do I use<br>the Booster Pro X2™?'],
    ['7 Umfassende Hautlösungen', '7 Total Skin Solutions'],
    ['Klinisch bewiesene Wirksamkeit', 'Clinically Proven Efficacy'],
    ['DUALE ANPASSUNG', 'DUAL CUSTOMIZATION'],
    ['MASKEN-BOOST', 'MASK BOOST'],
    ['KI-PERSONALISIERUNG', 'AI PERSONALIZATION'],
    ['2X GLOW-BOOSTING', '2X GLOW BOOSTING'],
    ['2X SPANNKRAFT-BOOST', '2X ELASTICITY BOOST'],
    ['2X KONTURIERUNG', '2X CONTOURING'],
    ['2X PORENVERFEINERUNG', '2X PORE REFINING'],
    ['So kombinieren Sie Ihre Modi', 'How to Layer Your Modes'],
    ['So kombinieren Sie<br class="mobile_device"> Ihre Modi', 'How to Layer<br class="mobile_device"> Your Modes'],
    ['Perfekt kombiniert.', 'Better Together.'],
    ['Produkte, die optimal mit dem AGE-R Booster Pro X2 harmonieren', 'Products that harmonize optimally with the AGE-R Booster Pro X2'],
    ['Beste Pflegeergebnisse durch synergetische Wirkstoffaufnahme', 'Best skincare results through synergistic active absorption'],
    ['Kollagen Linie', 'Collagen Line'],
    ['Zero Poren Linie', 'Zero Pore Line'],
    ['Deep Vita C Linie', 'Deep Vita C Line'],

    // Hypochlorous Steps & FAQs
    ['Unter der Dusche auf die feuchte Haut auftragen (besonders an Rücken, Armen & Beinen). Sanft in kreisenden Bewegungen einmassieren, 1–2 Minuten einwirken lassen und gründlich abspülen.', 'Apply in the shower to damp skin (especially on back, arms & legs). Gently massage in circular motions, leave on for 1–2 minutes, and rinse thoroughly.'],
    ['Unter der Dusche auf die feuchte Haut auftragen (besonders an Rücken, Armen &amp; Beinen). Sanft in kreisenden Bewegungen einmassieren, 1–2 Minuten einwirken lassen und gründlich abspülen.', 'Apply in the shower to damp skin (especially on back, arms & legs). Gently massage in circular motions, leave on for 1–2 minutes, and rinse thoroughly.'],
    ['Nach der Gesichtsreinigung 2–3 Tropfen mit der Pipette direkt auf Gesicht und Hals geben. Sanft mit den Fingerspitzen einklopfen, bis das Serum vollständig eingezogen ist.', 'After cleansing, apply 2–3 drops directly to face and neck using the dropper. Gently pat in with fingertips until fully absorbed.'],
    ['Die Routine mit deiner gewohnten Feuchtigkeitscreme (z. B. Collagen Jelly Cream) abschließen, um die Wirkstoffe einzuschließen und die Hautbarriere 24h zu schützen.', 'Complete your routine with your favorite moisturizer (e.g. Collagen Jelly Cream) to lock in active ingredients and protect the skin barrier 24h.'],
    ['Klassischer koreanischer Reis-Extrakt spendet tiefenwirksame Feuchtigkeit, hellt Pickelmale sichtbar auf und sorgt für den berühmten Glass-Skin-Glow.', 'Traditional Korean rice extract deeply hydrates, visibly brightens blemish marks, and imparts the famous glass-skin glow.'],
    ['Was ist Hypochlorous Acid und wie wirkt es auf der Haut?', 'What is Hypochlorous Acid and how does it work on the skin?'],
    ['Hypochlorous Acid (HOCl) ist eine natürlich im menschlichen Immunsystem vorkommende Substanz. Auf der Haut wirkt sie hochwirksam antimikrobiell, beruhigt Entzündungen und bekämpft Akne-verursachende Bakterien in Sekundenschnelle – ohne die gesunde Hautbarriere zu schädigen oder auszutrocknen.', 'Hypochlorous Acid (HOCl) is a substance naturally produced by the human immune system. On the skin, it provides highly effective antimicrobial protection, soothes inflammation, and fights acne-causing bacteria in seconds — without damaging the healthy skin barrier or drying it out.'],
    ['Hilft der Rice Body Peel Shot bei Erdbeerbeinen und Rückenakne?', 'Does the Rice Body Peel Shot help with strawberry legs and back acne?'],
    ['Ja, absolut! Die Kombination aus sanftem Peeling und HOCl löst Verhornungen in den Follikeln (Keratosis Pilaris bzw. Reibeisenhaut) und befreit Poren an Rücken, Schultern und Beinen. Das Hautbild wird spürbar glatter und ebenmäßiger.', 'Yes, absolutely! The combination of gentle exfoliation and HOCl dissolves keratin build-up in follicles (keratosis pilaris) and unclogs pores on the back, shoulders, and legs. Skin texture becomes noticeably smoother and more even.'],
    ['Kann ich das Face Serum täglich anwenden?', 'Can I use the Face Serum daily?'],
    ['Ja. Der Rice Face Peel Shot ist so formuliert, dass er selbst bei empfindlichster Haut morgens und abends täglich angewendet werden kann. Er zieht rückstandslos ein und lässt sich perfekt mit weiteren Seren und Cremes kombinieren.', 'Yes. The Rice Face Peel Shot is formulated to be gentle enough for daily morning and evening use, even on the most sensitive skin. It absorbs without residue and layers perfectly with other serums and creams.'],
    ['Ist das Produkt für empfindliche & zu Rötungen neigende Haut geeignet?', 'Is the product suitable for sensitive & redness-prone skin?'],
    ['Ist das Produkt für empfindliche &amp; zu Rötungen neigende Haut geeignet?', 'Is the product suitable for sensitive & redness-prone skin?'],
    ['Ja. Beide Produkte wurden dermatologisch mit einem Reizungsindex von 0.00% getestet. Sie sind frei von aggressiven Duftstoffen, künstlichen Farbstoffen und Parabenen.', 'Yes. Both products have been dermatologically tested with a 0.00% irritation index. They are free from harsh fragrances, artificial colorants, and parabens.'],
    ['Wann kann ich mit ersten sichtbaren Ergebnissen rechnen?', 'When can I expect to see the first visible results?'],
    ['Bereits nach der ersten Anwendung fühlt sich die Haut weicher und beruhigter an. Eine deutliche Reduzierung von Unreinheiten, Rötungen und rauen Stellen ist in der Regel nach 7 bis 14 Tagen regelmäßiger Anwendung sichtbar.', 'Skin feels softer and calmer after the very first application. A noticeable reduction in blemishes, redness, and rough texture is typically visible within 7 to 14 days of consistent use.'],

    // AGE-R Devices Dropdown Subtitles
    ['6-in-1 Klinische Pflege (Neuheit)', '6-in-1 Clinical Care (New)'],
    ['Bestseller Elektroporation & EMS', 'Bestseller Electroporation & EMS'],
    ['40.68 MHz Radiofrequenz Kollagenboost', '40.68 MHz Radiofrequency Collagen Boost'],
    ['Kompakter Glow für unterwegs', 'Compact On-The-Go Glow'],
    ['Klärende Körperpflege & Blemish-Control', 'Clarifying Body Care & Blemish Control'],

    // Hypochlorous Bundle Selector & Tiers
    ['Pflegeroutine wählen:', 'Choose your routine:'],
    ['🔥 87% wählen das Bestseller-Set', '🔥 87% choose the Bestseller Set'],
    ['Bestseller-Set', 'Bestseller Set'],
    ['Bestseller-Duo', 'Bestseller Duo'],
    ['/ Produkt • 330ml Routine', '/ product • 330ml Routine'],
    ['/ Flasche • 560ml Vorrat', '/ bottle • 560ml Supply'],
    ['Sanftes Peeling für den Körper gegen Unreinheiten & Blemishes', 'Gentle body peeling against blemishes & impurities'],
    ['Konzentriertes Klärendes Peeling-Serum für das Gesicht', 'Concentrated clarifying peeling serum for the face'],
    ['Beinhaltet BEIDE Produkte • Maximale Ergebnisse & Glass-Skin-Glow', 'Includes BOTH products • Maximum results & glass-skin glow'],
    ['Vorratspack für maximale Langzeitergebnisse • Spare zusätzlich 7 €', 'Value pack for maximum long-term results • Save an additional €7'],
    ['🔥 BESTSELLER-SET • SPARE 23%', '🔥 BESTSELLER SET • SAVE 23%'],
    ['🔥 BESTSELLER — 20% RABATT', '🔥 BESTSELLER — 20% OFF'],
    ['💎 MAXIMALER VORTEIL • SPARE 31%', '💎 MAXIMUM VALUE • SAVE 31%'],
    ['Wähle deine Pflegeroutine.', 'Choose your skincare routine.'],
    ['DAS OPTIMALE SET', 'THE OPTIMAL SET'],
    ['Hol dir das Komplett-Duo für Gesicht & Körper und spare 23% gegenüber dem Einzelkauf.', 'Get the complete duo for face & body and save 23% compared to individual purchase.'],
    ['Mit dem Bestseller-Duo sparst du 20 %', 'With the Bestseller Duo you save 20%'],
    ['AB 30 JAHREN (BESTSELLER)', 'FROM AGE 30 (BESTSELLER)'],
    ['originalen koreanischen Bestsellern', 'original Korean bestsellers'],
    ['ausgewählte MediCube Skincare-Bestseller.', 'selected MediCube skincare bestsellers.'],
    ['Entdecke unsere meistverkauften K-Beauty Bestseller und starte deine Hautpflege-Routine.', 'Discover our bestselling K-Beauty products and start your skincare routine.'],
    ['Bestseller für maximale Ergebnisse & sofortigen Glow', 'Bestsellers for maximum results & instant glow'],
    ['Alle Bestseller ansehen', 'View all bestsellers'],
    ['Perfekt abgestimmte K-Beauty Bestseller für deine tägliche Pflegeroutine.', 'Perfectly matched K-Beauty bestsellers for your daily skincare routine.'],
    ['KÖRPERPFLEGE', 'BODY CARE'],
    ['-30% RABATT', '30% OFF'],
    ['Rice Body Peel Shot (280ml)', 'Rice Body Peel Shot (280ml)'],
    ['Rice Face Peel Shot (50ml)', 'Rice Face Peel Shot (50ml)'],
    ['Komplettes Duo-Set (Body + Face)', 'Complete Duo Set (Body + Face)'],
    ['2x Komplettes Duo-Set (2x Body + 2x Face)', '2x Complete Duo Set (2x Body + 2x Face)'],

    // Hypochlorous Benefits, Routine, Clinical & FAQ
    ['🔬 DERMATOLOGISCHE INNOVATION', '🔬 DERMATOLOGICAL INNOVATION'],
    ['Die Kraft von Hypochlorous Acid & koreanischem Reis-Extrakt', 'The Power of Hypochlorous Acid & Korean Rice Extract'],
    ['Hypochlorous Acid (HOCl) ist ein körpereigener Abwehrstoff, der hochwirksam gegen Bakterien, Rötungen und Hautunreinheiten vorgeht – bei 100% Barriere-Schutz. In Kombination mit fermentiertem Reis-Extrakt entsteht das ultimative Pflegesystem für Gesicht und Körper.', 'Hypochlorous Acid (HOCl) is the body\'s natural defense molecule, highly effective against bacteria, redness, and blemishes — with 100% barrier protection. Combined with fermented rice extract, it creates the ultimate care system for face and body.'],
    ['Klärende Anti-Blemish Formel', 'Clarifying Anti-Blemish Formula'],
    ['Bekämpft gezielt Unreinheiten, Rötungen und Mitesser im Gesicht sowie am Körper (Rücken, Schultern, Dekolleté), ohne die Haut auszutrocknen.', 'Targeted defense against blemishes, redness, and blackheads on face and body (back, shoulders, décolleté) without drying out the skin.'],
    ['Mikro-Peeling & Textur-Glättung', 'Micro-Peeling & Texture Smoothing'],
    ['Befreit verstopfte Poren und glättet raue Hautpartien wie Erdbeerbeine (Keratosis Pilaris) sanft und gründlich für spürbar weiche Haut.', 'Unclogs pores and smooths rough patches like strawberry legs (Keratosis Pilaris) gently and thoroughly for visibly soft skin.'],
    ['Oryza Sativa Reis-Glow', 'Oryza Sativa Rice Glow'],
    ['Reis-Wasser & Reis-Kleie versorgen die Haut intensiv mit Nährstoffen, verfeinern das Hautbild und verleihen den begehrten koreanischen Glass-Skin-Glow.', 'Rice water and rice bran nourish the skin deeply, refine skin texture, and impart the coveted Korean glass-skin glow.'],
    ['100% Barriere-Schonend', '100% Barrier-Gentle'],
    ['Kein Brennen, keine Schälung: Beruhigt irritierte Haut sofort und stärkt das natürliche Mikrobiom – selbst bei empfindlicher und zu Akne neigender Haut.', 'Zero stinging, zero peeling: Instantly soothes irritated skin and strengthens the natural microbiome — even on sensitive and acne-prone skin.'],
    ['📊 KLINISCH ERWIESENE WIRKUNG', '📊 CLINICALLY PROVEN EFFICACY'],
    ['Sichtbare Ergebnisse ab der 1. Anwendung', 'Visible Results from the 1st Application'],
    ['In unabhängigen klinischen Tests unter dermatologischer Aufsicht in Seoul (Korea) bestätigt.', 'Confirmed in independent clinical tests under dermatological supervision in Seoul (Korea).'],
    ['Weniger Unreinheiten & Pickel', 'Fewer Blemishes & Spots'],
    ['Probanden bestätigen eine spürbare Reduzierung von Entzündungen & Rötungen nach 14 Tagen.', 'Participants confirm a noticeable reduction in inflammation & redness after 14 days.'],
    ['Verfeinerte Poren & Talgkontrolle', 'Refined Pores & Sebum Control'],
    ['Sichtbar feinere Porenstruktur und langanhaltend regulierte Talgproduktion ohne Austrocknen.', 'Visibly refined pore structure and long-lasting regulated sebum production without drying.'],
    ['Glattere, ebenmäßige Hauttextur', 'Smoother, Even Skin Texture'],
    ['Signifikante Verbesserung von rauen Hautstellen (Erdbeerbeine, Reibeisenhaut) am Körper.', 'Significant improvement in rough skin patches (strawberry legs, keratosis pilaris) on the body.'],
    ['0.00% Reizungsindex • Hypoallergen getestet • Für empfindlichste Hauttypen geeignet', '0.00% Irritation Index • Hypoallergenic Tested • Suitable for Sensitive Skin'],
    ['✨ ANWENDUNGS-ROUTINE', '✨ APPLICATION ROUTINE'],
    ['So wendest du das Hypochlorous Acid System an', 'How to Use the Hypochlorous Acid System'],
    ['Optimale Ergebnisse in 3 einfachen Schritten für reine, samtweiche Haut im Gesicht und am gesamten Körper.', 'Optimal results in 3 easy steps for clear, velvety soft skin on face and body.'],
    ['KÖRPERPFLEGE (DUSCHE)', 'BODY CARE (SHOWER)'],
    ['GESICHTSPFLEGE (SERUM)', 'FACIAL CARE (SERUM)'],
    ['BARRIERE & HYDRATION', 'BARRIER & HYDRATION'],
    ['Feuchtigkeit & Schutz', 'Hydration & Protection'],
    ['📅 Anwendung: 2–3x pro Woche', '📅 Usage: 2–3x per week'],
    ['📅 Anwendung: Täglich (Morgens & Abends)', '📅 Usage: Daily (Morning & Evening)'],
    ['📅 Anwendung: Im Anschluss an Schritt 2', '📅 Usage: Following Step 2'],
    ['❓ HÄUFIGE FRAGEN', '❓ FREQUENTLY ASKED QUESTIONS'],
    ['Fragen & Antworten zum Hypochlorous System', 'Questions & Answers about the Hypochlorous System'],
    ['Alles, was du über die Wirkungsweise, Verträglichkeit und Anwendung wissen musst.', 'Everything you need to know about efficacy, tolerance, and application.'],


    // Header & Navigation
    ['⚡ KOSTENLOSER DHL-VERSAND • 30 TAGE GELD-ZURÜCK-GARANTIE ⚡', '⚡ FREE DHL SHIPPING • 30-DAY MONEY-BACK GUARANTEE ⚡'],
    ['AGE-R Beauty Tech Geräte', 'AGE-R Beauty Devices'],
    ['Hautpflege-Linien', 'Skincare Lines'],
    ['Hautpflege', 'Skincare'],
    ['Zero Poren-Linie (Poren & Sebum)', 'Zero Pore Line (Pores & Sebum)'],
    ['Zero Poren-Linie', 'Zero Pore Line'],
    ['Triple Collagen & Glow (Straffung & Elastizität)', 'Triple Collagen & Glow (Firming & Elasticity)'],
    ['Triple Collagen & Glow', 'Triple Collagen & Glow'],
    ['Pink PDRN Linie (Barriere & Peptide)', 'Pink PDRN Line (Barrier & Peptides)'],
    ['Pink PDRN Regeneration', 'Pink PDRN Regeneration'],
    ['Pink PDRN Linie', 'Pink PDRN Line'],
    ['Exosome Super Cica (Beruhigung)', 'Exosome Super Cica (Calming & Soothing)'],
    ['Exosome Super Cica', 'Exosome Super Cica'],
    ['Deep Vitamin C (Anti-Aging & Flecken)', 'Deep Vitamin C (Anti-Aging & Radiance)'],
    ['Deep Vitamin C Anti-Aging', 'Deep Vitamin C Anti-Aging'],
    ['Red Akne-Linie (Unreine Haut)', 'Red Acne Line (Blemish Care)'],
    ['Red Akne-Pflege', 'Red Acne Care'],
    ['TXA & Kojisäure (Aufhellung)', 'TXA & Kojic Acid (Brightening)'],
    ['TXA & Kojisäure Aufhellung', 'TXA & Kojic Acid Brightening'],
    ['Nach Pflegelinie', 'By Skincare Line'],
    ['Nach Kategorie', 'By Category'],
    ['Reinigung & Cleanser', 'Cleansers & Cleansing'],
    ['Toner & Peeling-Pads', 'Toners & Exfoliating Pads'],
    ['Seren & Ampullen', 'Serums & Ampoules'],
    ['Cremes & Feuchtigkeit', 'Creams & Moisturizers'],
    ['Gesichtsmasken & Wrapping', 'Sheet Masks & Night Wrapping'],
    ['Sonnenschutz (SPF)', 'Sun Protection (SPF)'],
    ['Sets & Duos', 'Sets & Bundles'],
    ['Vorteils-Sets & Duos', 'Value Sets & Bundles'],
    ['Bestseller', 'Bestsellers'],
    ['AGE-R Guide & Anleitung', 'AGE-R Guide & Instructions'],
    ['Über uns', 'About Us'],
    ['Hilfe & Kundenservice', 'Help & Support'],
    ['Hilfe & Kontakt', 'Help & Contact'],
    ['Mein Konto / Anmelden', 'My Account / Sign In'],
    ['Alle Produkte', 'All Products'],
    ['Geräte-Leitgele & Zubehör →', 'Device Gels & Accessories →'],
    ['Alle Technologien im Überblick →', 'Explore All Technologies →'],

    // PDP Above the Fold & Pricing
    ['🔥 5-TEILIGES KOMPLETT-SET • 105 € SPAREN (75% VORTEIL)', '🔥 5-PIECE COMPLETE SET • SAVE €105 (75% OFF)'],
    ['SPAREN 75%', 'SAVE 75%'],
    ['SPAREN 24%', 'SAVE 24%'],
    ['SPAREN 31%', 'SAVE 31%'],
    ['139,00 € UVP', '€139.00 MSRP'],
    ['34,00 € KOMPLETT-SET', '€34.00 COMPLETE SET'],
    ['Wissenschaftlich fundiert', 'Backed by Science'],
    ['80+ von Experten begutachtete Studien hinter unserer Formel.', '80+ peer-reviewed studies supporting our formula.'],
    ['Studien ansehen & mehr erfahren', 'View studies & learn more'],
    ['Oder in 3 zinsfreien Raten von', 'Or 3 interest-free installments of'],
    ['mit Klarna', 'with Klarna'],
    ['Mehr erfahren', 'Learn more'],
    ['IN DEN WARENKORB', 'ADD TO CART'],
    ['In den Warenkorb', 'Add to Cart'],
    ['Wird hinzugefügt...', 'Adding...'],
    ['AUSVERKAUFT', 'SOLD OUT'],
    ['Ausverkauft', 'Sold Out'],
    ['LIMITIERTES TAGESANGEBOT', 'LIMITED DAILY OFFER'],
    ['Aktion endet in:', 'Deal ends in:'],
    ['Pflegeroutine wählen:', 'Choose your routine:'],
    ['🔥 87% wählen das Bestseller-Set', '🔥 87% choose the Bestseller Set'],
    ['1x Body Peel', '1x Body Peel'],
    ['280ml • Sanftes Körperpeeling', '280ml • Gentle Body Exfoliator'],
    ['1x Face Peel', '1x Face Peel'],
    ['50ml • Klärendes Gesichtsserum', '50ml • Clarifying Facial Serum'],
    ['Duo-Set (Body + Face)', 'Duo Set (Body + Face)'],
    ['+ 1 GRATIS', '+ 1 FREE'],
    ['2x Body Peel Doppelpack', '2x Body Peel Value Pack'],
    ['+ 2 GRATIS', '+ 2 FREE'],
    ['🔥 Meistgewählt', '🔥 Most Popular'],
    ['💎 Bester Wert', '💎 Best Value'],
    ['Spare 11,95 €', 'Save €11.95'],
    ['Spare 8,00 €', 'Save €8.00'],
    ['Spare 30,95 €', 'Save €30.95'],
    ['DEINE GESCHENKE ZUR BESTELLUNG', 'YOUR FREE GIFTS WITH PURCHASE'],
    ['Kostenloser Versand', 'Free Shipping'],
    ['1x GRATIS Flasche', '1x FREE Bottle'],
    ['2x GRATIS Flaschen', '2x FREE Bottles'],
    ['🔒 Ab 2x Vorrat', '🔒 Unlocks with 2x Supply'],
    ['Abo & Sparen (30% Rabatt)', 'Subscribe & Save (30% Off)'],
    ['30% Dauerrabatt auf jede Folgelieferung. Jederzeit mit 1 Klick kündbar.', '30% recurring discount on every auto-delivery. Cancel anytime in 1 click.'],
    ['Kostenlose Lieferung', 'Free Delivery'],
    ['30% Rabatt auf jede Folgebestellung', '30% off every follow-up order'],
    ['Jederzeit pausieren, anpassen oder mit 1 Klick kündigen', 'Pause, adjust, or cancel anytime in 1 click'],
    ['Im 5-teiligen Vorteilspaket enthalten:', 'Included in the 5-piece value bundle:'],
    ['Häufig zusammen gekauft', 'Frequently Bought Together'],
    ['Von Dermatologen empfohlene Routine-Ergänzungen für maximale Ergebnisse:', 'Dermatologist-recommended routine additions for maximum results:'],
    ['+ Hinzufügen', '+ Add'],
    ['Hinzugefügt', 'Added'],
    ['Größe / Variante:', 'Size / Variant:'],
    ['VORTEILSPACK', 'VALUE PACK'],
    ['Schneller Versand: 1-3 Werktage innerhalb Deutschlands & EU', 'Fast Shipping: 1-3 business days delivery via DHL'],
    ['100% Original K-Beauty: Direkt vom autorisierten Hersteller', '100% Authentic K-Beauty: Direct from authorized manufacturer'],
    ['30 Tage Zufriedenheits-Garantie: Risikofrei testen', '30-Day Satisfaction Guarantee: Risk-free trial'],
    ['30-Tage Geld-zurück-Garantie', '30-Day Money-Back Guarantee'],
    ['30 Tage risikofrei testen. Nicht zufrieden? Volle Erstattung – ohne Wenn und Aber.', 'Try risk-free for 30 days. Not satisfied? Full refund – no questions asked.'],
    ['Dazu passt perfekt', 'Pairs Perfectly With'],
    ['Koreas Nr. 1 Peeling- & Poren-Pad', 'Korea\'s #1 Exfoliating & Pore Pad'],
    ['Tiefenregeneration mit Lachs-DNA', 'Deep Cellular Repair with Salmon DNA'],
    ['Hauttyp', 'Skin Type'],
    ['Haartyp', 'Hair Type'],
    ['Hautbedürfnisse', 'Skin Concerns'],
    ['Pflegebedürfnisse', 'Care Needs'],
    ['Hauptwirkstoffe', 'Key Active Ingredients'],

    // Youth Lock Modules
    ['139,00 € GESAMT-EINZELWERT • HEUTE NUR 34,00 €', '€139.00 TOTAL RETAIL VALUE • TODAY ONLY €34.00'],
    ['Was ist im 5-teiligen Komplett-Set enthalten?', 'What is included in the 5-piece complete set?'],
    ['DAS HERO-PRODUKT', 'THE HERO PRODUCT'],
    ['SCHRITT 1', 'STEP 1'],
    ['SCHRITT 2', 'STEP 2'],
    ['SCHRITT 3', 'STEP 3'],
    ['SCHRITT 4', 'STEP 4'],
    ['SCHRITT 5', 'STEP 5'],
    ['HALS & DEKOLLETÉ LIFTING', 'NECK & DÉCOLLETÉ LIFTING'],
    ['KIEFERKONTUR & DOPPELKINN', 'JAWLINE CONTOUR & DOUBLE CHIN'],
    ['AUGEN-DEPOCKING & GLOW', 'EYE DE-PUFFING & GLOW'],
    ['KRÄHENFÜSSE & FALTEN', 'CROW\'S FEET & FINE LINES'],
    ['GLASS-SKIN FINISH', 'GLASS-SKIN FINISH'],
    ['INSTANT GLOW & LIPPEN', 'INSTANT GLOW & LIPS'],
    ['GEZIELTE AUGENPFLEGE', 'TARGETED EYE CARE'],
    ['Einzel-UVP:', 'Separate MSRP:'],
    ['TRANSPARENTER PREISVORTEIL', 'TRANSPARENT VALUE BREAKDOWN'],
    ['SET JETZT SICHERN', 'CLAIM YOUR SET NOW'],
    ['EINFACH & SCHNELL • NUR 5 MINUTEN TÄGLICH', 'FAST & EASY • JUST 5 MINUTES A DAY'],
    ['Deine tägliche 5-Schritte Youth-Lock Routine', 'Your Daily 5-Step Youth-Lock Regimen'],
    ['2–3x / WOCHE • 15 MIN', '2–3x / WEEK • 15 MIN'],
    ['V-Line Band anlegen', 'Apply V-Line Band'],
    ['TÄGLICH MORGENS • 10 MIN', 'DAILY MORNING • 10 MIN'],
    ['Augenpartie entstauen', 'De-Puff Eye Area'],
    ['MORGENS & ABENDS • 30 SEK', 'MORNING & EVENING • 30 SEC'],
    ['Falten präzise glätten', 'Target Fine Lines'],
    ['TÄGLICH • 2 MINUTEN', 'DAILY • 2 MINUTES'],
    ['Gua Sha Neck Massage', 'Gua Sha Neck Massage'],
    ['JEDERZEIT • FINISH & GLOW', 'ANYTIME • FINISH & GLOW'],
    ['Glass-Skin Glow to-go', 'On-The-Go Glass Skin Glow'],
    ['INTEGRIERTES GUA SHA TOOL • KEIN ZERBRECHLICHER STEIN', 'INTEGRATED GUA SHA TOOL • NO FRAGILE JADE STONE'],
    ['Die richtige Gua Sha Technik: So massierst du wie die K-Beauty Profis', 'The Proper Gua Sha Technique: Massage Like Korean Aesthetic Professionals'],
    ['1. Hals-Lifting gegen Tech-Neck', '1. Neck Lift Against Tech-Neck'],
    ['2. Jawline & V-Line Definition', '2. Jawline & V-Line Definition'],
    ['3. Dekolleté & Lymphatische Drainage', '3. Décolleté & Lymphatic Drainage'],
    ['Chirurgischer Edelstahl (Kühlend & Desinfizierbar)', 'Surgical Stainless Steel (Cooling & Easy to Sanitize)'],
    ['Hygienischer Dreh-Verschluss (Kein Auslaufen)', 'Hygienic Twist Lock (Zero Leakage)'],
    ['Präzise Dosierung während der Massage', 'Precise Dispensing During Massage'],
    ['Faltentiefe an den horizontalen Halslinien nach 14 Tagen', 'Wrinkle depth on horizontal neck lines after 14 days'],
    ['DERMATOLOGISCHE KLINIK-FORMEL', 'DERMATOLOGICAL CLINICAL FORMULATION'],
    ['Die Dual-Action-Wissenschaft hinter dem Set', 'The Dual-Action Science Behind the Set'],
    ['Zelluläre DNA-Reparatur', 'Cellular DNA Repair'],
    ['Natürlicher Aufpolsterungs-Effekt', 'Natural Tissue Plumping Effect'],
    ['Gefäß- und Gewebestimulation', 'Vascular & Tissue Stimulation'],
    ['KLINISCH GETESTET AN 34 PROBANDINNEN (4 WOCHEN)', 'CLINICALLY TESTED ON 34 PARTICIPANTS (4 WEEKS)'],
    ['Messbare Ergebnisse statt leerer Versprechen', 'Measurable Clinical Results, Not Empty Promises'],
    ['Straffere Kinnlinie & V-Kontur', 'Firmer Jawline & V-Contour'],
    ['Glattere Hals- & Dekolleté-Zone', 'Smoother Neck & Décolleté Area'],
    ['Sofortige Frische & Kühleffekt', 'Instant Freshness & Cooling Relief'],
    ['HÄUFIG GESTELLTE FRAGEN', 'FREQUENTLY ASKED QUESTIONS'],
    ['Alles, was du über das 5-teilige Set wissen musst', 'Everything You Need to Know About the 5-Piece Set'],
    ['In welcher genauen Reihenfolge soll ich die 5 Produkte anwenden?', 'In what exact order should I apply the 5 products?'],
    ['Riecht das Produkt nach Fisch, weil PDRN aus Lachs gewonnen wird?', 'Does the product smell like fish since PDRN is derived from salmon?'],
    ['Kann ich das Set mit meinem AGE-R Booster Pro oder anderen Schönheitsgeräten kombinieren?', 'Can I combine this set with my AGE-R Booster Pro or other beauty devices?'],
    ['Ist das Set für empfindliche oder zu Unreinheiten neigende Haut geeignet?', 'Is this set suitable for sensitive or acne-prone skin?'],
    ['Wie lange reicht ein 5-teiliges Set aus?', 'How long does a 5-piece set last?'],
    ['LIMITIERTE AKTION • 75% RABATT', 'LIMITED OFFER • 75% OFF'],
    ['Bereit für deine straffeste Kontur & jugendlichen Glow?', 'Ready for your firmest contour & youthful glow?'],
    ['Hol dir jetzt alle 5 K-Beauty Bestseller im Vorteilspaket für nur', 'Get all 5 K-Beauty bestsellers in the exclusive value bundle for only'],
    ['statt 139,00 € UVP', 'instead of €139.00 MSRP'],
    ['30 Tage Geld-zurück-Garantie', '30-Day Money-Back Guarantee'],
    ['Schneller DHL-Versand (1-3 Tage)', 'Fast DHL Shipping (1-3 Days)'],

    // Customer Reviews
    ['Kundenbewertungen', 'Customer Reviews'],
    ['Verifizierte Erfahrungen', 'Verified Experiences'],
    ['Bewertung schreiben', 'Write a Review'],
    ['5 Sterne', '5 Stars'],
    ['4 Sterne', '4 Stars'],
    ['3 Sterne', '3 Stars'],
    ['2 Sterne', '2 Stars'],
    ['1 Stern', '1 Star'],
    ['Basierend auf', 'Based on'],
    ['verifizierten Bewertungen', 'verified reviews'],
    ['Verifiziert', 'Verified'],
    ['Hilfreich', 'Helpful'],

    // Accordions / Tabs
    ['Vorteile & Wirkung', 'Benefits & Efficacy'],
    ['Klinische Studien & Wirksamkeit', 'Clinical Studies & Results'],
    ['Reinheitsgarantie & Inhaltsstoffe', 'Clean Formula & Ingredients'],
    ['Anwendung & Routine-Schritte', 'How to Use & Routine Steps'],
    ['Häufig gestellte Fragen (FAQ)', 'Frequently Asked Questions (FAQ)'],
    ['Vorteile des Abonnements (30% Rabatt)', 'Subscription Benefits (30% Off)'],
    ['✓ Ohne Duftstoffe', '✓ Fragrance-Free'],
    ['✓ Ohne Parabene', '✓ Paraben-Free'],
    ['✓ Ohne Silikone', '✓ Silicone-Free'],
    ['✓ Ohne Sulfate', '✓ Sulfate-Free'],
    ['✓ Cruelty-Free', '✓ Cruelty-Free'],
    ['✓ Nicht-komedogen', '✓ Non-Comedogenic'],

    // Cart Drawer
    ['Dein Warenkorb ist noch leer', 'Your cart is currently empty'],
    ['Dein Warenkorb', 'Your Cart'],
    ['Warenkorb', 'Cart'],
    ['ZUR KASSE • SICHERE ZAHLUNG', 'CHECKOUT • SECURE PAYMENT'],
    ['Zur Kasse', 'Checkout'],
    ['Kostenloser Versand freigeschaltet!', 'Free shipping unlocked!'],

    // Homepage
    ['Jetzt im Trend:', 'Trending Now:'],
    ['Koreanische Skincare', 'Korean Skincare'],
    ['Geräte', 'Devices'],
    ['ALLE ANZEIGEN', 'VIEW ALL'],
    ['JETZT SHOPPEN', 'SHOP NOW'],
    ['Jetzt shoppen', 'Shop Now'],
    ['ECHTE ERFAHRUNGEN UNSERER COMMUNITY', 'REAL EXPERIENCES FROM OUR COMMUNITY'],
    ['100% dermatologisch', '100% Dermatologist'],
    ['getestet.', 'Tested.'],
    ['Klinisch bewiesene<br>K-Beauty Formeln.', 'Clinically Proven<br>K-Beauty Formulas.'],
    ['Klinisch bewiesene K-Beauty Formeln.', 'Clinically proven K-Beauty formulas.'],

    // Additional Homepage & Category Elements
    ['Echtheits-Guide', 'Authenticity Guide'],
    ['ECHTHEITS-GUIDE', 'AUTHENTICITY GUIDE'],
    ['Abo & Sparen', 'Subscribe & Save'],
    ['ABO & SPAREN', 'SUBSCRIBE & SAVE'],
    ['Anleitung', 'Instructions'],
    ['ANLEITUNG', 'INSTRUCTIONS'],
    ['Glow Kollagen', 'Glow Collagen'],
    ['GLOW KOLLAGEN', 'GLOW COLLAGEN'],
    ['Deep Vita C', 'Deep Vitamin C'],
    ['DEEP VITA C', 'DEEP VITAMIN C'],
    ['Kojic Acid Linie', 'Kojic Acid Line'],
    ['KOJIC ACID LINIE', 'KOJIC ACID LINE'],
    ['Pink PDRN Linie', 'Pink PDRN Line'],
    ['PINK PDRN LINIE', 'PINK PDRN LINE'],
    ['TXA Linie', 'TXA Line'],
    ['TXA LINIE', 'TXA LINE'],
    ['Clear Beruhigung', 'Clear Soothing'],
    ['CLEAR BERUHIGUNG', 'CLEAR SOOTHING'],
    ['GERÄTE', 'DEVICES'],
    ['Geräte', 'Devices'],
    ['FEUCHTIGKEIT', 'HYDRATION'],
    ['Feuchtigkeit', 'Hydration'],
    ['AUFHELLUNG & GLOW', 'BRIGHTENING & GLOW'],
    ['Aufhellung & Glow', 'Brightening & Glow'],
    ['POREN & PEELING', 'PORES & PEELING'],
    ['Poren & Peeling', 'Pores & Peeling'],
    ['Poren & Unreinheiten', 'Pores & Blemishes'],
    ['Feine Linien & Falten', 'Fine Lines & Wrinkles'],
    ['Pigmentflecken & Ebenmäßigkeit', 'Dark Spots & Even Tone'],
    ['Strahlkraft & Glass Glow', 'Radiance & Glass Glow'],
    ['Rötungen & Sensible Haut', 'Redness & Sensitive Skin'],
    ['Exosome Cica Linie', 'Exosome Cica Line'],
    ['7-in-1 Komplettlösung', '7-in-1 Total Solution'],
    ['3-in-1 K-Beauty Gesichtsgerät', '3-in-1 K-Beauty Facial Device'],
    ['High-Tech Dual-Energie', 'High-Tech Dual Energy'],
    ['Booster Pro X2™\n7-in-1 Total Solution Gerät', 'Booster Pro X2™\n7-in-1 Total Solution Device'],
    ['Booster Pro X2™ 7-in-1 Total Solution Gerät', 'Booster Pro X2™ 7-in-1 Total Solution Device'],
    ['7-in-1 Total Solution Gerät', '7-in-1 Total Solution Device'],
    ['Entdecke deinen jugendlichen Glow\n2x mehr Glow, Festigkeit, Kontur & Porenverfeinerung', 'Unlock your youthful glow\n2x more radiance, firmness, contouring & pore refinement'],
    ['Entdecke deinen jugendlichen Glow 2x mehr Glow, Festigkeit, Kontur & Porenverfeinerung', 'Unlock your youthful glow 2x more radiance, firmness, contouring & pore refinement'],
    ['Erwecke deinen Glow\nüber Nacht', 'Awaken your glow\novernight'],
    ['Erwecke deinen Glow über Nacht', 'Awaken your glow overnight'],
    ['Entwickelt, um die Elastizität deiner Haut während des Schlafs intensiv zu nähren und zu schützen.', 'Formulated to intensively nourish and protect skin elasticity while you sleep.'],
    ['Reine Poren, klares Hautbild', 'Poreless, crystal-clear skin'],
    ['K-BEAUTY #1 POREN-PADS\nEinfache & effektive Pflege für sichtbar verfeinerte Poren', 'K-BEAUTY #1 PORE CARE PADS\nSimple & effective care for visibly refined pores'],
    ['K-BEAUTY #1 POREN-PADS Einfache & effektive Pflege für sichtbar verfeinerte Poren', 'K-BEAUTY #1 PORE CARE PADS Simple & effective care for visibly refined pores'],
    ['Perfekter Glass Glow\nfür den ganzen Tag', 'Flawless glass glow\nall day long'],
    ['Perfekter Glass Glow für den ganzen Tag', 'Flawless glass glow all day long'],
    ['Das individuelle Kollagen-Duo für strahlende, tiefenhydratisierte und jugendliche Haut.', 'The custom collagen duo for radiant, deeply hydrated, and youthful skin.'],
    ['Vorherige Produkte', 'Previous products'],
    ['Nächste Produkte', 'Next products'],
    ['100% Dermatologisch getestet', '100% Dermatologist tested'],
    ['Revolutionäres Beauty-Gerät für straffe & klare Haut', 'Revolutionary beauty device for firm & clear skin'],
    ['Entdecke Tatis liebstes Beauty-Geheimnis! Ein absoluter Gamechanger für tägliche professionelle Behandlungen zu Hause.', 'Discover Tati\'s favorite beauty secret! An absolute game changer for daily professional treatments at home.'],
    ['Koreanischer Glass-Glow Look mit MediCube', 'Korean glass-glow look with MediCube'],
    ['8,7 Mio. Abonnenten Beauty-Ikone Michelle Phans Skincare Hack für maximalen Feuchtigkeits-Glow und jugendliche Frische.', '8.7M subscriber beauty icon Michelle Phan\'s skincare hack for maximum hydration glow and youthful freshness.'],
    ['Definierte Gesichtskonturen & straffere Jawline', 'Defined facial contours & firmer jawline'],
    ['Erfahre, wie du deine Gesichtskonturen sichtbar straffst und feine Linien mit der AGE-R Technologie reduzierst.', 'Learn how to visibly firm your facial contours and reduce fine lines with AGE-R technology.'],
    ['Ein lebensveränderndes K-Beauty Skincare Gerät!', 'A life-changing K-beauty skincare device!'],
    ['4,6 Mio. YouTube Star Laura Lees absoluter Heiliger Gral für makellose, ebenmäßige und tiefenreine Haut.', '4.6M YouTube star Laura Lee\'s absolute holy grail for flawless, even, and deeply purified skin.']
  ];

  // ---------------------------------------------------------------
  // FINNISH (FI) HIGH-PRECISION TEXT REPLACEMENT TABLE
  // Maps both German and English source strings directly to Finnish
  // ---------------------------------------------------------------
  window.MC_FI_PHRASES = [
    // AGE-R Devices Dropdown Subtitles
    ['6-in-1 Klinische Pflege (Neuheit)', '6-in-1 Kliininen hoito (Uutuus)'],
    ['Bestseller Elektroporation & EMS', 'Bestseller • Elektroporaatio & EMS'],
    ['40.68 MHz Radiofrequenz Kollagenboost', '40.68 MHz Radiotaajuus-kollageeniboosti'],
    ['Kompakter Glow für unterwegs', 'Kompakti hehku mukaan'],
    ['Klärende Körperpflege & Blemish-Control', 'Kirkastava vartalonhoito & epäpuhtauksien hallinta'],

    // Hypochlorous Bundle Selector & Tiers
    ['Pflegeroutine wählen:', 'Valitse rutiinisi:'],
    ['🔥 87% wählen das Bestseller-Set', '🔥 87% valitsee Bestseller-setin'],
    ['Bestseller-Set', 'Bestseller-setti'],
    ['Bestseller-Duo', 'Bestseller-duo'],
    ['/ Produkt • 330ml Routine', '/ tuote • 330ml rutiini'],
    ['/ Flasche • 560ml Vorrat', '/ pullo • 560ml pakkaus'],
    ['Sanftes Peeling für den Körper gegen Unreinheiten & Blemishes', 'Hellävarainen vartalokuorinta epäpuhtauksia vastaan'],
    ['Konzentriertes Klärendes Peeling-Serum für das Gesicht', 'Konsentroitu kirkastava kuorintaseerumi kasvoille'],
    ['Beinhaltet BEIDE Produkte • Maximale Ergebnisse & Glass-Skin-Glow', 'Sisältää MOLEMMAT tuotteet • Maksimaaliset tulokset & glass-skin -hehku'],
    ['Vorratspack für maximale Langzeitergebnisse • Spare zusätzlich 7 €', 'Säästöpakkaus pitkäaikaistuloksiin • Säästä vielä 7 €'],
    ['🔥 BESTSELLER-SET • SPARE 23%', '🔥 BESTSELLER-SETTI • SÄÄSTÄ 23%'],
    ['🔥 BESTSELLER — 20% RABATT', '🔥 BESTSELLER — 20% ALENNUS'],
    ['💎 MAXIMALER VORTEIL • SPARE 31%', '💎 SUURIN ETU • SÄÄSTÄ 31%'],
    ['Wähle deine Pflegeroutine.', 'Valitse ihonhoitorutiinisi.'],
    ['DAS OPTIMALE SET', 'OPTIMAALINEN SETTI'],
    ['Hol dir das Komplett-Duo für Gesicht & Körper und spare 23% gegenüber dem Einzelkauf.', 'Hanki täydellinen duo kasvoille ja vartalolle ja säästä 23% erillishintaan verrattuna.'],
    ['Mit dem Bestseller-Duo sparst du 20 %', 'Bestseller-duolla säästät 20 %'],
    ['AB 30 JAHREN (BESTSELLER)', 'YLI 30-VUOTIAILLE (BESTSELLERI)'],
    ['originalen koreanischen Bestsellern', 'alkuperäisiin korealaisiin bestsellereihin'],
    ['ausgewählte MediCube Skincare-Bestseller.', 'valikoituja MediCube-ihonhoitobestsellereitä.'],
    ['Entdecke unsere meistverkauften K-Beauty Bestseller und starte deine Hautpflege-Routine.', 'Löydä myydyimmät K-Beauty-bestsellerimme ja aloita ihonhoitorutiinisi.'],
    ['Bestseller für maximale Ergebnisse & sofortigen Glow', 'Bestsellerit maksimaalisiin tuloksiin & välittömään hehkuun'],
    ['Alle Bestseller ansehen', 'Katso kaikki bestsellerit'],
    ['Perfekt abgestimmte K-Beauty Bestseller für deine tägliche Pflegeroutine.', 'Täydellisesti yhteensovitetut K-Beauty-bestsellerit päivittäiseen rutiiniisi.'],
    ['KÖRPERPFLEGE', 'VARTALONHOITO'],
    ['-30% RABATT', '30% ALENNUS'],
    ['Rice Body Peel Shot (280ml)', 'Rice Body Peel Shot (280ml)'],
    ['Rice Face Peel Shot (50ml)', 'Rice Face Peel Shot (50ml)'],
    ['Komplettes Duo-Set (Body + Face)', 'Täydellinen Duo-setti (Vartalo + Kasvot)'],
    ['2x Komplettes Duo-Set (2x Body + 2x Face)', '2x Täydellinen Duo-setti (2x Vartalo + 2x Kasvot)'],

    // Hypochlorous Benefits, Routine, Clinical & FAQ
    ['🔬 DERMATOLOGISCHE INNOVATION', '🔬 DERMATOLOGINEN INNOVAATIO'],
    ['Die Kraft von Hypochlorous Acid & koreanischem Reis-Extrakt', 'Hypokloorihapokkeen & korealaisen riisiuutteen voima'],
    ['Klärende Anti-Blemish Formel', 'Kirkastava anti-blemish -koostumus'],
    ['Mikro-Peeling & Textur-Glättung', 'Mikrokuorinta & ihon silotus'],
    ['Oryza Sativa Reis-Glow', 'Oryza Sativa -riisihehku'],
    ['100% Barriere-Schonend', '100% ihosuojalle hellävarainen'],
    ['📊 KLINISCH ERWIESENE WIRKUNG', '📊 KLIINISESTI TODISTETTU TEHO'],
    ['Sichtbare Ergebnisse ab der 1. Anwendung', 'Näkyviä tuloksia 1. käyttökerrasta'],
    ['Weniger Unreinheiten & Pickel', 'Vähemmän epäpuhtauksia & näppylöitä'],
    ['Verfeinerte Poren & Talgkontrolle', 'Pienemmät ihohuokoset & talitasapaino'],
    ['Glattere, ebenmäßige Hauttextur', 'Sileämpi, tasaisempi ihon pinta'],
    ['0.00% Reizungsindex • Hypoallergen getestet • Für empfindlichste Hauttypen geeignet', '0.00% ärsytysindeksi • Hypoallergeenisesti testattu • Sopii herkimmällekin iholle'],
    ['✨ ANWENDUNGS-ROUTINE', '✨ KÄYTTÖRUTIINI'],
    ['So wendest du das Hypochlorous Acid System an', 'Näin käytät Hypochlorous Acid -järjestelmää'],
    ['KÖRPERPFLEGE (DUSCHE)', 'VARTALONHOITO (SUIHKUSSA)'],
    ['GESICHTSPFLEGE (SERUM)', 'KASVONHOITO (SEERUMI)'],
    ['BARRIERE & HYDRATION', 'IHOSUOJA & KOSTEUTUS'],
    ['Feuchtigkeit & Schutz', 'Kosteutus & suoja'],
    ['📅 Anwendung: 2–3x pro Woche', '📅 Käyttö: 2–3x viikossa'],
    ['📅 Anwendung: Täglich (Morgens & Abends)', '📅 Käyttö: Päivittäin (Aamuin & Illoin)'],
    ['📅 Anwendung: Im Anschluss an Schritt 2', '📅 Käyttö: Vaiheen 2 jälkeen'],
    ['❓ HÄUFIGE FRAGEN', '❓ USEIN KYSYTYT KYSYMYKSET'],
    ['Fragen & Antworten zum Hypochlorous System', 'Kysymyksiä & vastauksia Hypochlorous -järjestelmästä'],


    // Header & Navigation
    ['⚡ KOSTENLOSER DHL-VERSAND • 30 TAGE GELD-ZURÜCK-GARANTIE ⚡', '⚡ ILMAINEN DHL-TOIMITUS • 30 PÄIVÄN TYYTYVÄISYYSTAKUU ⚡'],
    ['⚡ FREE DHL SHIPPING • 30-DAY MONEY-BACK GUARANTEE ⚡', '⚡ ILMAINEN DHL-TOIMITUS • 30 PÄIVÄN TYYTYVÄISYYSTAKUU ⚡'],
    ['AGE-R Beauty Tech Geräte', 'AGE-R -kauneudenhoitolaitteet'],
    ['AGE-R Beauty Devices', 'AGE-R -kauneudenhoitolaitteet'],
    ['Hautpflege-Linien', 'Ihonhoitosarjat'],
    ['Skincare Lines', 'Ihonhoitosarjat'],
    ['Hautpflege', 'Ihonhoito'],
    ['Skincare', 'Ihonhoito'],
    ['Zero Poren-Linie (Poren & Sebum)', 'Zero Pore -sarja (Ihohuokoset & tali)'],
    ['Zero Pore Line (Pores & Sebum)', 'Zero Pore -sarja (Ihohuokoset & tali)'],
    ['Zero Poren-Linie', 'Zero Pore -sarja'],
    ['Zero Pore Line', 'Zero Pore -sarja'],
    ['Triple Collagen & Glow (Straffung & Elastizität)', 'Triple Collagen & Glow (Kiinteytys & kimmoisuus)'],
    ['Triple Collagen & Glow (Lifting & Firmness)', 'Triple Collagen & Glow (Kiinteytys & kimmoisuus)'],
    ['Triple Collagen & Glow (Firming & Elasticity)', 'Triple Collagen & Glow (Kiinteytys & kimmoisuus)'],
    ['Triple Collagen & Glow', 'Triple Collagen & Glow'],
    ['Pink PDRN Linie (Barriere & Peptide)', 'Pink PDRN -sarja (Ihosuoja & peptidit)'],
    ['Pink PDRN Line (Barrier & Peptides)', 'Pink PDRN -sarja (Ihosuoja & peptidit)'],
    ['Pink PDRN Regeneration', 'Pink PDRN -uudistus'],
    ['Pink PDRN Linie', 'Pink PDRN -sarja'],
    ['Pink PDRN Line', 'Pink PDRN -sarja'],
    ['Exosome Super Cica (Beruhigung)', 'Exosome Super Cica (Rauhoittava)'],
    ['Exosome Super Cica (Calming & Soothing)', 'Exosome Super Cica (Rauhoittava)'],
    ['Exosome Super Cica', 'Exosome Super Cica'],
    ['Deep Vitamin C (Anti-Aging & Flecken)', 'Deep Vitamin C (Anti-Aging & hehku)'],
    ['Deep Vitamin C (Anti-Aging & Radiance)', 'Deep Vitamin C (Anti-Aging & hehku)'],
    ['Deep Vitamin C Anti-Aging', 'Deep Vitamin C Anti-Aging'],
    ['Red Akne-Linie (Unreine Haut)', 'Red Acne -sarja (Epäpuhtauksien hoito)'],
    ['Red Acne Line (Blemish Care)', 'Red Acne -sarja (Epäpuhtauksien hoito)'],
    ['Red Akne-Pflege', 'Red Acne -hoito'],
    ['Red Acne Care', 'Red Acne -hoito'],
    ['TXA & Kojisäure (Aufhellung)', 'TXA & kojiinihappo (Kirkastava)'],
    ['TXA & Kojic Acid (Brightening)', 'TXA & kojiinihappo (Kirkastava)'],
    ['TXA & Kojisäure Aufhellung', 'TXA & kojiinihappo kirkastus'],
    ['Nach Pflegelinie', 'Ihonhoitosarjan mukaan'],
    ['By Skincare Line', 'Ihonhoitosarjan mukaan'],
    ['Nach Kategorie', 'Kategorian mukaan'],
    ['By Category', 'Kategorian mukaan'],
    ['Reinigung & Cleanser', 'Puhdistustuotteet'],
    ['Cleansers & Cleansing', 'Puhdistustuotteet'],
    ['Toner & Peeling-Pads', 'Kasvovedet & kuorintalaput'],
    ['Toners & Exfoliating Pads', 'Kasvovedet & kuorintalaput'],
    ['Seren & Ampullen', 'Seerumit & ampullit'],
    ['Serums & Ampoules', 'Seerumit & ampullit'],
    ['Cremes & Feuchtigkeit', 'Voiteet & kosteutus'],
    ['Creams & Moisturizers', 'Voiteet & kosteutus'],
    ['Gesichtsmasken & Wrapping', 'Kangasnaamiot & wrapping-naamiot'],
    ['Sheet Masks & Night Wrapping', 'Kangasnaamiot & wrapping-naamiot'],
    ['Sheet Masks & Wrapping', 'Kangasnaamiot & wrapping-naamiot'],
    ['Sonnenschutz (SPF)', 'Aurinkosuoja (SPF)'],
    ['Sun Protection (SPF)', 'Aurinkosuoja (SPF)'],
    ['Sets & Duos', 'Setit & tuotepaketit'],
    ['Sets & Bundles', 'Setit & tuotepaketit'],
    ['Vorteils-Sets & Duos', 'Etu-setit & pakkaukset'],
    ['Value Sets & Bundles', 'Etu-setit & pakkaukset'],
    ['Bestseller', 'Bestsellerit'],
    ['Bestsellers', 'Bestsellerit'],
    ['AGE-R Guide & Anleitung', 'AGE-R -opas & käyttöohjeet'],
    ['AGE-R Guide & Instructions', 'AGE-R -opas & käyttöohjeet'],
    ['Über uns', 'Tietoa meistä'],
    ['About Us', 'Tietoa meistä'],
    ['Hilfe & Kundenservice', 'Asiakaspalvelu & tuki'],
    ['Help & Support', 'Asiakaspalvelu & tuki'],
    ['Hilfe & Kontakt', 'Asiakaspalvelu & tuki'],
    ['Help & Contact', 'Asiakaspalvelu & tuki'],
    ['Mein Konto / Anmelden', 'Oma tili / Kirjaudu sisään'],
    ['My Account / Sign In', 'Oma tili / Kirjaudu sisään'],
    ['Alle Produkte', 'Kaikki tuotteet'],
    ['All Products', 'Kaikki tuotteet'],
    ['Geräte-Leitgele & Zubehör →', 'Laitteiden geelit & tarvikkeet →'],
    ['Device Gels & Accessories →', 'Laitteiden geelit & tarvikkeet →'],
    ['Alle Technologien im Überblick →', 'Tutustu kaikkiin teknologioihin →'],
    ['Explore All Technologies →', 'Tutustu kaikkiin teknologioihin →'],

    // PDP Above the Fold & Pricing
    ['🔥 5-TEILIGES KOMPLETT-SET • 105 € SPAREN (75% VORTEIL)', '🔥 5-OSAINEN TÄYDELLINEN SETTI • SÄÄSTÄ 105 € (75% ALENNUS)'],
    ['🔥 5-PIECE COMPLETE SET • SAVE €105 (75% OFF)', '🔥 5-OSAINEN TÄYDELLINEN SETTI • SÄÄSTÄ 105 € (75% ALENNUS)'],
    ['SPAREN 75%', 'SÄÄSTÄ 75%'],
    ['SAVE 75%', 'SÄÄSTÄ 75%'],
    ['SPAREN 24%', 'SÄÄSTÄ 24%'],
    ['SAVE 24%', 'SÄÄSTÄ 24%'],
    ['SPAREN 31%', 'SÄÄSTÄ 31%'],
    ['SAVE 31%', 'SÄÄSTÄ 31%'],
    ['139,00 € UVP', '139,00 € OVH'],
    ['€139.00 MSRP', '139,00 € OVH'],
    ['34,00 € KOMPLETT-SET', '34,00 € TÄYDELLINEN SETTI'],
    ['€34.00 COMPLETE SET', '34,00 € TÄYDELLINEN SETTI'],
    ['Wissenschaftlich fundiert', 'Tieteellisesti todistettu'],
    ['Backed by Science', 'Tieteellisesti todistettu'],
    ['80+ von Experten begutachtete Studien hinter unserer Formel.', 'Yli 80 vertaisarvioitua tutkimusta tukee koostumustamme.'],
    ['80+ peer-reviewed studies supporting our formula.', 'Yli 80 vertaisarvioitua tutkimusta tukee koostumustamme.'],
    ['Studien ansehen & mehr erfahren', 'Katso tutkimukset & lue lisää'],
    ['View studies & learn more', 'Katso tutkimukset & lue lisää'],
    ['Oder in 3 zinsfreien Raten von', 'Tai 3 korotonta erää'],
    ['Or 3 interest-free installments of', 'Tai 3 korotonta erää'],
    ['mit Klarna', 'Klarnalla'],
    ['with Klarna', 'Klarnalla'],
    ['Mehr erfahren', 'Lue lisää'],
    ['Learn more', 'Lue lisää'],
    ['IN DEN WARENKORB', 'LISÄÄ OSTOSKORIIN'],
    ['ADD TO CART', 'LISÄÄ OSTOSKORIIN'],
    ['In den Warenkorb', 'Lisää ostoskoriin'],
    ['Add to Cart', 'Lisää ostoskoriin'],
    ['Add to cart', 'Lisää ostoskoriin'],
    ['Wird hinzugefügt...', 'Lisätään...'],
    ['Adding...', 'Lisätään...'],
    ['AUSVERKAUFT', 'LOPPUUNMYYTY'],
    ['SOLD OUT', 'LOPPUUNMYYTY'],
    ['Ausverkauft', 'Loppuunmyyty'],
    ['Sold Out', 'Loppuunmyyty'],
    ['Sold out', 'Loppuunmyyty'],
    ['LIMITIERTES TAGESANGEBOT', 'PÄIVÄN RAJOITETTU TARJOUS'],
    ['LIMITED DAILY OFFER', 'PÄIVÄN RAJOITETTU TARJOUS'],
    ['Aktion endet in:', 'Tarjous päättyy:'],
    ['Deal ends in:', 'Tarjous päättyy:'],
    ['Pflegeroutine wählen:', 'Valitse rutiinisi:'],
    ['Choose your routine:', 'Valitse rutiinisi:'],
    ['🔥 87% wählen das Bestseller-Set', '🔥 87% valitsee Bestseller-setin'],
    ['🔥 87% choose the Bestseller Set', '🔥 87% valitsee Bestseller-setin'],
    ['1x Body Peel', '1x Body Peel'],
    ['280ml • Sanftes Körperpeeling', '280ml • Hellävarainen vartalokuorinta'],
    ['280ml • Gentle Body Exfoliator', '280ml • Hellävarainen vartalokuorinta'],
    ['1x Face Peel', '1x Face Peel'],
    ['50ml • Klärendes Gesichtsserum', '50ml • Kirkastava kasvoseerumi'],
    ['50ml • Clarifying Facial Serum', '50ml • Kirkastava kasvoseerumi'],
    ['Duo-Set (Body + Face)', 'Duo-setti (Vartalo + Kasvot)'],
    ['Duo Set (Body + Face)', 'Duo-setti (Vartalo + Kasvot)'],
    ['+ 1 GRATIS', '+ 1 ILMAINEN'],
    ['+ 1 FREE', '+ 1 ILMAINEN'],
    ['2x Body Peel Doppelpack', '2x Body Peel -säästöpakkaus'],
    ['2x Body Peel Value Pack', '2x Body Peel -säästöpakkaus'],
    ['+ 2 GRATIS', '+ 2 ILMAISTA'],
    ['+ 2 FREE', '+ 2 ILMAISTA'],
    ['🔥 Meistgewählt', '🔥 Suosituin'],
    ['🔥 Most Popular', '🔥 Suosituin'],
    ['💎 Bester Wert', '💎 Paras arvo'],
    ['💎 Best Value', '💎 Paras arvo'],
    ['Spare 11,95 €', 'Säästä 11,95 €'],
    ['Save €11.95', 'Säästä 11,95 €'],
    ['Spare 8,00 €', 'Säästä 8,00 €'],
    ['Save €8.00', 'Säästä 8,00 €'],
    ['Spare 30,95 €', 'Säästä 30,95 €'],
    ['Save €30.95', 'Säästä 30,95 €'],
    ['DEINE GESCHENKE ZUR BESTELLUNG', 'ILMAISET LAHJASI TILAUKSEEN'],
    ['YOUR FREE GIFTS WITH PURCHASE', 'ILMAISET LAHJASI TILAUKSEEN'],
    ['Kostenloser Versand', 'Ilmainen toimitus'],
    ['Free Shipping', 'Ilmainen toimitus'],
    ['1x GRATIS Flasche', '1x ILMAINEN pullo'],
    ['1x FREE Bottle', '1x ILMAINEN pullo'],
    ['2x GRATIS Flaschen', '2x ILMAISTA pulloa'],
    ['2x FREE Bottles', '2x ILMAISTA pulloa'],
    ['🔒 Ab 2x Vorrat', '🔒 Avautuu 2 kpl tilauksella'],
    ['🔒 Unlocks with 2x Supply', '🔒 Avautuu 2 kpl tilauksella'],
    ['Abo & Sparen (30% Rabatt)', 'Tilaa & säästä (30% alennus)'],
    ['Subscribe & Save (30% Off)', 'Tilaa & säästä (30% alennus)'],
    ['30% Dauerrabatt auf jede Folgelieferung. Jederzeit mit 1 Klick kündbar.', '30% jatkuva alennus jokaiseen toimitukseen. Peruuta milloin vain 1 klikkauksella.'],
    ['30% recurring discount on every auto-delivery. Cancel anytime in 1 click.', '30% jatkuva alennus jokaiseen toimitukseen. Peruuta milloin vain 1 klikkauksella.'],
    ['Kostenlose Lieferung', 'Ilmainen toimitus'],
    ['Free Delivery', 'Ilmainen toimitus'],
    ['30% Rabatt auf jede Folgebestellung', '30% alennus kaikista jatkotilauksista'],
    ['30% off every follow-up order', '30% alennus kaikista jatkotilauksista'],
    ['Jederzeit pausieren, anpassen oder mit 1 Klick kündigen', 'Pidä taukoa, muuta tai peruuta milloin vain 1 klikkauksella'],
    ['Pause, adjust, or cancel anytime in 1 click', 'Pidä taukoa, muuta tai peruuta milloin vain 1 klikkauksella'],
    ['Im 5-teiligen Vorteilspaket enthalten:', 'Sisältyy 5-osaiseen etupakettiin:'],
    ['Included in the 5-Piece Value Bundle:', 'Sisältyy 5-osaiseen etupakettiin:'],
    ['Included in the 5-piece value bundle:', 'Sisältyy 5-osaiseen etupakettiin:'],
    ['Häufig zusammen gekauft', 'Ostetaan usein yhdessä'],
    ['Frequently Bought Together', 'Ostetaan usein yhdessä'],
    ['Von Dermatologen empfohlene Routine-Ergänzungen für maximale Ergebnisse:', 'Ihotautilääkärien suosittelemat rutiinilisät maksimaalisiin tuloksiin:'],
    ['Dermatologist-recommended routine additions for maximum results:', 'Ihotautilääkärien suosittelemat rutiinilisät maksimaalisiin tuloksiin:'],
    ['+ Hinzufügen', '+ Lisää'],
    ['+ Add', '+ Lisää'],
    ['Hinzugefügt', 'Lisätty'],
    ['Added', 'Lisätty'],
    ['Größe / Variante:', 'Koko / Versio:'],
    ['Size / Variant:', 'Koko / Versio:'],
    ['VORTEILSPACK', 'SÄÄSTÖPAKKAUS'],
    ['VALUE PACK', 'SÄÄSTÖPAKKAUS'],
    ['Schneller Versand: 1-3 Werktage innerhalb Deutschlands & EU', 'Nopea toimitus: 1-3 arkipäivää DHL:llä'],
    ['Fast Shipping: 1-3 business days delivery via DHL', 'Nopea toimitus: 1-3 arkipäivää DHL:llä'],
    ['100% Original K-Beauty: Direkt vom autorisierten Hersteller', '100% aito K-Beauty: Suoraan valtuutetulta valmistajalta'],
    ['100% Authentic K-Beauty: Direct from authorized manufacturer', '100% aito K-Beauty: Suoraan valtuutetulta valmistajalta'],
    ['30 Tage Zufriedenheits-Garantie: Risikofrei testen', '30 päivän tyytyväisyystakuu: Kokeile riskittömästi'],
    ['30-Day Satisfaction Guarantee: Risk-free trial', '30 päivän tyytyväisyystakuu: Kokeile riskittömästi'],
    ['30-Tage Geld-zurück-Garantie', '30 päivän rahat takaisin -takuu'],
    ['30-Day Money-Back Guarantee', '30 päivän rahat takaisin -takuu'],
    ['30 Tage risikofrei testen. Nicht zufrieden? Volle Erstattung – ohne Wenn und Aber.', 'Kokeile riskittömästi 30 päivää. Etkö ole tyytyväinen? Täysi hyvitys – ilman kysymyksiä.'],
    ['Try risk-free for 30 days. Not satisfied? Full refund – no questions asked.', 'Kokeile riskittömästi 30 päivää. Etkö ole tyytyväinen? Täysi hyvitys – ilman kysymyksiä.'],
    ['Dazu passt perfekt', 'Sopii täydellisesti yhteen'],
    ['Pairs Perfectly With', 'Sopii täydellisesti yhteen'],
    ['Koreas Nr. 1 Peeling- & Poren-Pad', 'Korean #1 kuorinta- ja huokoslappu'],
    ['Korea\'s #1 Exfoliating & Pore Pad', 'Korean #1 kuorinta- ja huokoslappu'],
    ['Tiefenregeneration mit Lachs-DNA', 'Syväsolujen uudistus lohi-PDRN:llä'],
    ['Deep Cellular Repair with Salmon DNA', 'Syväsolujen uudistus lohi-PDRN:llä'],
    ['Hauttyp', 'Ihotyyppi'],
    ['Skin Type', 'Ihotyyppi'],
    ['Haartyp', 'Hiustyyppi'],
    ['Hair Type', 'Hiustyyppi'],
    ['Hautbedürfnisse', 'Iho-ongelmat'],
    ['Skin Concerns', 'Iho-ongelmat'],
    ['Pflegebedürfnisse', 'Hoitotarpeet'],
    ['Care Needs', 'Hoitotarpeet'],
    ['Hauptwirkstoffe', 'Tärkeimmät tehoaineet'],
    ['Key Active Ingredients', 'Tärkeimmät tehoaineet'],

    // Youth Lock Modules
    ['139,00 € GESAMT-EINZELWERT • HEUTE NUR 34,00 €', '139,00 € KOKONAISARVO • TÄNÄÄN VAIN 34,00 €'],
    ['€139.00 TOTAL RETAIL VALUE • TODAY ONLY €34.00', '139,00 € KOKONAISARVO • TÄNÄÄN VAIN 34,00 €'],
    ['Was ist im 5-teiligen Komplett-Set enthalten?', 'Mitä 5-osainen täydellinen setti sisältää?'],
    ['What is included in the 5-piece complete set?', 'Mitä 5-osainen täydellinen setti sisältää?'],
    ['DAS HERO-PRODUKT', 'PÄÄTUOTE (HERO)'],
    ['THE HERO PRODUCT', 'PÄÄTUOTE (HERO)'],
    ['SCHRITT 1', 'VAIHE 1'],
    ['STEP 1', 'VAIHE 1'],
    ['SCHRITT 2', 'VAIHE 2'],
    ['STEP 2', 'VAIHE 2'],
    ['SCHRITT 3', 'VAIHE 3'],
    ['STEP 3', 'VAIHE 3'],
    ['SCHRITT 4', 'VAIHE 4'],
    ['STEP 4', 'VAIHE 4'],
    ['SCHRITT 5', 'VAIHE 5'],
    ['STEP 5', 'VAIHE 5'],
    ['HALS & DEKOLLETÉ LIFTING', 'KAULAN & DEKOLTEEN KIINTEYTYS'],
    ['NECK & DÉCOLLETÉ LIFTING', 'KAULAN & DEKOLTEEN KIINTEYTYS'],
    ['KIEFERKONTUR & DOPPELKINN', 'LEUKALINJA & KAKSOISLEUKA'],
    ['JAWLINE CONTOUR & DOUBLE CHIN', 'LEUKALINJA & KAKSOISLEUKA'],
    ['AUGEN-DEPOCKING & GLOW', 'SILMÄNYMPÄRYKSEN TURVOTUKSEN POISTO & HEHKU'],
    ['EYE DE-PUFFING & GLOW', 'SILMÄNYMPÄRYKSEN TURVOTUKSEN POISTO & HEHKU'],
    ['KRÄHENFÜSSE & FALTEN', 'HARAKANVARPAAT & JUONTEET'],
    ['CROW\'S FEET & FINE LINES', 'HARAKANVARPAAT & JUONTEET'],
    ['GLASS-SKIN FINISH', 'GLASS-SKIN -VIIMEISTELY'],
    ['INSTANT GLOW & LIPPEN', 'VÄLITÖN HEHKU & HUULET'],
    ['INSTANT GLOW & LIPS', 'VÄLITÖN HEHKU & HUULET'],
    ['GEZIELTE AUGENPFLEGE', 'KOHDISTETTU SILMÄNYMPÄRYSHOITO'],
    ['TARGETED EYE CARE', 'KOHDISTETTU SILMÄNYMPÄRYSHOITO'],
    ['Einzel-UVP:', 'Erillinen OVH:'],
    ['Separate MSRP:', 'Erillinen OVH:'],
    ['TRANSPARENTER PREISVORTEIL', 'LÄPINÄKYVÄ HINTAETU'],
    ['TRANSPARENT VALUE BREAKDOWN', 'LÄPINÄKYVÄ HINTAETU'],
    ['SET JETZT SICHERN', 'LUNASTA SETTISI NYT'],
    ['CLAIM YOUR SET NOW', 'LUNASTA SETTISI NYT'],
    ['EINFACH & SCHNELL • NUR 5 MINUTEN TÄGLICH', 'HELPPO & NOPEA • VAIN 5 MINUUTTIA PÄIVÄSSÄ'],
    ['FAST & EASY • JUST 5 MINUTES A DAY', 'HELPPO & NOPEA • VAIN 5 MINUUTTIA PÄIVÄSSÄ'],
    ['Deine tägliche 5-Schritte Youth-Lock Routine', 'Päivittäinen 5-vaiheinen Youth-Lock -rutiinisi'],
    ['Your Daily 5-Step Youth-Lock Regimen', 'Päivittäinen 5-vaiheinen Youth-Lock -rutiinisi'],
    ['2–3x / WOCHE • 15 MIN', '2–3x / VIIKOSSA • 15 MIN'],
    ['2–3x / WEEK • 15 MIN', '2–3x / VIIKOSSA • 15 MIN'],
    ['V-Line Band anlegen', 'Aseta V-Line -naamio'],
    ['Apply V-Line Band', 'Aseta V-Line -naamio'],
    ['TÄGLICH MORGENS • 10 MIN', 'PÄIVITTÄIN AAMUISIN • 10 MIN'],
    ['DAILY MORNING • 10 MIN', 'PÄIVITTÄIN AAMUISIN • 10 MIN'],
    ['Augenpartie entstauen', 'Laske silmänympäryksen turvotusta'],
    ['De-Puff Eye Area', 'Laske silmänympäryksen turvotusta'],
    ['MORGENS & ABENDS • 30 SEK', 'AAMUIN JA ILLOIN • 30 SEK'],
    ['MORNING & EVENING • 30 SEC', 'AAMUIN JA ILLOIN • 30 SEK'],
    ['Falten präzise glätten', 'Tasoita juonteet tarkasti'],
    ['Target Fine Lines', 'Tasoita juonteet tarkasti'],
    ['TÄGLICH • 2 MINUTEN', 'PÄIVITTÄIN • 2 MINUUTTIA'],
    ['DAILY • 2 MINUTES', 'PÄIVITTÄIN • 2 MINUUTTIA'],
    ['Gua Sha Neck Massage', 'Gua Sha -kaulahieronta'],
    ['JEDERZEIT • FINISH & GLOW', 'MILLOIN VAIN • VIIMEISTELYYN & HEHKUUN'],
    ['ANYTIME • FINISH & GLOW', 'MILLOIN VAIN • VIIMEISTELYYN & HEHKUUN'],
    ['Glass-Skin Glow to-go', 'Glass-Skin -hehkua mukaan'],
    ['On-The-Go Glass Skin Glow', 'Glass-Skin -hehkua mukaan'],
    ['INTEGRIERTES GUA SHA TOOL • KEIN ZERBRECHLICHER STEIN', 'INTEGROITU GUA SHA -TYÖKALU • EI HELPOSTI SÄRKYVÄÄ JADEKIVEÄ'],
    ['INTEGRATED GUA SHA TOOL • NO FRAGILE JADE STONE', 'INTEGROITU GUA SHA -TYÖKALU • EI HELPOSTI SÄRKYVÄÄ JADEKIVEÄ'],
    ['Die richtige Gua Sha Technik: So massierst du wie die K-Beauty Profis', 'Oikea Gua Sha -tekniikka: Hiero kuin K-Beauty -ammattilaiset'],
    ['The Proper Gua Sha Technique: Massage Like Korean Aesthetic Professionals', 'Oikea Gua Sha -tekniikka: Hiero kuin K-Beauty -ammattilaiset'],
    ['1. Hals-Lifting gegen Tech-Neck', '1. Kaulan kohotus tech-neck-juonteita vastaan'],
    ['1. Neck Lift Against Tech-Neck', '1. Kaulan kohotus tech-neck-juonteita vastaan'],
    ['2. Jawline & V-Line Definition', '2. Leukalinjan & V-linjan muotoilu'],
    ['3. Dekolleté & Lymphatische Drainage', '3. Dekoltee & lymfaattinen hieronta'],
    ['3. Décolleté & Lymphatic Drainage', '3. Dekoltee & lymfaattinen hieronta'],
    ['Chirurgischer Edelstahl (Kühlend & Desinfizierbar)', 'Kirurgista ruostumatonta terästä (Viilentävä & helppo desinfioida)'],
    ['Surgical Stainless Steel (Cooling & Easy to Sanitize)', 'Kirurgista ruostumatonta terästä (Viilentävä & helppo desinfioida)'],
    ['Hygienischer Dreh-Verschluss (Kein Auslaufen)', 'Hygieeninen kääntölukitus (Ei vuotoja)'],
    ['Hygienic Twist Lock (Zero Leakage)', 'Hygieeninen kääntölukitus (Ei vuotoja)'],
    ['Präzise Dosierung während der Massage', 'Tarkka annostelu hieronnan aikana'],
    ['Precise Dispensing During Massage', 'Tarkka annostelu hieronnan aikana'],
    ['Faltentiefe an den horizontalen Halslinien nach 14 Tagen', 'Vaakasuuntaisten kaulajuonteiden syvyys 14 päivän jälkeen'],
    ['Wrinkle depth on horizontal neck lines after 14 days', 'Vaakasuuntaisten kaulajuonteiden syvyys 14 päivän jälkeen'],
    ['DERMATOLOGISCHE KLINIK-FORMEL', 'DERMATOLOGINEN KLIININEN KOOSTUMUS'],
    ['DERMATOLOGICAL CLINICAL FORMULATION', 'DERMATOLOGINEN KLIININEN KOOSTUMUS'],
    ['Die Dual-Action-Wissenschaft hinter dem Set', 'Kaksoisvaikutteinen tiede setin taustalla'],
    ['The Dual-Action Science Behind the Set', 'Kaksoisvaikutteinen tiede setin taustalla'],
    ['Zelluläre DNA-Reparatur', 'Solutason DNA-korjaus'],
    ['Cellular DNA Repair', 'Solutason DNA-korjaus'],
    ['Natürlicher Aufpolsterungs-Effekt', 'Luonnollinen täyteläistävä kudosvaikutus'],
    ['Natural Tissue Plumping Effect', 'Luonnollinen täyteläistävä kudosvaikutus'],
    ['Gefäß- und Gewebestimulation', 'Verisuoniston ja kudosten stimulointi'],
    ['Vascular & Tissue Stimulation', 'Verisuoniston ja kudosten stimulointi'],
    ['KLINISCH GETESTET AN 34 PROBANDINNEN (4 WOCHEN)', 'KLIINISESTI TESTATTU 34 OSALLISTUjALLA (4 VIIKKOA)'],
    ['CLINICALLY TESTED ON 34 PARTICIPANTS (4 WEEKS)', 'KLIINISESTI TESTATTU 34 OSALLISTUjALLA (4 VIIKKOA)'],
    ['Messbare Ergebnisse statt leerer Versprechen', 'Mitattavia kliinisiä tuloksia, ei tyhjiä lupauksia'],
    ['Measurable Clinical Results, Not Empty Promises', 'Mitattavia kliinisiä tuloksia, ei tyhjiä lupauksia'],
    ['Straffere Kinnlinie & V-Kontur', 'Napakampi leukalinja & V-muoto'],
    ['Firmer Jawline & V-Contour', 'Napakampi leukalinja & V-muoto'],
    ['Glattere Hals- & Dekolleté-Zone', 'Sileämpi kaula & dekoltee'],
    ['Smoother Neck & Décolleté Area', 'Sileämpi kaula & dekoltee'],
    ['Sofortige Frische & Kühleffekt', 'Välitön raikkaus & viilennys'],
    ['Instant Freshness & Cooling Relief', 'Välitön raikkaus & viilennys'],
    ['HÄUFIG GESTELLTE FRAGEN', 'USEIN KYSYTYT KYSYMYKSET'],
    ['FREQUENTLY ASKED QUESTIONS', 'USEIN KYSYTYT KYSYMYKSET'],
    ['Alles, was du über das 5-teilige Set wissen musst', 'Kaikki mitä sinun tarvitsee tietää 5-osaisesta setistä'],
    ['Everything You Need to Know About the 5-Piece Set', 'Kaikki mitä sinun tarvitsee tietää 5-osaisesta setistä'],
    ['In welcher genauen Reihenfolge soll ich die 5 Produkte anwenden?', 'Missä järjestyksessä tuotteita tulee käyttää?'],
    ['In what exact order should I apply the 5 products?', 'Missä järjestyksessä tuotteita tulee käyttää?'],
    ['LIMITIERTE AKTION • 75% RABATT', 'RAJOITETTU TARJOUS • 75% ALENNUS'],
    ['LIMITED OFFER • 75% OFF', 'RAJOITETTU TARJOUS • 75% ALENNUS'],
    ['Bereit für deine straffeste Kontur & jugendlichen Glow?', 'Oletko valmis kiinteimpään leukalinjaan & nuorekkaaseen hehkuun?'],
    ['Ready for your firmest contour & youthful glow?', 'Oletko valmis kiinteimpään leukalinjaan & nuorekkaaseen hehkuun?'],
    ['Hol dir jetzt alle 5 K-Beauty Bestseller im Vorteilspaket für nur', 'Hanki kaikki 5 K-Beauty -bestselleriä etupaketissa vain hintaan'],
    ['Get all 5 K-Beauty bestsellers in the exclusive value bundle for only', 'Hanki kaikki 5 K-Beauty -bestselleriä etupaketissa vain hintaan'],
    ['statt 139,00 € UVP', 'norm. 139,00 € OVH sijaan'],
    ['instead of €139.00 MSRP', 'norm. 139,00 € OVH sijaan'],
    ['Schneller DHL-Versand (1-3 Tage)', 'Nopea DHL-toimitus (1-3 päivää)'],
    ['Fast DHL Shipping (1-3 Days)', 'Nopea DHL-toimitus (1-3 päivää)'],

    // Reviews
    ['Kundenbewertungen', 'Asiakasarvostelut'],
    ['Customer Reviews', 'Asiakasarvostelut'],
    ['Verifizierte Erfahrungen', 'Vahvistetut kokemukset'],
    ['Verified Experiences', 'Vahvistetut kokemukset'],
    ['Bewertung schreiben', 'Kirjoita arvostelu'],
    ['Write a Review', 'Kirjoita arvostelu'],
    ['5 Sterne', '5 tähteä'],
    ['5 Stars', '5 tähteä'],
    ['4 Sterne', '4 tähteä'],
    ['4 Stars', '4 tähteä'],
    ['3 Sterne', '3 tähteä'],
    ['3 Stars', '3 tähteä'],
    ['2 Sterne', '2 tähteä'],
    ['2 Stars', '2 tähteä'],
    ['1 Stern', '1 tähti'],
    ['1 Star', '1 tähti'],
    ['Basierend auf', 'Perustuu'],
    ['Based on', 'Perustuu'],
    ['verifizierten Bewertungen', 'vahvistettuun arvosteluun'],
    ['verified reviews', 'vahvistettuun arvosteluun'],
    ['Verifiziert', 'Vahvistettu'],
    ['Verified', 'Vahvistettu'],
    ['Hilfreich', 'Hyödyllinen'],
    ['Helpful', 'Hyödyllinen'],

    // Tabs / Accordions
    ['Vorteile & Wirkung', 'Hyödyt & Teho'],
    ['Benefits & Efficacy', 'Hyödyt & Teho'],
    ['Klinische Studien & Wirksamkeit', 'Kliiniset tutkimukset & tulokset'],
    ['Clinical Studies & Results', 'Kliiniset tutkimukset & tulokset'],
    ['Reinheitsgarantie & Inhaltsstoffe', 'Puhdas koostumus & ainesosat'],
    ['Clean Formula & Ingredients', 'Puhdas koostumus & ainesosat'],
    ['Anwendung & Routine-Schritte', 'Käyttöohje & rutiinivaiheet'],
    ['How to Use & Routine Steps', 'Käyttöohje & rutiinivaiheet'],
    ['Häufig gestellte Fragen (FAQ)', 'Usein kysytyt kysymykset (FAQ)'],
    ['Frequently Asked Questions (FAQ)', 'Usein kysytyt kysymykset (FAQ)'],
    ['Vorteile des Abonnements (30% Rabatt)', 'Kestotilauksen edut (30% alennus)'],
    ['Subscription Benefits (30% Off)', 'Kestotilauksen edut (30% alennus)'],
    ['✓ Ohne Duftstoffe', '✓ Hajusteeton'],
    ['✓ Fragrance-Free', '✓ Hajusteeton'],
    ['✓ Ohne Parabene', '✓ Ei parabeeneja'],
    ['✓ Paraben-Free', '✓ Ei parabeeneja'],
    ['✓ Ohne Silikone', '✓ Ei silikoneja'],
    ['✓ Silicone-Free', '✓ Ei silikoneja'],
    ['✓ Ohne Sulfate', '✓ Ei sulfaatteja'],
    ['✓ Sulfate-Free', '✓ Ei sulfaatteja'],
    ['✓ Cruelty-Free', '✓ Cruelty-Free (Ei eläinkokeita)'],
    ['✓ Nicht-komedogen', '✓ Ei tuki ihohuokosia'],
    ['✓ Non-Comedogenic', '✓ Ei tuki ihohuokosia'],

    // Cart Drawer
    ['Dein Warenkorb ist noch leer', 'Ostoskorisi on tällä hetkellä tyhjä'],
    ['Your cart is currently empty', 'Ostoskorisi on tällä hetkellä tyhjä'],
    ['Dein Warenkorb', 'Ostoskorisi'],
    ['Your Cart', 'Ostoskorisi'],
    ['Warenkorb', 'Ostoskori'],
    ['Cart', 'Ostoskori'],
    ['ZUR KASSE • SICHERE ZAHLUNG', 'KASSALLE • TURVALLINEN MAKSU'],
    ['CHECKOUT • SECURE PAYMENT', 'KASSALLE • TURVALLINEN MAKSU'],
    ['Zur Kasse', 'Kassalle'],
    ['Checkout', 'Kassalle'],
    ['Kostenloser Versand freigeschaltet!', 'Ilmainen toimitus saavutettu!'],
    ['Free shipping unlocked!', 'Ilmainen toimitus saavutettu!'],

    // Homepage
    ['Jetzt im Trend:', 'Nyt trendeissä:'],
    ['Trending Now:', 'Nyt trendeissä:'],
    ['Koreanische Skincare', 'Korealainen ihonhoito'],
    ['Korean Skincare', 'Korealainen ihonhoito'],
    ['Geräte', 'Laitteet'],
    ['Devices', 'Laitteet'],
    ['ALLE ANZEIGEN', 'KATSO KAIKKI'],
    ['VIEW ALL', 'KATSO KAIKKI'],
    ['JETZT SHOPPEN', 'OSTA NYT'],
    ['SHOP NOW', 'OSTA NYT'],
    ['Jetzt shoppen', 'Osta nyt'],
    ['Shop Now', 'Osta nyt'],
    ['ECHTE ERFAHRUNGEN UNSERER COMMUNITY', 'AITOJA KOKEMUKSIA YHTEISÖLTÄMME'],
    ['REAL EXPERIENCES FROM OUR COMMUNITY', 'AITOJA KOKEMUKSIA YHTEISÖLTÄMME'],
    ['100% dermatologisch', '100% ihotautilääkärien'],
    ['100% Dermatologist', '100% ihotautilääkärien'],
    ['getestet.', 'testaama.'],
    ['Tested.', 'testaama.'],
    ['Klinisch bewiesene<br>K-Beauty Formeln.', 'Kliinisesti todistetut<br>K-Beauty -koostumukset.'],
    ['Clinically Proven<br>K-Beauty Formulas.', 'Kliinisesti todistetut<br>K-Beauty -koostumukset.'],
    ['Klinisch bewiesene K-Beauty Formeln.', 'Kliinisesti todistetut K-Beauty -koostumukset.'],
    ['Clinically proven K-Beauty formulas.', 'Kliinisesti todistetut K-Beauty -koostumukset.']
  ];

  // ---------------------------------------------------------------
  // DANISH (DA) HIGH-PRECISION TEXT REPLACEMENT TABLE
  // Maps both German and English source strings directly to Danish
  // ---------------------------------------------------------------
  window.MC_DA_PHRASES = [
    // AGE-R Devices Dropdown Subtitles
    ['6-in-1 Klinische Pflege (Neuheit)', '6-i-1 Klinisk pleje (Nyhed)'],
    ['Bestseller Elektroporation & EMS', 'Bestseller • Elektroporation & EMS'],
    ['40.68 MHz Radiofrequenz Kollagenboost', '40.68 MHz Radiofrekvens kollagenboost'],
    ['Kompakter Glow für unterwegs', 'Kompakt glød på farten'],
    ['Klärende Körperpflege & Blemish-Control', 'Klarerende kropspleje & blemish-kontrol'],

    // Hypochlorous Bundle Selector & Tiers
    ['Pflegeroutine wählen:', 'Vælg din rutine:'],
    ['🔥 87% wählen das Bestseller-Set', '🔥 87% vælger Bestseller-sættet'],
    ['Bestseller-Set', 'Bestseller-sæt'],
    ['Bestseller-Duo', 'Bestseller-duo'],
    ['/ Produkt • 330ml Routine', '/ produkt • 330ml rutine'],
    ['/ Flasche • 560ml Vorrat', '/ flaske • 560ml forråd'],
    ['Sanftes Peeling für den Körper gegen Unreinheiten & Blemishes', 'Skånsom kropspeeling mod urenheder og blemishes'],
    ['Konzentriertes Klärendes Peeling-Serum für das Gesicht', 'Koncentreret klarerende peelingserum til ansigtet'],
    ['Beinhaltet BEIDE Produkte • Maximale Ergebnisse & Glass-Skin-Glow', 'Indeholder BEGGE produkter • Maksimale resultater og glass-skin-glød'],
    ['Vorratspack für maximale Langzeitergebnisse • Spare zusätzlich 7 €', 'Fordelspakke til maksimale langtidsresultater • Spar yderligere 7 €'],
    ['🔥 BESTSELLER-SET • SPARE 23%', '🔥 BESTSELLER-SÆT • SPAR 23%'],
    ['🔥 BESTSELLER — 20% RABATT', '🔥 BESTSELLER — 20% RABAT'],
    ['💎 MAXIMALER VORTEIL • SPARE 31%', '💎 MAKSIMAL FORDEL • SPAR 31%'],
    ['Wähle deine Pflegeroutine.', 'Vælg din hudplejerutine.'],
    ['DAS OPTIMALE SET', 'DET OPTIMALE SÆT'],
    ['Hol dir das Komplett-Duo für Gesicht & Körper und spare 23% gegenüber dem Einzelkauf.', 'Få det komplette duo-sæt til ansigt og krop og spar 23% i forhold til enkeltkøb.'],
    ['Mit dem Bestseller-Duo sparst du 20 %', 'Med Bestseller-duoen sparer du 20%'],
    ['AB 30 JAHREN (BESTSELLER)', 'FRA 30 ÅR (BESTSELLER)'],
    ['originalen koreanischen Bestsellern', 'originale koreanske bestsellere'],
    ['ausgewählte MediCube Skincare-Bestseller.', 'udvalgte MediCube hudplejebestsellere.'],
    ['Entdecke unsere meistverkauften K-Beauty Bestseller und starte deine Hautpflege-Routine.', 'Opdag vores bedst sælgende K-Beauty bestsellere og start din hudplejerutine.'],
    ['Bestseller für maximale Ergebnisse & sofortigen Glow', 'Bestsellere for maksimale resultater & øjeblikkelig glød'],
    ['Alle Bestseller ansehen', 'Se alle bestsellere'],
    ['Perfekt abgestimmte K-Beauty Bestseller für deine tägliche Pflegeroutine.', 'Perfekt afstemte K-Beauty bestsellere til din daglige plejerutine.'],
    ['KÖRPERPFLEGE', 'KROPSPLEJE'],
    ['-30% RABATT', '30% RABAT'],
    ['Rice Body Peel Shot (280ml)', 'Rice Body Peel Shot (280ml)'],
    ['Rice Face Peel Shot (50ml)', 'Rice Face Peel Shot (50ml)'],
    ['Komplettes Duo-Set (Body + Face)', 'Komplet Duo-sæt (Krop + Ansigt)'],
    ['2x Komplettes Duo-Set (2x Body + 2x Face)', '2x Komplet Duo-sæt (2x Krop + 2x Ansigt)'],

    // Hypochlorous Benefits, Routine, Clinical & FAQ
    ['🔬 DERMATOLOGISCHE INNOVATION', '🔬 DERMATOLOGISK INNOVATION'],
    ['Die Kraft von Hypochlorous Acid & koreanischem Reis-Extrakt', 'Kraften af hypoklorsyre og koreansk risekstrakt'],
    ['Klärende Anti-Blemish Formel', 'Klarerende anti-blemish formel'],
    ['Mikro-Peeling & Textur-Glättung', 'Mikropeeling & udglatning af tekstur'],
    ['Oryza Sativa Reis-Glow', 'Oryza Sativa risglød'],
    ['100% Barriere-Schonend', '100% barrierevenlig'],
    ['📊 KLINISCH ERWIESENE WIRKUNG', '📊 KLINISK DOKUMENTERET EFFEKT'],
    ['Sichtbare Ergebnisse ab der 1. Anwendung', 'Synlige resultater fra 1. anvendelse'],
    ['Weniger Unreinheiten & Pickel', 'Færre urenheder & bumser'],
    ['Verfeinerte Poren & Talgkontrolle', 'Forfinede porer & talgkontrol'],
    ['Glattere, ebenmäßige Hauttextur', 'Glatte, ensartet hudtekstur'],
    ['0.00% Reizungsindex • Hypoallergen getestet • Für empfindlichste Hauttypen geeignet', '0.00% irritationsindeks • Hypoallergent testet • Velegnet til sensitiv hud'],
    ['✨ ANWENDUNGS-ROUTINE', '✨ ANVENDELSESRUTINE'],
    ['So wendest du das Hypochlorous Acid System an', 'Sådan anvender du Hypochlorous Acid-systemet'],
    ['KÖRPERPFLEGE (DUSCHE)', 'KROPSPLEJE (BRUSER)'],
    ['GESICHTSPFLEGE (SERUM)', 'ANSIGTSPLEJE (SERUM)'],
    ['BARRIERE & HYDRATION', 'BARRIERE & FUGT'],
    ['Feuchtigkeit & Schutz', 'Fugt & beskyttelse'],
    ['📅 Anwendung: 2–3x pro Woche', '📅 Anvendelse: 2–3x om ugen'],
    ['📅 Anwendung: Täglich (Morgens & Abends)', '📅 Anvendelse: Dagligt (Morgen & Aften)'],
    ['📅 Anwendung: Im Anschluss an Schritt 2', '📅 Anvendelse: Efter trin 2'],
    ['❓ HÄUFIGE FRAGEN', '❓ OFTE STILLEDE SPØRGSMÅL'],
    ['Fragen & Antworten zum Hypochlorous System', 'Spørgsmål & svar om Hypochlorous-systemet'],


    // Header & Navigation
    ['⚡ KOSTENLOSER DHL-VERSAND • 30 TAGE GELD-ZURÜCK-GARANTIE ⚡', '⚡ GRATIS DHL-LEVERING • 30 DAGES TILFREDSHEDSGARANTI ⚡'],
    ['⚡ FREE DHL SHIPPING • 30-DAY MONEY-BACK GUARANTEE ⚡', '⚡ GRATIS DHL-LEVERING • 30 DAGES TILFREDSHEDSGARANTI ⚡'],
    ['AGE-R Beauty Tech Geräte', 'AGE-R Beauty Tech Enheder'],
    ['AGE-R Beauty Devices', 'AGE-R Beauty Tech Enheder'],
    ['Hautpflege-Linien', 'Hudplejeserier'],
    ['Skincare Lines', 'Hudplejeserier'],
    ['Hautpflege', 'Hudpleje'],
    ['Skincare', 'Hudpleje'],
    ['Zero Poren-Linie (Poren & Sebum)', 'Zero Pore-serien (Porominimering & Sebum)'],
    ['Zero Pore Line (Pores & Sebum)', 'Zero Pore-serien (Porominimering & Sebum)'],
    ['Zero Poren-Linie', 'Zero Pore-serien'],
    ['Zero Pore Line', 'Zero Pore-serien'],
    ['Triple Collagen & Glow (Straffung & Elastizität)', 'Triple Collagen & Glow (Løft & Fasthed)'],
    ['Triple Collagen & Glow (Lifting & Firmness)', 'Triple Collagen & Glow (Løft & Fasthed)'],
    ['Triple Collagen & Glow (Firming & Elasticity)', 'Triple Collagen & Glow (Løft & Fasthed)'],
    ['Triple Collagen & Glow', 'Triple Collagen & Glow'],
    ['Pink PDRN Linie (Barriere & Peptide)', 'Pink PDRN-serien (Barriere & Peptider)'],
    ['Pink PDRN Line (Barrier & Peptides)', 'Pink PDRN-serien (Barriere & Peptider)'],
    ['Pink PDRN Regeneration', 'Pink PDRN-fornyelse'],
    ['Pink PDRN Linie', 'Pink PDRN-serien'],
    ['Pink PDRN Line', 'Pink PDRN-serien'],
    ['Exosome Super Cica (Beruhigung)', 'Exosome Super Cica (Beroligende)'],
    ['Exosome Super Cica (Calming & Soothing)', 'Exosome Super Cica (Beroligende)'],
    ['Exosome Super Cica', 'Exosome Super Cica'],
    ['Deep Vitamin C (Anti-Aging & Flecken)', 'Deep Vitamin C (Anti-Aging & Glød)'],
    ['Deep Vitamin C (Anti-Aging & Radiance)', 'Deep Vitamin C (Anti-Aging & Glød)'],
    ['Deep Vitamin C Anti-Aging', 'Deep Vitamin C Anti-Aging'],
    ['Red Akne-Linie (Unreine Haut)', 'Red Acne-serien (Uren hud)'],
    ['Red Acne Line (Blemish Care)', 'Red Acne-serien (Uren hud)'],
    ['Red Akne-Pflege', 'Red Acne-pleje'],
    ['Red Acne Care', 'Red Acne-pleje'],
    ['TXA & Kojisäure (Aufhellung)', 'TXA & Kojisukker (Lysnende)'],
    ['TXA & Kojic Acid (Brightening)', 'TXA & Kojisukker (Lysnende)'],
    ['TXA & Kojisäure Aufhellung', 'TXA & Kojisukker lysning'],
    ['Nach Pflegelinie', 'Efter hudplejeserie'],
    ['By Skincare Line', 'Efter hudplejeserie'],
    ['Nach Kategorie', 'Efter kategori'],
    ['By Category', 'Efter kategori'],
    ['Reinigung & Cleanser', 'Renseprodukter & Cleansers'],
    ['Cleansers & Cleansing', 'Renseprodukter & Cleansers'],
    ['Toner & Peeling-Pads', 'Tonere & Eksfolierende pads'],
    ['Toners & Exfoliating Pads', 'Tonere & Eksfolierende pads'],
    ['Seren & Ampullen', 'Sera & Ampuller'],
    ['Serums & Ampoules', 'Sera & Ampuller'],
    ['Cremes & Feuchtigkeit', 'Cremer & Fugtgivende pleje'],
    ['Creams & Moisturizers', 'Cremer & Fugtgivende pleje'],
    ['Gesichtsmasken & Wrapping', 'Sheet-masker & Natindpakning'],
    ['Sheet Masks & Night Wrapping', 'Sheet-masker & Natindpakning'],
    ['Sheet Masks & Wrapping', 'Sheet-masker & Natindpakning'],
    ['Sonnenschutz (SPF)', 'Solbeskyttelse (SPF)'],
    ['Sun Protection (SPF)', 'Solbeskyttelse (SPF)'],
    ['Sets & Duos', 'Sæt & Fordelspakker'],
    ['Sets & Bundles', 'Sæt & Fordelspakker'],
    ['Vorteils-Sets & Duos', 'Fordelssæt & Pakker'],
    ['Value Sets & Bundles', 'Fordelssæt & Pakker'],
    ['Bestseller', 'Bestsellere'],
    ['Bestsellers', 'Bestsellere'],
    ['AGE-R Guide & Anleitung', 'AGE-R Vejledning & Instruktioner'],
    ['AGE-R Guide & Instructions', 'AGE-R Vejledning & Instruktioner'],
    ['Über uns', 'Om os'],
    ['About Us', 'Om os'],
    ['Hilfe & Kundenservice', 'Hjælp & Kundeservice'],
    ['Help & Support', 'Hjælp & Kundeservice'],
    ['Hilfe & Kontakt', 'Hjælp & Kundeservice'],
    ['Help & Contact', 'Hjælp & Kundeservice'],
    ['Mein Konto / Anmelden', 'Min konto / Log ind'],
    ['My Account / Sign In', 'Min konto / Log ind'],
    ['Alle Produkte', 'Alle produkter'],
    ['All Products', 'Alle produkter'],
    ['Geräte-Leitgele & Zubehör →', 'Enhedsgeler & tilbehør →'],
    ['Device Gels & Accessories →', 'Enhedsgeler & tilbehør →'],
    ['Alle Technologien im Überblick →', 'Oversigt over alle teknologier →'],
    ['Explore All Technologies →', 'Oversigt over alle teknologier →'],

    // PDP Above the Fold & Pricing
    ['🔥 5-TEILIGES KOMPLETT-SET • 105 € SPAREN (75% VORTEIL)', '🔥 5-DELT KOMPLET SÆT • SPAR 105 € (75% RABAT)'],
    ['🔥 5-PIECE COMPLETE SET • SAVE €105 (75% OFF)', '🔥 5-DELT KOMPLET SÆT • SPAR 105 € (75% RABAT)'],
    ['SPAREN 75%', 'SPAR 75%'],
    ['SAVE 75%', 'SPAR 75%'],
    ['SPAREN 24%', 'SPAR 24%'],
    ['SAVE 24%', 'SPAR 24%'],
    ['SPAREN 31%', 'SPAR 31%'],
    ['SAVE 31%', 'SPAR 31%'],
    ['139,00 € UVP', '139,00 € VEJL.'],
    ['€139.00 MSRP', '139,00 € VEJL.'],
    ['34,00 € KOMPLETT-SET', '34,00 € KOMPLET SÆT'],
    ['€34.00 COMPLETE SET', '34,00 € KOMPLET SÆT'],
    ['Wissenschaftlich fundiert', 'Videnskabeligt dokumenteret'],
    ['Backed by Science', 'Videnskabeligt dokumenteret'],
    ['80+ von Experten begutachtete Studien hinter unserer Formel.', '80+ fagfællebedømte studier understøtter vores formel.'],
    ['80+ peer-reviewed studies supporting our formula.', '80+ fagfællebedømte studier understøtter vores formel.'],
    ['Studien ansehen & mehr erfahren', 'Se studier & lær mere'],
    ['View studies & learn more', 'Se studier & lær mere'],
    ['Oder in 3 zinsfreien Raten von', 'Eller 3 rentefri rater på'],
    ['Or 3 interest-free installments of', 'Eller 3 rentefri rater på'],
    ['mit Klarna', 'med Klarna'],
    ['with Klarna', 'med Klarna'],
    ['Mehr erfahren', 'Læs mere'],
    ['Learn more', 'Læs mere'],
    ['IN DEN WARENKORB', 'LÆG I KURV'],
    ['ADD TO CART', 'LÆG I KURV'],
    ['In den Warenkorb', 'Læg i kurv'],
    ['Add to Cart', 'Læg i kurv'],
    ['Add to cart', 'Læg i kurv'],
    ['Wird hinzugefügt...', 'Tilføjer...'],
    ['Adding...', 'Tilføjer...'],
    ['AUSVERKAUFT', 'UDSOLGT'],
    ['SOLD OUT', 'UDSOLGT'],
    ['Ausverkauft', 'Udsolgt'],
    ['Sold Out', 'Udsolgt'],
    ['Sold out', 'Udsolgt'],
    ['LIMITIERTES TAGESANGEBOT', 'BEGRÆNSET DAGSTILBUD'],
    ['LIMITED DAILY OFFER', 'BEGRÆNSET DAGSTILBUD'],
    ['Aktion endet in:', 'Tilbuddet udløber om:'],
    ['Deal ends in:', 'Tilbuddet udløber om:'],
    ['Pflegeroutine wählen:', 'Vælg din rutine:'],
    ['Choose your routine:', 'Vælg din rutine:'],
    ['🔥 87% wählen das Bestseller-Set', '🔥 87% vælger Bestseller-sættet'],
    ['🔥 87% choose the Bestseller Set', '🔥 87% vælger Bestseller-sættet'],
    ['1x Body Peel', '1x Body Peel'],
    ['280ml • Sanftes Körperpeeling', '280ml • Skånsom kropseksfoliering'],
    ['280ml • Gentle Body Exfoliator', '280ml • Skånsom kropseksfoliering'],
    ['1x Face Peel', '1x Face Peel'],
    ['50ml • Klärendes Gesichtsserum', '50ml • Rensende ansigtsserum'],
    ['50ml • Clarifying Facial Serum', '50ml • Rensende ansigtsserum'],
    ['Duo-Set (Body + Face)', 'Duo-sæt (Krop + Ansigt)'],
    ['Duo Set (Body + Face)', 'Duo-sæt (Krop + Ansigt)'],
    ['+ 1 GRATIS', '+ 1 GRATIS'],
    ['+ 1 FREE', '+ 1 GRATIS'],
    ['2x Body Peel Doppelpack', '2x Body Peel Dobbeltpakke'],
    ['2x Body Peel Value Pack', '2x Body Peel Dobbeltpakke'],
    ['+ 2 GRATIS', '+ 2 GRATIS'],
    ['+ 2 FREE', '+ 2 GRATIS'],
    ['🔥 Meistgewählt', '🔥 Mest populær'],
    ['🔥 Most Popular', '🔥 Mest populær'],
    ['💎 Bester Wert', '💎 Bedste værdi'],
    ['💎 Best Value', '💎 Bedste værdi'],
    ['Spare 11,95 €', 'Spar 11,95 €'],
    ['Save €11.95', 'Spar 11,95 €'],
    ['Spare 8,00 €', 'Spar 8,00 €'],
    ['Save €8.00', 'Spar 8,00 €'],
    ['Spare 30,95 €', 'Spar 30,95 €'],
    ['Save €30.95', 'Spar 30,95 €'],
    ['DEINE GESCHENKE ZUR BESTELLUNG', 'DINE GRATIS GAVER MED ORDREN'],
    ['YOUR FREE GIFTS WITH PURCHASE', 'DINE GRATIS GAVER MED ORDREN'],
    ['Kostenloser Versand', 'Gratis levering'],
    ['Free Shipping', 'Gratis levering'],
    ['1x GRATIS Flasche', '1x GRATIS flaske'],
    ['1x FREE Bottle', '1x GRATIS flaske'],
    ['2x GRATIS Flaschen', '2x GRATIS flasker'],
    ['2x FREE Bottles', '2x GRATIS flasker'],
    ['🔒 Ab 2x Vorrat', '🔒 Låses op ved 2x forsyning'],
    ['🔒 Unlocks with 2x Supply', '🔒 Låses op ved 2x forsyning'],
    ['Abo & Sparen (30% Rabatt)', 'Abonnér & spar (30% rabat)'],
    ['Subscribe & Save (30% Off)', 'Abonnér & spar (30% rabat)'],
    ['30% Dauerrabatt auf jede Folgelieferung. Jederzeit mit 1 Klick kündbar.', '30% fast rabat på hver efterfølgende levering. Opsig når som helst med 1 klik.'],
    ['30% recurring discount on every auto-delivery. Cancel anytime in 1 click.', '30% fast rabat på hver efterfølgende levering. Opsig når som helst med 1 klik.'],
    ['Kostenlose Lieferung', 'Gratis levering'],
    ['Free Delivery', 'Gratis levering'],
    ['30% Rabatt auf jede Folgebestellung', '30% rabat på enhver genbestilling'],
    ['30% off every follow-up order', '30% rabat på enhver genbestilling'],
    ['Jederzeit pausieren, anpassen oder mit 1 Klick kündigen', 'Sæt på pause, tilpas eller opsig når som helst med 1 klik'],
    ['Pause, adjust, or cancel anytime in 1 click', 'Sæt på pause, tilpas eller opsig når som helst med 1 klik'],
    ['Im 5-teiligen Vorteilspaket enthalten:', 'Indeholdt i det 5-delte fordelssæt:'],
    ['Included in the 5-Piece Value Bundle:', 'Indeholdt i det 5-delte fordelssæt:'],
    ['Included in the 5-piece value bundle:', 'Indeholdt i det 5-delte fordelssæt:'],
    ['Häufig zusammen gekauft', 'Købes ofte sammen'],
    ['Frequently Bought Together', 'Købes ofte sammen'],
    ['Von Dermatologen empfohlene Routine-Ergänzungen für maximale Ergebnisse:', 'Hudlægeanbefalede rutinetilføjelser for maksimale resultater:'],
    ['Dermatologist-recommended routine additions for maximum results:', 'Hudlægeanbefalede rutinetilføjelser for maksimale resultater:'],
    ['+ Hinzufügen', '+ Tilføj'],
    ['+ Add', '+ Tilføj'],
    ['Hinzugefügt', 'Tilføjet'],
    ['Added', 'Tilføjet'],
    ['Größe / Variante:', 'Størrelse / Variant:'],
    ['Size / Variant:', 'Størrelse / Variant:'],
    ['VORTEILSPACK', 'FORDELSPAKKE'],
    ['VALUE PACK', 'FORDELSPAKKE'],
    ['Schneller Versand: 1-3 Werktage innerhalb Deutschlands & EU', 'Hurtig levering: 1-3 hverdage med DHL'],
    ['Fast Shipping: 1-3 business days delivery via DHL', 'Hurtig levering: 1-3 hverdage med DHL'],
    ['100% Original K-Beauty: Direkt vom autorisierten Hersteller', '100% Ægte K-Beauty: Direkte fra autoriseret producent'],
    ['100% Authentic K-Beauty: Direct from authorized manufacturer', '100% Ægte K-Beauty: Direkte fra autoriseret producent'],
    ['30 Tage Zufriedenheits-Garantie: Risikofrei testen', '30 dages tilfredshedsgaranti: Prøv helt risikofrit'],
    ['30-Day Satisfaction Guarantee: Risk-free trial', '30 dages tilfredshedsgaranti: Prøv helt risikofrit'],
    ['30-Tage Geld-zurück-Garantie', '30 dages pengene-tilbage-garanti'],
    ['30-Day Money-Back Guarantee', '30 dages pengene-tilbage-garanti'],
    ['30 Tage risikofrei testen. Nicht zufrieden? Volle Erstattung – ohne Wenn und Aber.', 'Prøv risikofrit i 30 dage. Ikke tilfreds? Fuld refusion – uden spørgsmål.'],
    ['Try risk-free for 30 days. Not satisfied? Full refund – no questions asked.', 'Prøv risikofrit i 30 dage. Ikke tilfreds? Fuld refusion – uden spørgsmål.'],
    ['Dazu passt perfekt', 'Passer perfekt sammen med'],
    ['Pairs Perfectly With', 'Passer perfekt sammen med'],
    ['Koreas Nr. 1 Peeling- & Poren-Pad', 'Koreas #1 eksfolierende pore-pad'],
    ['Korea\'s #1 Exfoliating & Pore Pad', 'Koreas #1 eksfolierende pore-pad'],
    ['Tiefenregeneration mit Lachs-DNA', 'Dybdegående cellefornyelse med lakse-PDRN'],
    ['Deep Cellular Repair with Salmon DNA', 'Dybdegående cellefornyelse med lakse-PDRN'],
    ['Hauttyp', 'Hudtype'],
    ['Skin Type', 'Hudtype'],
    ['Haartyp', 'Hårtype'],
    ['Hair Type', 'Hårtype'],
    ['Hautbedürfnisse', 'Hudtilstande'],
    ['Skin Concerns', 'Hudtilstande'],
    ['Pflegebedürfnisse', 'Plejebehov'],
    ['Care Needs', 'Plejebehov'],
    ['Hauptwirkstoffe', 'Vigtigste aktive ingredienser'],
    ['Key Active Ingredients', 'Vigtigste aktive ingredienser'],

    // Youth Lock Modules
    ['139,00 € GESAMT-EINZELWERT • HEUTE NUR 34,00 €', '139,00 € SAMLET VÆRDI • I DAG KUN 34,00 €'],
    ['€139.00 TOTAL RETAIL VALUE • TODAY ONLY €34.00', '139,00 € SAMLET VÆRDI • I DAG KUN 34,00 €'],
    ['Was ist im 5-teiligen Komplett-Set enthalten?', 'Hvad indeholder det 5-delte komplette sæt?'],
    ['What is included in the 5-piece complete set?', 'Hvad indeholder det 5-delte komplette sæt?'],
    ['DAS HERO-PRODUKT', 'HERO-PRODUKTET'],
    ['THE HERO PRODUCT', 'HERO-PRODUKTET'],
    ['SCHRITT 1', 'TRIN 1'],
    ['STEP 1', 'TRIN 1'],
    ['SCHRITT 2', 'TRIN 2'],
    ['STEP 2', 'TRIN 2'],
    ['SCHRITT 3', 'TRIN 3'],
    ['STEP 3', 'TRIN 3'],
    ['SCHRITT 4', 'TRIN 4'],
    ['STEP 4', 'TRIN 4'],
    ['SCHRITT 5', 'TRIN 5'],
    ['STEP 5', 'TRIN 5'],
    ['HALS & DEKOLLETÉ LIFTING', 'HALS & DEKOLLETÉ LØFT'],
    ['NECK & DÉCOLLETÉ LIFTING', 'HALS & DEKOLLETÉ LØFT'],
    ['KIEFERKONTUR & DOPPELKINN', 'KÆBELINJE & DOBBELTHAGE'],
    ['JAWLINE CONTOUR & DOUBLE CHIN', 'KÆBELINJE & DOBBELTHAGE'],
    ['AUGEN-DEPOCKING & GLOW', 'MOD HÆVEDE ØJNE & GLØD'],
    ['EYE DE-PUFFING & GLOW', 'MOD HÆVEDE ØJNE & GLØD'],
    ['KRÄHENFÜSSE & FALTEN', 'SMILERYNKER & FINE LINJER'],
    ['CROW\'S FEET & FINE LINES', 'SMILERYNKER & FINE LINJER'],
    ['GLASS-SKIN FINISH', 'GLASS-SKIN FINISH'],
    ['INSTANT GLOW & LIPPEN', 'ØJEBLIKKELIG GLØD & LÆBER'],
    ['INSTANT GLOW & LIPS', 'ØJEBLIKKELIG GLØD & LÆBER'],
    ['GEZIELTE AUGENPFLEGE', 'MÅLRETTET ØJENPLEJE'],
    ['TARGETED EYE CARE', 'MÅLRETTET ØJENPLEJE'],
    ['Einzel-UVP:', 'Vejl. udsalgspris:'],
    ['Separate MSRP:', 'Vejl. udsalgspris:'],
    ['TRANSPARENTER PREISVORTEIL', 'GENNEMSKUELIG PRISFORDEL'],
    ['TRANSPARENT VALUE BREAKDOWN', 'GENNEMSKUELIG PRISFORDEL'],
    ['SET JETZT SICHERN', 'SIKR DIG DIT SÆT NU'],
    ['CLAIM YOUR SET NOW', 'SIKR DIG DIT SÆT NU'],
    ['EINFACH & SCHNELL • NUR 5 MINUTEN TÄGLICH', 'HURTIGT & NEMT • KUN 5 MINUTTER OM DAGEN'],
    ['FAST & EASY • JUST 5 MINUTES A DAY', 'HURTIGT & NEMT • KUN 5 MINUTTER OM DAGEN'],
    ['Deine tägliche 5-Schritte Youth-Lock Routine', 'Din daglige 5-trins Youth-Lock rutine'],
    ['Your Daily 5-Step Youth-Lock Regimen', 'Din daglige 5-trins Youth-Lock rutine'],
    ['2–3x / WOCHE • 15 MIN', '2–3x / UGE • 15 MIN'],
    ['2–3x / WEEK • 15 MIN', '2–3x / UGE • 15 MIN'],
    ['V-Line Band anlegen', 'Påfør V-Line maske'],
    ['Apply V-Line Band', 'Påfør V-Line maske'],
    ['TÄGLICH MORGENS • 10 MIN', 'DAGLIGT MORGEN • 10 MIN'],
    ['DAILY MORNING • 10 MIN', 'DAGLIGT MORGEN • 10 MIN'],
    ['Augenpartie entstauen', 'Dæmp hævelser omkring øjnene'],
    ['De-Puff Eye Area', 'Dæmp hævelser omkring øjnene'],
    ['MORGENS & ABENDS • 30 SEK', 'MORGEN & AFTEN • 30 SEK'],
    ['MORNING & EVENING • 30 SEC', 'MORGEN & AFTEN • 30 SEK'],
    ['Falten präzise glätten', 'Udjævn fine linjer præcist'],
    ['Target Fine Lines', 'Udjævn fine linjer præcist'],
    ['TÄGLICH • 2 MINUTEN', 'DAGLIGT • 2 MINUTTER'],
    ['DAILY • 2 MINUTES', 'DAGLIGT • 2 MINUTTER'],
    ['Gua Sha Neck Massage', 'Gua Sha halsmassage'],
    ['JEDERZEIT • FINISH & GLOW', 'NÅR SOM HELST • FINISH & GLØD'],
    ['ANYTIME • FINISH & GLOW', 'NÅR SOM HELST • FINISH & GLØD'],
    ['Glass-Skin Glow to-go', 'Glass-Skin glød på farten'],
    ['On-The-Go Glass Skin Glow', 'Glass-Skin glød på farten'],
    ['INTEGRIERTES GUA SHA TOOL • KEIN ZERBRECHLICHER STEIN', 'INTEGRERET GUA SHA VÆRKTØJ • INGEN SKØR JADESTEN'],
    ['INTEGRATED GUA SHA TOOL • NO FRAGILE JADE STONE', 'INTEGRERET GUA SHA VÆRKTØJ • INGEN SKØR JADESTEN'],
    ['Die richtige Gua Sha Technik: So massierst du wie die K-Beauty Profis', 'Den korrekte Gua Sha teknik: Massér som K-Beauty eksperterne'],
    ['The Proper Gua Sha Technique: Massage Like Korean Aesthetic Professionals', 'Den korrekte Gua Sha teknik: Massér som K-Beauty eksperterne'],
    ['1. Hals-Lifting gegen Tech-Neck', '1. Halsløft mod Tech-Neck'],
    ['1. Neck Lift Against Tech-Neck', '1. Halsløft mod Tech-Neck'],
    ['2. Jawline & V-Line Definition', '2. Kæbelinje & V-linje definition'],
    ['3. Dekolleté & Lymphatische Drainage', '3. Dekolleté & lymfatisk drænage'],
    ['3. Décolleté & Lymphatic Drainage', '3. Dekolleté & lymfatisk drænage'],
    ['Chirurgischer Edelstahl (Kühlend & Desinfizierbar)', 'Kirurgisk rustfrit stål (Kølende & hygiejnisk)'],
    ['Surgical Stainless Steel (Cooling & Easy to Sanitize)', 'Kirurgisk rustfrit stål (Kølende & hygiejnisk)'],
    ['Hygienischer Drehverschluss (Auslaufsicher)', 'Hygiejnisk drejelås (Ingen lækager)'],
    ['Hygienic Twist-Lock Dispenser (Leak-Proof)', 'Hygiejnisk drejelås (Ingen lækager)'],
    ['Präzise Dosierung während der Massage', 'Præcis dosering under massagen'],
    ['Precise Cream Dispensing During Massage', 'Præcis dosering under massagen'],
    ['Tiefe horizontaler Halsfalten nach 14 Tagen', 'Dybde af tværgående halsrynker efter 14 dage'],
    ['Depth of horizontal neck lines after 14 days', 'Dybde af tværgående halsrynker efter 14 dage'],
    ['DERMATOLOGISCHE KLINISCHE FORMEL', 'DERMATOLOGISK KLINISK FORMEL'],
    ['DERMATOLOGICAL CLINICAL FORMULATION', 'DERMATOLOGISK KLINISK FORMEL'],
    ['Die duale Wissenschaft hinter dem Set', 'Den dobbelte videnskab bag sættet'],
    ['The Dual-Action Science Behind the Regimen', 'Den dobbelte videnskab bag sættet'],
    ['PDRN (Lachs-DNA)', 'PDRN (Lakse-DNA)'],
    ['PDRN (Salmon DNA)', 'PDRN (Lakse-DNA)'],
    ['Zelluläre DNA-Reparatur', 'Cellulær DNA-reparation'],
    ['Cellular DNA Repair', 'Cellulær DNA-reparation'],
    ['5% Volufiline™ (Frankreich)', '5% Volufiline™ (Frankrig)'],
    ['5% Volufiline™ (France)', '5% Volufiline™ (Frankrig)'],
    ['Natürlicher Aufpolsterungseffekt', 'Naturlig volumenopbyggende vævseffekt'],
    ['Natural Lipofilling Plumping Effect', 'Naturlig volumenopbyggende vævseffekt'],
    ['Mechanische Gua Sha Lymphdrainage', 'Mekanisk Gua Sha lymfedrænage'],
    ['Mechanical Gua Sha Lymphatic Drainage', 'Mekanisk Gua Sha lymfedrænage'],
    ['Mikrozirkulation & Gewebestimulation', 'Stimulering af mikrocirkulation & væv'],
    ['Microcirculation & Tissue Stimulation', 'Stimulering af mikrocirkulation & væv'],
    ['KLINISCH GETESTET AN 34 PROBANDEN (4 WOCHEN)', 'KLINISK TESTET PÅ 34 DELTAGERE (4 UGER)'],
    ['CLINICALLY TESTED ON 34 PARTICIPANTS (4 WEEKS)', 'KLINISK TESTET PÅ 34 DELTAGERE (4 UGER)'],
    ['Messbare klinische Ergebnisse statt leerer Versprechen', 'Målbare kliniske resultater, ikke tomme løfter'],
    ['Measurable Clinical Results Instead of Empty Promises', 'Målbare kliniske resultater, ikke tomme løfter'],
    ['Straffere Kieferkontur & V-Shape', 'Mere defineret kæbelinje & V-form'],
    ['Firmer Jawline & V-Contour', 'Mere defineret kæbelinje & V-form'],
    ['Glattere Hals- & Dekolleté-Zone', 'Glatte hals- & dekolletélinjer'],
    ['Smoother Neck & Décolleté Area', 'Glatte hals- & dekolletélinjer'],
    ['Sofortige Frische & Kühleffekt', 'Øjeblikkelig friskhed & køling'],
    ['Instant Freshness & Cooling Relief', 'Øjeblikkelig friskhed & køling'],
    ['HÄUFIG GESTELLTE FRAGEN', 'OFTE STILLEDE SPØRGSMÅL'],
    ['FREQUENTLY ASKED QUESTIONS', 'OFTE STILLEDE SPØRGSMÅL'],
    ['Alles, was du über das 5-teilige Set wissen musst', 'Alt hvad du behøver at vide om det 5-delte sæt'],
    ['Everything You Need to Know About the 5-Piece Set', 'Alt hvad du behøver at vide om det 5-delte sæt'],
    ['In welcher genauen Reihenfolge soll ich die 5 Produkte anwenden?', 'I hvilken rækkefølge skal produkterne anvendes?'],
    ['In what exact order should I apply the 5 products?', 'I hvilken rækkefølge skal produkterne anvendes?'],
    ['LIMITIERTE AKTION • 75% RABATT', 'BEGRÆNSET TILBUD • SPAR 75%'],
    ['LIMITED OFFER • 75% OFF', 'BEGRÆNSET TILBUD • SPAR 75%'],
    ['Bereit für deine straffeste Kontur & jugendlichen Glow?', 'Er du klar til din mest definerede kæbelinje og ungdommelige glød?'],
    ['Ready for your firmest contour & youthful glow?', 'Er du klar til din mest definerede kæbelinje og ungdommelige glød?'],
    ['Hol dir jetzt alle 5 K-Beauty Bestseller im Vorteilspaket für nur', 'Få alle 5 K-Beauty bestsellere i en eksklusiv fordelspakke til kun'],
    ['Get all 5 K-Beauty bestsellers in the exclusive value bundle for only', 'Få alle 5 K-Beauty bestsellere i en eksklusiv fordelspakke til kun'],
    ['statt 139,00 € UVP', 'vejl. pris 139,00 €'],
    ['instead of €139.00 MSRP', 'vejl. pris 139,00 €'],
    ['Schneller DHL-Versand (1-3 Tage)', 'Hurtig DHL-levering (1-3 hverdage)'],
    ['Fast DHL Shipping (1-3 Days)', 'Hurtig DHL-levering (1-3 hverdage)'],

    // Reviews
    ['Kundenbewertungen', 'Kundeanmeldelser'],
    ['Customer Reviews', 'Kundeanmeldelser'],
    ['Verifizierte Erfahrungen', 'Verificerede oplevelser'],
    ['Verified Experiences', 'Verificerede oplevelser'],
    ['Bewertung schreiben', 'Skriv en anmeldelse'],
    ['Write a Review', 'Skriv en anmeldelse'],
    ['5 Sterne', '5 stjerner'],
    ['5 Stars', '5 stjerner'],
    ['4 Sterne', '4 stjerner'],
    ['4 Stars', '4 stjerner'],
    ['3 Sterne', '3 stjerner'],
    ['3 Stars', '3 stjerner'],
    ['2 Sterne', '2 stjerner'],
    ['2 Stars', '2 stjerner'],
    ['1 Stern', '1 stjerne'],
    ['1 Star', '1 stjerne'],
    ['Basierend auf', 'Baseret på'],
    ['Based on', 'Baseret på'],
    ['verifizierten Bewertungen', 'verificerede anmeldelser'],
    ['verified reviews', 'verificerede anmeldelser'],
    ['Verifiziert', 'Verificeret'],
    ['Verified', 'Verificeret'],
    ['Hilfreich', 'Nyttig'],
    ['Helpful', 'Nyttig'],

    // Tabs / Accordions
    ['Vorteile & Wirkung', 'Fordele & Virkning'],
    ['Benefits & Efficacy', 'Fordele & Virkning'],
    ['Klinische Studien & Wirksamkeit', 'Kliniske studier & Resultater'],
    ['Clinical Studies & Results', 'Kliniske studier & Resultater'],
    ['Reinheitsgarantie & Inhaltsstoffe', 'Ren formel & Ingredienser'],
    ['Clean Formula & Ingredients', 'Ren formel & Ingredienser'],
    ['Anwendung & Routine-Schritte', 'Anvendelse & Rutinetrin'],
    ['How to Use & Routine Steps', 'Anvendelse & Rutinetrin'],
    ['Häufig gestellte Fragen (FAQ)', 'Ofte stillede spørgsmål (FAQ)'],
    ['Frequently Asked Questions (FAQ)', 'Ofte stillede spørgsmål (FAQ)'],
    ['Vorteile des Abonnements (30% Rabatt)', 'Abonnementsfordele (30% rabat)'],
    ['Subscription Benefits (30% Off)', 'Abonnementsfordele (30% rabat)'],
    ['✓ Ohne Duftstoffe', '✓ Uden parfume'],
    ['✓ Fragrance-Free', '✓ Uden parfume'],
    ['✓ Ohne Parabene', '✓ Uden parabener'],
    ['✓ Paraben-Free', '✓ Uden parabener'],
    ['✓ Ohne Silikone', '✓ Uden silikone'],
    ['✓ Silicone-Free', '✓ Uden silikone'],
    ['✓ Ohne Sulfate', '✓ Uden sulfater'],
    ['✓ Sulfate-Free', '✓ Uden sulfater'],
    ['✓ Cruelty-Free', '✓ Cruelty-Free (Ikke testet på dyr)'],
    ['✓ Nicht-komedogen', '✓ Non-comedogen (Tilstopper ikke porerne)'],
    ['✓ Non-Comedogenic', '✓ Non-comedogen (Tilstopper ikke porerne)'],

    // Cart Drawer
    ['Dein Warenkorb ist noch leer', 'Din indkøbskurv er tom i øjeblikket'],
    ['Your cart is currently empty', 'Din indkøbskurv er tom i øjeblikket'],
    ['Dein Warenkorb', 'Din indkøbskurv'],
    ['Your Cart', 'Din indkøbskurv'],
    ['Warenkorb', 'Indkøbskurv'],
    ['Cart', 'Indkøbskurv'],
    ['ZUR KASSE • SICHERE ZAHLUNG', 'GÅ TIL KASSEN • SIKKER BETALING'],
    ['CHECKOUT • SECURE PAYMENT', 'GÅ TIL KASSEN • SIKKER BETALING'],
    ['Zur Kasse', 'Gå til kassen'],
    ['Checkout', 'Gå til kassen'],
    ['Kostenloser Versand freigeschaltet!', 'Gratis levering opnået!'],
    ['Free shipping unlocked!', 'Gratis levering opnået!'],

    // Homepage
    ['Jetzt im Trend:', 'Trender lige nu:'],
    ['Trending Now:', 'Trender lige nu:'],
    ['Koreanische Skincare', 'Koreansk hudpleje'],
    ['Korean Skincare', 'Koreansk hudpleje'],
    ['Geräte', 'Enheder'],
    ['Devices', 'Enheder'],
    ['ALLE ANZEIGEN', 'SE ALLE'],
    ['VIEW ALL', 'SE ALLE'],
    ['JETZT SHOPPEN', 'KØB NU'],
    ['SHOP NOW', 'KØB NU'],
    ['Jetzt shoppen', 'Køb nu'],
    ['Shop Now', 'Køb nu'],
    ['ECHTE ERFAHRUNGEN UNSERER COMMUNITY', 'ÆGTE OPLEVELSER FRA VORES FÆLLESSKAB'],
    ['REAL EXPERIENCES FROM OUR COMMUNITY', 'ÆGTE OPLEVELSER FRA VORES FÆLLESSKAB'],
    ['100% dermatologisch', '100% testet af'],
    ['100% Dermatologist', '100% testet af'],
    ['getestet.', 'hudlæger.'],
    ['Tested.', 'hudlæger.'],
    ['Klinisch bewiesene<br>K-Beauty Formeln.', 'Klinisk dokumenterede<br>K-Beauty formler.'],
    ['Clinically Proven<br>K-Beauty Formulas.', 'Klinisk dokumenterede<br>K-Beauty formler.'],
    ['Klinisch bewiesene K-Beauty Formeln.', 'Klinisk dokumenterede K-Beauty formler.'],
    ['Clinically proven K-Beauty formulas.', 'Klinisk dokumenterede K-Beauty formler.']
  ];

  window.MC_SV_PHRASES = [
    ["6-in-1 Klinische Pflege (Neuheit)", "6-i-1 Klinisk vård (Nyhet)"],
    ["Bestseller Elektroporation & EMS", "Bästsäljare • Elektroporation & EMS"],
    ["40.68 MHz Radiofrequenz Kollagenboost", "40.68 MHz Radiofrekvens kollagenboost"],
    ["Kompakter Glow für unterwegs", "Kompakt lyster på farten"],
    ["Klärende Körperpflege & Blemish-Control", "Rengörande kropppsvård & blemish-kontrol"],
    ["Pflegeroutine wählen:", "Välj din rutin:"],
    ["🔥 87% wählen das Bestseller-Set", "🔥 87% väljer Bästsäljar-paketet"],
    ["Bestseller-Set", "Bästsäljar-paket"],
    ["Bestseller-Duo", "Bästsäljar-duo"],
    ["/ Produkt • 330ml Routine", "/ produkt • 330ml rutin"],
    ["/ Flasche • 560ml Vorrat", "/ flaske • 560ml förråd"],
    ["Sanftes Peeling für den Körper gegen Unreinheiten & Blemishes", "Skonsam kroppspeeling mod orenheter og blemishes"],
    ["Konzentriertes Klärendes Peeling-Serum für das Gesicht", "Koncentreret rengörande peelingserum til ansigtet"],
    ["Beinhaltet BEIDE Produkte • Maximale Ergebnisse & Glass-Skin-Glow", "Indeholder BEGGE produkter • Maksimale resultater og glass-skin-lyster"],
    ["Vorratspack für maximale Langzeitergebnisse • Spare zusätzlich 7 €", "Fördelspaket til maksimale langtidsresultater • Spara yderligere 7 €"],
    ["🔥 BESTSELLER-SET • SPARE 23%", "🔥 BESTSELLER-SÆT • SPARA 23%"],
    ["🔥 BESTSELLER — 20% RABATT", "🔥 BESTSELLER — 20% RABATT"],
    ["💎 MAXIMALER VORTEIL • SPARE 31%", "💎 MAKSIMAL FORDEL • SPARA 31%"],
    ["Wähle deine Pflegeroutine.", "Välj din hudvårdsrutin."],
    ["DAS OPTIMALE SET", "DET OPTIMALE SÆT"],
    ["Hol dir das Komplett-Duo für Gesicht & Körper und spare 23% gegenüber dem Einzelkauf.", "Få det komplette duo-paket til ansigt og kropp og spar 23% i forhold til enkeltkøb."],
    ["Mit dem Bestseller-Duo sparst du 20 %", "Med Bästsäljar-duon sparer du 20%"],
    ["AB 30 JAHREN (BESTSELLER)", "FRA 30 ÅR (BESTSELLER)"],
    ["originalen koreanischen Bestsellern", "originale koreanske bestsellere"],
    ["ausgewählte MediCube Skincare-Bestseller.", "udvalgte MediCube hudvårdbestsellere."],
    ["Entdecke unsere meistverkauften K-Beauty Bestseller und starte deine Hautpflege-Routine.", "Opdag vores bedst sælgende K-Beauty bestsellere og start din hudvårdrutin."],
    ["Bestseller für maximale Ergebnisse & sofortigen Glow", "Bästsäljare for maksimale resultater & øjeblikkelig lyster"],
    ["Alle Bestseller ansehen", "Se alla bestsellere"],
    ["Perfekt abgestimmte K-Beauty Bestseller für deine tägliche Pflegeroutine.", "Perfekt afstemte K-Beauty bestsellere til din daglige plejerutin."],
    ["KÖRPERPFLEGE", "KROPSPLEJE"],
    ["-30% RABATT", "30% RABATT"],
    ["Rice Body Peel Shot (280ml)", "Rice Body Peel Shot (280ml)"],
    ["Rice Face Peel Shot (50ml)", "Rice Face Peel Shot (50ml)"],
    ["Komplettes Duo-Set (Body + Face)", "Komplet Duo-paket (Kropp + Ansigt)"],
    ["2x Komplettes Duo-Set (2x Body + 2x Face)", "2x Komplet Duo-paket (2x Kropp + 2x Ansigt)"],
    ["🔬 DERMATOLOGISCHE INNOVATION", "🔬 DERMATOLOGISK INNOVATION"],
    ["Die Kraft von Hypochlorous Acid & koreanischem Reis-Extrakt", "Kraften af hypoklorsyre og koreansk risekstrakt"],
    ["Klärende Anti-Blemish Formel", "Rengörande anti-blemish formel"],
    ["Mikro-Peeling & Textur-Glättung", "Mikroppeeling & udglatning af tekstur"],
    ["Oryza Sativa Reis-Glow", "Oryza Sativa rislyster"],
    ["100% Barriere-Schonend", "100% barrierevenlig"],
    ["📊 KLINISCH ERWIESENE WIRKUNG", "📊 KLINISK DOKUMENTERET EFFEKT"],
    ["Sichtbare Ergebnisse ab der 1. Anwendung", "Synlige resultater fra 1. anvendelse"],
    ["Weniger Unreinheiten & Pickel", "Færre orenheter & finnar"],
    ["Verfeinerte Poren & Talgkontrolle", "Forfinede porer & talgkontrol"],
    ["Glattere, ebenmäßige Hauttextur", "Glatte, ensartet hudtekstur"],
    ["0.00% Reizungsindex • Hypoallergen getestet • Für empfindlichste Hauttypen geeignet", "0.00% irritationsindeks • Hypoallergent testet • Velegnet til sensitiv hud"],
    ["✨ ANWENDUNGS-ROUTINE", "✨ ANVENDELSESRUTINE"],
    ["So wendest du das Hypochlorous Acid System an", "Sådan anvender du Hypochlorous Acid-systemet"],
    ["KÖRPERPFLEGE (DUSCHE)", "KROPSPLEJE (BRUSER)"],
    ["GESICHTSPFLEGE (SERUM)", "ANSIGTSPLEJE (SERUM)"],
    ["BARRIERE & HYDRATION", "BARRIERE & FUGT"],
    ["Feuchtigkeit & Schutz", "Fugt & beskyttelse"],
    ["📅 Anwendung: 2–3x pro Woche", "📅 Anvendelse: 2–3x om ugen"],
    ["📅 Anwendung: Täglich (Morgens & Abends)", "📅 Anvendelse: Dagligt (Morgen & Aften)"],
    ["📅 Anwendung: Im Anschluss an Schritt 2", "📅 Anvendelse: Efter trin 2"],
    ["❓ HÄUFIGE FRAGEN", "❓ OFTE STILLEDE SPØRGSMÅL"],
    ["Fragen & Antworten zum Hypochlorous System", "Spørgsmål & svar om Hypochlorous-systemet"],
    ["⚡ KOSTENLOSER DHL-VERSAND • 30 TAGE GELD-ZURÜCK-GARANTIE ⚡", "⚡ GRATIS DHL-LEVERING • 30 DAGES TILFREDSHEDSGARANTI ⚡"],
    ["⚡ FREE DHL SHIPPING • 30-DAY MONEY-BACK GUARANTEE ⚡", "⚡ GRATIS DHL-LEVERING • 30 DAGES TILFREDSHEDSGARANTI ⚡"],
    ["AGE-R Beauty Tech Geräte", "AGE-R Beauty Tech Apparater"],
    ["AGE-R Beauty Devices", "AGE-R Beauty Tech Apparater"],
    ["Hautpflege-Linien", "Hudvårdslinjer"],
    ["Skincare Lines", "Hudvårdslinjer"],
    ["Hautpflege", "Hudvård"],
    ["Skincare", "Hudvård"],
    ["Zero Poren-Linie (Poren & Sebum)", "Zero Pore-serien (Porominimering & Sebum)"],
    ["Zero Pore Line (Pores & Sebum)", "Zero Pore-serien (Porominimering & Sebum)"],
    ["Zero Poren-Linie", "Zero Pore-serien"],
    ["Zero Pore Line", "Zero Pore-serien"],
    ["Triple Collagen & Glow (Straffung & Elastizität)", "Triple Collagen & Glow (Løft & Fasthed)"],
    ["Triple Collagen & Glow (Lifting & Firmness)", "Triple Collagen & Glow (Løft & Fasthed)"],
    ["Triple Collagen & Glow (Firming & Elasticity)", "Triple Collagen & Glow (Løft & Fasthed)"],
    ["Triple Collagen & Glow", "Triple Collagen & Glow"],
    ["Pink PDRN Linie (Barriere & Peptide)", "Pink PDRN-serien (Barriere & Peptider)"],
    ["Pink PDRN Line (Barrier & Peptides)", "Pink PDRN-serien (Barriere & Peptider)"],
    ["Pink PDRN Regeneration", "Pink PDRN-fornyelse"],
    ["Pink PDRN Linie", "Pink PDRN-serien"],
    ["Pink PDRN Line", "Pink PDRN-serien"],
    ["Exosome Super Cica (Beruhigung)", "Exosome Super Cica (Beroligende)"],
    ["Exosome Super Cica (Calming & Soothing)", "Exosome Super Cica (Beroligende)"],
    ["Exosome Super Cica", "Exosome Super Cica"],
    ["Deep Vitamin C (Anti-Aging & Flecken)", "Deep Vitamin C (Anti-Aging & Lyster)"],
    ["Deep Vitamin C (Anti-Aging & Radiance)", "Deep Vitamin C (Anti-Aging & Lyster)"],
    ["Deep Vitamin C Anti-Aging", "Deep Vitamin C Anti-Aging"],
    ["Red Akne-Linie (Unreine Haut)", "Red Acne-serien (Uren hud)"],
    ["Red Acne Line (Blemish Care)", "Red Acne-serien (Uren hud)"],
    ["Red Akne-Pflege", "Red Acne-pleje"],
    ["Red Acne Care", "Red Acne-pleje"],
    ["TXA & Kojisäure (Aufhellung)", "TXA & Kojisukker (Lysnende)"],
    ["TXA & Kojic Acid (Brightening)", "TXA & Kojisukker (Lysnende)"],
    ["TXA & Kojisäure Aufhellung", "TXA & Kojisukker lysning"],
    ["Nach Pflegelinie", "Efter hudvårdserie"],
    ["By Skincare Line", "Efter hudvårdserie"],
    ["Nach Kategorie", "Efter kategori"],
    ["By Category", "Efter kategori"],
    ["Reinigung & Cleanser", "Renseprodukter & Cleansers"],
    ["Cleansers & Cleansing", "Renseprodukter & Cleansers"],
    ["Toner & Peeling-Pads", "Tonere & Eksfolierende pads"],
    ["Toners & Exfoliating Pads", "Tonere & Eksfolierende pads"],
    ["Seren & Ampullen", "Sera & Ampuller"],
    ["Serums & Ampoules", "Sera & Ampuller"],
    ["Cremes & Feuchtigkeit", "Cremer & Fugtgivende pleje"],
    ["Creams & Moisturizers", "Cremer & Fugtgivende pleje"],
    ["Gesichtsmasken & Wrapping", "Sheet-masker & Natindpakning"],
    ["Sheet Masks & Night Wrapping", "Sheet-masker & Natindpakning"],
    ["Sheet Masks & Wrapping", "Sheet-masker & Natindpakning"],
    ["Sonnenschutz (SPF)", "Solbeskyttelse (SPF)"],
    ["Sun Protection (SPF)", "Solbeskyttelse (SPF)"],
    ["Sets & Duos", "Paket & Fördelspaket"],
    ["Sets & Bundles", "Paket & Fördelspaket"],
    ["Vorteils-Sets & Duos", "Fördelspaket & Duos"],
    ["Value Sets & Bundles", "Fördelspaket & Duos"],
    ["Bestseller", "Bästsäljare"],
    ["Bestsellers", "Bästsäljare"],
    ["AGE-R Guide & Anleitung", "AGE-R Guide & Instruktioner"],
    ["AGE-R Guide & Instructions", "AGE-R Guide & Instruktioner"],
    ["Über uns", "Om os"],
    ["About Us", "Om os"],
    ["Hilfe & Kundenservice", "Hjälp & Kundservice"],
    ["Help & Support", "Hjälp & Kundservice"],
    ["Hilfe & Kontakt", "Hjälp & Kundservice"],
    ["Help & Contact", "Hjälp & Kundservice"],
    ["Mein Konto / Anmelden", "Mitt konto / Logga in"],
    ["My Account / Sign In", "Mitt konto / Logga in"],
    ["Alle Produkte", "Alle produkter"],
    ["All Products", "Alle produkter"],
    ["Geräte-Leitgele & Zubehör →", "Enhedsgeler & tilbehør →"],
    ["Device Gels & Accessories →", "Enhedsgeler & tilbehør →"],
    ["Alle Technologien im Überblick →", "Oversigt over alle teknologier →"],
    ["Explore All Technologies →", "Oversigt over alle teknologier →"],
    ["🔥 5-TEILIGES KOMPLETT-SET • 105 € SPAREN (75% VORTEIL)", "🔥 5-DELT KOMPLET SÆT • SPARA 105 € (75% RABATT)"],
    ["🔥 5-PIECE COMPLETE SET • SAVE €105 (75% OFF)", "🔥 5-DELT KOMPLET SÆT • SPARA 105 € (75% RABATT)"],
    ["SPAREN 75%", "SPARA 75%"],
    ["SAVE 75%", "SPARA 75%"],
    ["SPAREN 24%", "SPARA 24%"],
    ["SAVE 24%", "SPARA 24%"],
    ["SPAREN 31%", "SPARA 31%"],
    ["SAVE 31%", "SPARA 31%"],
    ["139,00 € UVP", "139,00 € VEJL."],
    ["€139.00 MSRP", "139,00 € VEJL."],
    ["34,00 € KOMPLETT-SET", "34,00 € KOMPLET SÆT"],
    ["€34.00 COMPLETE SET", "34,00 € KOMPLET SÆT"],
    ["Wissenschaftlich fundiert", "Vetenskapligt dokumenterat"],
    ["Backed by Science", "Vetenskapligt dokumenterat"],
    ["80+ von Experten begutachtete Studien hinter unserer Formel.", "80+ peer-reviewed studier understøtter vores formel."],
    ["80+ peer-reviewed studies supporting our formula.", "80+ peer-reviewed studier understøtter vores formel."],
    ["Studien ansehen & mehr erfahren", "Se studier & lær mere"],
    ["View studies & learn more", "Se studier & lær mere"],
    ["Oder in 3 zinsfreien Raten von", "Eller 3 rentefri rater på"],
    ["Or 3 interest-free installments of", "Eller 3 rentefri rater på"],
    ["mit Klarna", "med Klarna"],
    ["with Klarna", "med Klarna"],
    ["Mehr erfahren", "Læs mere"],
    ["Learn more", "Læs mere"],
    ["IN DEN WARENKORB", "LÄGG I VARUKORGEN"],
    ["ADD TO CART", "LÄGG I VARUKORGEN"],
    ["In den Warenkorb", "Lägg i varukorgen"],
    ["Add to Cart", "Lägg i varukorgen"],
    ["Add to cart", "Lägg i varukorgen"],
    ["Wird hinzugefügt...", "Lägger till..."],
    ["Adding...", "Lägger till..."],
    ["AUSVERKAUFT", "SLUTSÅLD"],
    ["SOLD OUT", "SLUTSÅLD"],
    ["Ausverkauft", "Slutsåld"],
    ["Sold Out", "Slutsåld"],
    ["Sold out", "Slutsåld"],
    ["LIMITIERTES TAGESANGEBOT", "BEGRÄNSAT DAGSERBJUDANDE"],
    ["LIMITED DAILY OFFER", "BEGRÄNSAT DAGSERBJUDANDE"],
    ["Aktion endet in:", "Tilbuddet slutar om:"],
    ["Deal ends in:", "Tilbuddet slutar om:"],
    ["Pflegeroutine wählen:", "Välj din rutin:"],
    ["Choose your routine:", "Välj din rutin:"],
    ["🔥 87% wählen das Bestseller-Set", "🔥 87% väljer Bästsäljar-paketet"],
    ["🔥 87% choose the Bestseller Set", "🔥 87% väljer Bästsäljar-paketet"],
    ["1x Body Peel", "1x Body Peel"],
    ["280ml • Sanftes Körperpeeling", "280ml • Skonsam kroppseksfoliering"],
    ["280ml • Gentle Body Exfoliator", "280ml • Skonsam kroppseksfoliering"],
    ["1x Face Peel", "1x Face Peel"],
    ["50ml • Klärendes Gesichtsserum", "50ml • Rensende ansigtsserum"],
    ["50ml • Clarifying Facial Serum", "50ml • Rensende ansigtsserum"],
    ["Duo-Set (Body + Face)", "Duo-paket (Kropp + Ansigt)"],
    ["Duo Set (Body + Face)", "Duo-paket (Kropp + Ansigt)"],
    ["+ 1 GRATIS", "+ 1 GRATIS"],
    ["+ 1 FREE", "+ 1 GRATIS"],
    ["2x Body Peel Doppelpack", "2x Body Peel Dobbeltpakke"],
    ["2x Body Peel Value Pack", "2x Body Peel Dobbeltpakke"],
    ["+ 2 GRATIS", "+ 2 GRATIS"],
    ["+ 2 FREE", "+ 2 GRATIS"],
    ["🔥 Meistgewählt", "🔥 Mest populær"],
    ["🔥 Most Popular", "🔥 Mest populær"],
    ["💎 Bester Wert", "💎 Bedste værdi"],
    ["💎 Best Value", "💎 Bedste værdi"],
    ["Spare 11,95 €", "Spara 11,95 €"],
    ["Save €11.95", "Spara 11,95 €"],
    ["Spare 8,00 €", "Spara 8,00 €"],
    ["Save €8.00", "Spara 8,00 €"],
    ["Spare 30,95 €", "Spara 30,95 €"],
    ["Save €30.95", "Spara 30,95 €"],
    ["DEINE GESCHENKE ZUR BESTELLUNG", "DINE GRATIS GAVER MED ORDREN"],
    ["YOUR FREE GIFTS WITH PURCHASE", "DINE GRATIS GAVER MED ORDREN"],
    ["Kostenloser Versand", "Gratis levering"],
    ["Free Shipping", "Gratis levering"],
    ["1x GRATIS Flasche", "1x GRATIS flaske"],
    ["1x FREE Bottle", "1x GRATIS flaske"],
    ["2x GRATIS Flaschen", "2x GRATIS flasker"],
    ["2x FREE Bottles", "2x GRATIS flasker"],
    ["🔒 Ab 2x Vorrat", "🔒 Låses op ved 2x forsyning"],
    ["🔒 Unlocks with 2x Supply", "🔒 Låses op ved 2x forsyning"],
    ["Abo & Sparen (30% Rabatt)", "Abonnér & spar (30% rabatt)"],
    ["Subscribe & Save (30% Off)", "Abonnér & spar (30% rabatt)"],
    ["30% Dauerrabatt auf jede Folgelieferung. Jederzeit mit 1 Klick kündbar.", "30% fast rabatt på hver efterfølgende levering. Opsig når som helst med 1 klik."],
    ["30% recurring discount on every auto-delivery. Cancel anytime in 1 click.", "30% fast rabatt på hver efterfølgende levering. Opsig når som helst med 1 klik."],
    ["Kostenlose Lieferung", "Gratis levering"],
    ["Free Delivery", "Gratis levering"],
    ["30% Rabatt auf jede Folgebestellung", "30% rabatt på enhver genbestilling"],
    ["30% off every follow-up order", "30% rabatt på enhver genbestilling"],
    ["Jederzeit pausieren, anpassen oder mit 1 Klick kündigen", "Paket på pause, tilpas eller opsig når som helst med 1 klik"],
    ["Pause, adjust, or cancel anytime in 1 click", "Paket på pause, tilpas eller opsig når som helst med 1 klik"],
    ["Im 5-teiligen Vorteilspaket enthalten:", "Indeholdt i det 5-delte fordelspaket:"],
    ["Included in the 5-Piece Value Bundle:", "Indeholdt i det 5-delte fordelspaket:"],
    ["Included in the 5-piece value bundle:", "Indeholdt i det 5-delte fordelspaket:"],
    ["Häufig zusammen gekauft", "Købes ofte sammen"],
    ["Frequently Bought Together", "Købes ofte sammen"],
    ["Von Dermatologen empfohlene Routine-Ergänzungen für maximale Ergebnisse:", "Hudlægeanbefalede rutintilføjelser for maksimale resultater:"],
    ["Dermatologist-recommended routine additions for maximum results:", "Hudlægeanbefalede rutintilføjelser for maksimale resultater:"],
    ["+ Hinzufügen", "+ Tilføj"],
    ["+ Add", "+ Tilføj"],
    ["Hinzugefügt", "Tilføjet"],
    ["Added", "Tilføjet"],
    ["Größe / Variante:", "Størrelse / Variant:"],
    ["Size / Variant:", "Størrelse / Variant:"],
    ["VORTEILSPACK", "FORDELSPAKKE"],
    ["VALUE PACK", "FORDELSPAKKE"],
    ["Schneller Versand: 1-3 Werktage innerhalb Deutschlands & EU", "Hurtig levering: 1-3 hverdage med DHL"],
    ["Fast Shipping: 1-3 business days delivery via DHL", "Hurtig levering: 1-3 hverdage med DHL"],
    ["100% Original K-Beauty: Direkt vom autorisierten Hersteller", "100% Ægte K-Beauty: Direkte fra autoriseret producent"],
    ["100% Authentic K-Beauty: Direct from authorized manufacturer", "100% Ægte K-Beauty: Direkte fra autoriseret producent"],
    ["30 Tage Zufriedenheits-Garantie: Risikofrei testen", "30 dages tilfredshedsgaranti: Prøv helt risikofrit"],
    ["30-Day Satisfaction Guarantee: Risk-free trial", "30 dages tilfredshedsgaranti: Prøv helt risikofrit"],
    ["30-Tage Geld-zurück-Garantie", "30 dages pengene-tilbage-garanti"],
    ["30-Day Money-Back Guarantee", "30 dages pengene-tilbage-garanti"],
    ["30 Tage risikofrei testen. Nicht zufrieden? Volle Erstattung – ohne Wenn und Aber.", "Prøv risikofrit i 30 dage. Ikke tilfreds? Fuld refusion – uden spørgsmål."],
    ["Try risk-free for 30 days. Not satisfied? Full refund – no questions asked.", "Prøv risikofrit i 30 dage. Ikke tilfreds? Fuld refusion – uden spørgsmål."],
    ["Dazu passt perfekt", "Passer perfekt sammen med"],
    ["Pairs Perfectly With", "Passer perfekt sammen med"],
    ["Koreas Nr. 1 Peeling- & Poren-Pad", "Koreas #1 eksfolierende pore-pad"],
    ["Tiefenregeneration mit Lachs-DNA", "Dybdegående cellefornyelse med lakse-PDRN"],
    ["Deep Cellular Repair with Salmon DNA", "Dybdegående cellefornyelse med lakse-PDRN"],
    ["Hauttyp", "Hudtype"],
    ["Skin Type", "Hudtype"],
    ["Haartyp", "Hårtype"],
    ["Hair Type", "Hårtype"],
    ["Hautbedürfnisse", "Hudtilstande"],
    ["Skin Concerns", "Hudtilstande"],
    ["Pflegebedürfnisse", "Plejebehov"],
    ["Care Needs", "Plejebehov"],
    ["Hauptwirkstoffe", "Vigtigste aktive ingredienser"],
    ["Key Active Ingredients", "Vigtigste aktive ingredienser"],
    ["139,00 € GESAMT-EINZELWERT • HEUTE NUR 34,00 €", "139,00 € SAMLET VÆRDI • I DAG KUN 34,00 €"],
    ["€139.00 TOTAL RETAIL VALUE • TODAY ONLY €34.00", "139,00 € SAMLET VÆRDI • I DAG KUN 34,00 €"],
    ["Was ist im 5-teiligen Komplett-Set enthalten?", "Hvad indeholder det 5-delte komplette paket?"],
    ["What is included in the 5-piece complete set?", "Hvad indeholder det 5-delte komplette paket?"],
    ["DAS HERO-PRODUKT", "HERO-PRODUKTET"],
    ["THE HERO PRODUCT", "HERO-PRODUKTET"],
    ["SCHRITT 1", "TRIN 1"],
    ["STEP 1", "TRIN 1"],
    ["SCHRITT 2", "TRIN 2"],
    ["STEP 2", "TRIN 2"],
    ["SCHRITT 3", "TRIN 3"],
    ["STEP 3", "TRIN 3"],
    ["SCHRITT 4", "TRIN 4"],
    ["STEP 4", "TRIN 4"],
    ["SCHRITT 5", "TRIN 5"],
    ["STEP 5", "TRIN 5"],
    ["HALS & DEKOLLETÉ LIFTING", "HALS & DEKOLLETÉ LØFT"],
    ["NECK & DÉCOLLETÉ LIFTING", "HALS & DEKOLLETÉ LØFT"],
    ["KIEFERKONTUR & DOPPELKINN", "KÆBELINJE & DOBBELTHAGE"],
    ["JAWLINE CONTOUR & DOUBLE CHIN", "KÆBELINJE & DOBBELTHAGE"],
    ["AUGEN-DEPOCKING & GLOW", "MOD HÆVEDE ØJNE & GLØD"],
    ["EYE DE-PUFFING & GLOW", "MOD HÆVEDE ØJNE & GLØD"],
    ["KRÄHENFÜSSE & FALTEN", "SMILERYNKER & FINE LINJER"],
    ["GLASS-SKIN FINISH", "GLASS-SKIN FINISH"],
    ["INSTANT GLOW & LIPPEN", "ØJEBLIKKELIG GLØD & LÆBER"],
    ["INSTANT GLOW & LIPS", "ØJEBLIKKELIG GLØD & LÆBER"],
    ["GEZIELTE AUGENPFLEGE", "MÅLRETTET ØJENPLEJE"],
    ["TARGETED EYE CARE", "MÅLRETTET ØJENPLEJE"],
    ["Einzel-UVP:", "Vejl. udsalgspris:"],
    ["Separate MSRP:", "Vejl. udsalgspris:"],
    ["TRANSPARENTER PREISVORTEIL", "GENNEMSKUELIG PRISFORDEL"],
    ["TRANSPARENT VALUE BREAKDOWN", "GENNEMSKUELIG PRISFORDEL"],
    ["SET JETZT SICHERN", "SIKR DIG DIT SÆT NU"],
    ["CLAIM YOUR SET NOW", "SIKR DIG DIT SÆT NU"],
    ["EINFACH & SCHNELL • NUR 5 MINUTEN TÄGLICH", "HURTIGT & NEMT • KUN 5 MINUTTER OM DAGEN"],
    ["FAST & EASY • JUST 5 MINUTES A DAY", "HURTIGT & NEMT • KUN 5 MINUTTER OM DAGEN"],
    ["Deine tägliche 5-Schritte Youth-Lock Routine", "Din daglige 5-trins Youth-Lock rutin"],
    ["Your Daily 5-Step Youth-Lock Regimen", "Din daglige 5-trins Youth-Lock rutin"],
    ["2–3x / WOCHE • 15 MIN", "2–3x / UGE • 15 MIN"],
    ["2–3x / WEEK • 15 MIN", "2–3x / UGE • 15 MIN"],
    ["V-Line Band anlegen", "Påfør V-Line maske"],
    ["Apply V-Line Band", "Påfør V-Line maske"],
    ["TÄGLICH MORGENS • 10 MIN", "DAGLIGT MORGEN • 10 MIN"],
    ["DAILY MORNING • 10 MIN", "DAGLIGT MORGEN • 10 MIN"],
    ["Augenpartie entstauen", "Dæmp hævelser omkring øjnene"],
    ["De-Puff Eye Area", "Dæmp hævelser omkring øjnene"],
    ["MORGENS & ABENDS • 30 SEK", "MORGEN & AFTEN • 30 SEK"],
    ["MORNING & EVENING • 30 SEC", "MORGEN & AFTEN • 30 SEK"],
    ["Falten präzise glätten", "Udjævn fine linjer præcist"],
    ["Target Fine Lines", "Udjævn fine linjer præcist"],
    ["TÄGLICH • 2 MINUTEN", "DAGLIGT • 2 MINUTTER"],
    ["DAILY • 2 MINUTES", "DAGLIGT • 2 MINUTTER"],
    ["Gua Sha Neck Massage", "Gua Sha halsmassage"],
    ["JEDERZEIT • FINISH & GLOW", "NÅR SOM HELST • FINISH & GLØD"],
    ["ANYTIME • FINISH & GLOW", "NÅR SOM HELST • FINISH & GLØD"],
    ["Glass-Skin Glow to-go", "Glass-Skin lyster på farten"],
    ["On-The-Go Glass Skin Glow", "Glass-Skin lyster på farten"],
    ["INTEGRIERTES GUA SHA TOOL • KEIN ZERBRECHLICHER STEIN", "INTEGRERET GUA SHA VÆRKTØJ • INGEN SKØR JADESTEN"],
    ["INTEGRATED GUA SHA TOOL • NO FRAGILE JADE STONE", "INTEGRERET GUA SHA VÆRKTØJ • INGEN SKØR JADESTEN"],
    ["Die richtige Gua Sha Technik: So massierst du wie die K-Beauty Profis", "Den korrekte Gua Sha teknik: Massér som K-Beauty eksperterne"],
    ["The Proper Gua Sha Technique: Massage Like Korean Aesthetic Professionals", "Den korrekte Gua Sha teknik: Massér som K-Beauty eksperterne"],
    ["1. Hals-Lifting gegen Tech-Neck", "1. Halsløft mod Tech-Neck"],
    ["1. Neck Lift Against Tech-Neck", "1. Halsløft mod Tech-Neck"],
    ["2. Jawline & V-Line Definition", "2. Kæbelinje & V-linje definition"],
    ["3. Dekolleté & Lymphatische Drainage", "3. Dekolleté & lymfatisk drænage"],
    ["3. Décolleté & Lymphatic Drainage", "3. Dekolleté & lymfatisk drænage"],
    ["Chirurgischer Edelstahl (Kühlend & Desinfizierbar)", "Kirurgisk rustfrit stål (Kølende & hygiejnisk)"],
    ["Surgical Stainless Steel (Cooling & Easy to Sanitize)", "Kirurgisk rustfrit stål (Kølende & hygiejnisk)"],
    ["Hygienischer Drehverschluss (Auslaufsicher)", "Hygiejnisk drejelås (Ingen lækager)"],
    ["Hygienic Twist-Lock Dispenser (Leak-Proof)", "Hygiejnisk drejelås (Ingen lækager)"],
    ["Präzise Dosierung während der Massage", "Præcis dosering under massagen"],
    ["Precise Cream Dispensing During Massage", "Præcis dosering under massagen"],
    ["Tiefe horizontaler Halsfalten nach 14 Tagen", "Dybde af tværgående halsrynkor efter 14 dage"],
    ["Depth of horizontal neck lines after 14 days", "Dybde af tværgående halsrynkor efter 14 dage"],
    ["DERMATOLOGISCHE KLINISCHE FORMEL", "DERMATOLOGISK KLINISK FORMEL"],
    ["DERMATOLOGICAL CLINICAL FORMULATION", "DERMATOLOGISK KLINISK FORMEL"],
    ["Die duale Wissenschaft hinter dem Set", "Den dobbelte videnskab bag paketet"],
    ["The Dual-Action Science Behind the Regimen", "Den dobbelte videnskab bag paketet"],
    ["PDRN (Lachs-DNA)", "PDRN (Lakse-DNA)"],
    ["PDRN (Salmon DNA)", "PDRN (Lakse-DNA)"],
    ["Zelluläre DNA-Reparatur", "Cellulær DNA-reparation"],
    ["Cellular DNA Repair", "Cellulær DNA-reparation"],
    ["5% Volufiline™ (Frankreich)", "5% Volufiline™ (Frankrig)"],
    ["5% Volufiline™ (France)", "5% Volufiline™ (Frankrig)"],
    ["Natürlicher Aufpolsterungseffekt", "Naturlig volumenopbyggende vævseffekt"],
    ["Natural Lipofilling Plumping Effect", "Naturlig volumenopbyggende vævseffekt"],
    ["Mechanische Gua Sha Lymphdrainage", "Mekanisk Gua Sha lymfedrænage"],
    ["Mechanical Gua Sha Lymphatic Drainage", "Mekanisk Gua Sha lymfedrænage"],
    ["Mikrozirkulation & Gewebestimulation", "Stimulering af mikrocirkulation & væv"],
    ["Microcirculation & Tissue Stimulation", "Stimulering af mikrocirkulation & væv"],
    ["KLINISCH GETESTET AN 34 PROBANDEN (4 WOCHEN)", "KLINISK TESTET PÅ 34 DELTAGERE (4 UGER)"],
    ["CLINICALLY TESTED ON 34 PARTICIPANTS (4 WEEKS)", "KLINISK TESTET PÅ 34 DELTAGERE (4 UGER)"],
    ["Messbare klinische Ergebnisse statt leerer Versprechen", "Målbare kliniske resultater, ikke tomme løfter"],
    ["Measurable Clinical Results Instead of Empty Promises", "Målbare kliniske resultater, ikke tomme løfter"],
    ["Straffere Kieferkontur & V-Shape", "Mere defineret käklinje & V-form"],
    ["Firmer Jawline & V-Contour", "Mere defineret käklinje & V-form"],
    ["Glattere Hals- & Dekolleté-Zone", "Glatte hals- & dekolletélinjer"],
    ["Smoother Neck & Décolleté Area", "Glatte hals- & dekolletélinjer"],
    ["Sofortige Frische & Kühleffekt", "Øjeblikkelig friskhed & køling"],
    ["Instant Freshness & Cooling Relief", "Øjeblikkelig friskhed & køling"],
    ["HÄUFIG GESTELLTE FRAGEN", "OFTE STILLEDE SPØRGSMÅL"],
    ["FREQUENTLY ASKED QUESTIONS", "OFTE STILLEDE SPØRGSMÅL"],
    ["Alles, was du über das 5-teilige Set wissen musst", "Alt hvad du behøver at vide om det 5-delte paket"],
    ["Everything You Need to Know About the 5-Piece Set", "Alt hvad du behøver at vide om det 5-delte paket"],
    ["In welcher genauen Reihenfolge soll ich die 5 Produkte anwenden?", "I hvilken rækkefølge skal produkterne anvendes?"],
    ["In what exact order should I apply the 5 products?", "I hvilken rækkefølge skal produkterne anvendes?"],
    ["LIMITIERTE AKTION • 75% RABATT", "BEGRÆNSET TILBUD • SPARA 75%"],
    ["LIMITED OFFER • 75% OFF", "BEGRÆNSET TILBUD • SPARA 75%"],
    ["Bereit für deine straffeste Kontur & jugendlichen Glow?", "Er du klar til din mest definerede käklinje og ungdommelige lyster?"],
    ["Ready for your firmest contour & youthful glow?", "Er du klar til din mest definerede käklinje og ungdommelige lyster?"],
    ["Hol dir jetzt alle 5 K-Beauty Bestseller im Vorteilspaket für nur", "Få alle 5 K-Beauty bestsellere i en eksklusiv fördelspaket til kun"],
    ["Get all 5 K-Beauty bestsellers in the exclusive value bundle for only", "Få alle 5 K-Beauty bestsellere i en eksklusiv fördelspaket til kun"],
    ["statt 139,00 € UVP", "vejl. pris 139,00 €"],
    ["instead of €139.00 MSRP", "vejl. pris 139,00 €"],
    ["Schneller DHL-Versand (1-3 Tage)", "Hurtig DHL-levering (1-3 hverdage)"],
    ["Fast DHL Shipping (1-3 Days)", "Hurtig DHL-levering (1-3 hverdage)"],
    ["Kundenbewertungen", "Kunderecensioner"],
    ["Customer Reviews", "Kunderecensioner"],
    ["Verifizierte Erfahrungen", "Verificerede oplevelser"],
    ["Verified Experiences", "Verificerede oplevelser"],
    ["Bewertung schreiben", "Skriv en anmeldelse"],
    ["Write a Review", "Skriv en anmeldelse"],
    ["5 Sterne", "5 stjerner"],
    ["5 Stars", "5 stjerner"],
    ["4 Sterne", "4 stjerner"],
    ["4 Stars", "4 stjerner"],
    ["3 Sterne", "3 stjerner"],
    ["3 Stars", "3 stjerner"],
    ["2 Sterne", "2 stjerner"],
    ["2 Stars", "2 stjerner"],
    ["1 Stern", "1 stjerne"],
    ["1 Star", "1 stjerne"],
    ["Basierend auf", "Baseret på"],
    ["Based on", "Baseret på"],
    ["verifizierten Bewertungen", "verificerede recensioner"],
    ["verified reviews", "verificerede recensioner"],
    ["Verifiziert", "Verificeret"],
    ["Verified", "Verificeret"],
    ["Hilfreich", "Nyttig"],
    ["Helpful", "Nyttig"],
    ["Vorteile & Wirkung", "Fordele & Virkning"],
    ["Benefits & Efficacy", "Fordele & Virkning"],
    ["Klinische Studien & Wirksamkeit", "Kliniske studier & Resultater"],
    ["Clinical Studies & Results", "Kliniske studier & Resultater"],
    ["Reinheitsgarantie & Inhaltsstoffe", "Ren formel & Ingredienser"],
    ["Clean Formula & Ingredients", "Ren formel & Ingredienser"],
    ["Anwendung & Routine-Schritte", "Anvendelse & Rutintrin"],
    ["How to Use & Routine Steps", "Anvendelse & Rutintrin"],
    ["Häufig gestellte Fragen (FAQ)", "Ofte stillede spørgsmål (FAQ)"],
    ["Frequently Asked Questions (FAQ)", "Ofte stillede spørgsmål (FAQ)"],
    ["Vorteile des Abonnements (30% Rabatt)", "Abonnementsfordele (30% rabatt)"],
    ["Subscription Benefits (30% Off)", "Abonnementsfordele (30% rabatt)"],
    ["✓ Ohne Duftstoffe", "✓ Uden parfume"],
    ["✓ Fragrance-Free", "✓ Uden parfume"],
    ["✓ Ohne Parabene", "✓ Uden parabener"],
    ["✓ Paraben-Free", "✓ Uden parabener"],
    ["✓ Ohne Silikone", "✓ Uden silikone"],
    ["✓ Silicone-Free", "✓ Uden silikone"],
    ["✓ Ohne Sulfate", "✓ Uden sulfater"],
    ["✓ Sulfate-Free", "✓ Uden sulfater"],
    ["✓ Cruelty-Free", "✓ Cruelty-Free (Ikke testet på dyr)"],
    ["✓ Nicht-komedogen", "✓ Non-comedogen (Tilstopper ikke porerne)"],
    ["✓ Non-Comedogenic", "✓ Non-comedogen (Tilstopper ikke porerne)"],
    ["Dein Warenkorb ist noch leer", "Din indkøbskurv er tom i øjeblikket"],
    ["Your cart is currently empty", "Din indkøbskurv er tom i øjeblikket"],
    ["Dein Warenkorb", "Din indkøbskurv"],
    ["Your Cart", "Din indkøbskurv"],
    ["Warenkorb", "Indkøbskurv"],
    ["Cart", "Indkøbskurv"],
    ["ZUR KASSE • SICHERE ZAHLUNG", "GÅ TIL KASSEN • SIKKER BETALING"],
    ["CHECKOUT • SECURE PAYMENT", "GÅ TIL KASSEN • SIKKER BETALING"],
    ["Zur Kasse", "Gå til kassen"],
    ["Checkout", "Gå til kassen"],
    ["Kostenloser Versand freigeschaltet!", "Gratis levering opnået!"],
    ["Free shipping unlocked!", "Gratis levering opnået!"],
    ["Jetzt im Trend:", "Trender lige nu:"],
    ["Trending Now:", "Trender lige nu:"],
    ["Koreanische Skincare", "Koreansk hudvård"],
    ["Korean Skincare", "Koreansk hudvård"],
    ["Geräte", "Apparater"],
    ["Devices", "Apparater"],
    ["ALLE ANZEIGEN", "SE ALLA"],
    ["VIEW ALL", "SE ALLA"],
    ["JETZT SHOPPEN", "KÖP NU"],
    ["SHOP NOW", "KÖP NU"],
    ["Jetzt shoppen", "Köp nu"],
    ["Shop Now", "Köp nu"],
    ["ECHTE ERFAHRUNGEN UNSERER COMMUNITY", "ÆGTE OPLEVELSER FRA VORES FÆLLESSKAB"],
    ["REAL EXPERIENCES FROM OUR COMMUNITY", "ÆGTE OPLEVELSER FRA VORES FÆLLESSKAB"],
    ["100% dermatologisch", "100% testet af"],
    ["100% Dermatologist", "100% testet af"],
    ["getestet.", "hudlæger."],
    ["Tested.", "hudlæger."],
    ["Klinisch bewiesene<br>K-Beauty Formeln.", "Klinisk dokumenterede<br>K-Beauty formler."],
    ["Clinically Proven<br>K-Beauty Formulas.", "Klinisk dokumenterede<br>K-Beauty formler."],
    ["Klinisch bewiesene K-Beauty Formeln.", "Klinisk dokumenterede K-Beauty formler."],
    ["Clinically proven K-Beauty formulas.", "Klinisk dokumenterede K-Beauty formler."]
  ];

  window.MC_NO_PHRASES = [
    ["6-in-1 Klinische Pflege (Neuheit)", "6-i-1 Klinisk pleie (Nyhet)"],
    ["Bestseller Elektroporation & EMS", "Bestselger • Elektroporation & EMS"],
    ["40.68 MHz Radiofrequenz Kollagenboost", "40.68 MHz Radiofrekvens kollagenboost"],
    ["Kompakter Glow für unterwegs", "Kompakt glød på farten"],
    ["Klärende Körperpflege & Blemish-Control", "Rensende kropppspleie & blemish-kontrol"],
    ["Pflegeroutine wählen:", "Velg din rutine:"],
    ["🔥 87% wählen das Bestseller-Set", "🔥 87% velger Bestselger-settet"],
    ["Bestseller-Set", "Bestselger-sett"],
    ["Bestseller-Duo", "Bestselger-duo"],
    ["/ Produkt • 330ml Routine", "/ produkt • 330ml rutine"],
    ["/ Flasche • 560ml Vorrat", "/ flaske • 560ml forråd"],
    ["Sanftes Peeling für den Körper gegen Unreinheiten & Blemishes", "Skånsom kroppspeeling mod urenheter og blemishes"],
    ["Konzentriertes Klärendes Peeling-Serum für das Gesicht", "Koncentreret rensende peelingserum til ansigtet"],
    ["Beinhaltet BEIDE Produkte • Maximale Ergebnisse & Glass-Skin-Glow", "Indeholder BEGGE produkter • Maksimale resultater og glass-skin-glød"],
    ["Vorratspack für maximale Langzeitergebnisse • Spare zusätzlich 7 €", "Fordelspakke til maksimale langtidsresultater • Spar yderligere 7 €"],
    ["🔥 BESTSELLER-SET • SPARE 23%", "🔥 BESTSELLER-SÆT • SPAR 23%"],
    ["🔥 BESTSELLER — 20% RABATT", "🔥 BESTSELLER — 20% RABATT"],
    ["💎 MAXIMALER VORTEIL • SPARE 31%", "💎 MAKSIMAL FORDEL • SPAR 31%"],
    ["Wähle deine Pflegeroutine.", "Velg din hudpleierutine."],
    ["DAS OPTIMALE SET", "DET OPTIMALE SÆT"],
    ["Hol dir das Komplett-Duo für Gesicht & Körper und spare 23% gegenüber dem Einzelkauf.", "Få det komplette duo-sett til ansigt og kropp og spar 23% i forhold til enkeltkøb."],
    ["Mit dem Bestseller-Duo sparst du 20 %", "Med Bestselger-duoen sparer du 20%"],
    ["AB 30 JAHREN (BESTSELLER)", "FRA 30 ÅR (BESTSELLER)"],
    ["originalen koreanischen Bestsellern", "originale koreanske bestsellere"],
    ["ausgewählte MediCube Skincare-Bestseller.", "udvalgte MediCube hudplejebestsellere."],
    ["Entdecke unsere meistverkauften K-Beauty Bestseller und starte deine Hautpflege-Routine.", "Opdag vores bedst sælgende K-Beauty bestsellere og start din hudplejerutine."],
    ["Bestseller für maximale Ergebnisse & sofortigen Glow", "Bestselgere for maksimale resultater & øjeblikkelig glød"],
    ["Alle Bestseller ansehen", "Se alle bestsellere"],
    ["Perfekt abgestimmte K-Beauty Bestseller für deine tägliche Pflegeroutine.", "Perfekt afstemte K-Beauty bestsellere til din daglige plejerutine."],
    ["KÖRPERPFLEGE", "KROPSPLEJE"],
    ["-30% RABATT", "30% RABATT"],
    ["Rice Body Peel Shot (280ml)", "Rice Body Peel Shot (280ml)"],
    ["Rice Face Peel Shot (50ml)", "Rice Face Peel Shot (50ml)"],
    ["Komplettes Duo-Set (Body + Face)", "Komplet Duo-sett (Kropp + Ansigt)"],
    ["2x Komplettes Duo-Set (2x Body + 2x Face)", "2x Komplet Duo-sett (2x Kropp + 2x Ansigt)"],
    ["🔬 DERMATOLOGISCHE INNOVATION", "🔬 DERMATOLOGISK INNOVATION"],
    ["Die Kraft von Hypochlorous Acid & koreanischem Reis-Extrakt", "Kraften af hypoklorsyre og koreansk risekstrakt"],
    ["Klärende Anti-Blemish Formel", "Rensende anti-blemish formel"],
    ["Mikro-Peeling & Textur-Glättung", "Mikroppeeling & udglatning af tekstur"],
    ["Oryza Sativa Reis-Glow", "Oryza Sativa risglød"],
    ["100% Barriere-Schonend", "100% barrierevenlig"],
    ["📊 KLINISCH ERWIESENE WIRKUNG", "📊 KLINISK DOKUMENTERET EFFEKT"],
    ["Sichtbare Ergebnisse ab der 1. Anwendung", "Synlige resultater fra 1. anvendelse"],
    ["Weniger Unreinheiten & Pickel", "Færre urenheter & kviser"],
    ["Verfeinerte Poren & Talgkontrolle", "Forfinede porer & talgkontrol"],
    ["Glattere, ebenmäßige Hauttextur", "Glatte, ensartet hudtekstur"],
    ["0.00% Reizungsindex • Hypoallergen getestet • Für empfindlichste Hauttypen geeignet", "0.00% irritationsindeks • Hypoallergent testet • Velegnet til sensitiv hud"],
    ["✨ ANWENDUNGS-ROUTINE", "✨ ANVENDELSESRUTINE"],
    ["So wendest du das Hypochlorous Acid System an", "Sådan anvender du Hypochlorous Acid-systemet"],
    ["KÖRPERPFLEGE (DUSCHE)", "KROPSPLEJE (BRUSER)"],
    ["GESICHTSPFLEGE (SERUM)", "ANSIGTSPLEJE (SERUM)"],
    ["BARRIERE & HYDRATION", "BARRIERE & FUGT"],
    ["Feuchtigkeit & Schutz", "Fugt & beskyttelse"],
    ["📅 Anwendung: 2–3x pro Woche", "📅 Anvendelse: 2–3x om ugen"],
    ["📅 Anwendung: Täglich (Morgens & Abends)", "📅 Anvendelse: Dagligt (Morgen & Aften)"],
    ["📅 Anwendung: Im Anschluss an Schritt 2", "📅 Anvendelse: Efter trin 2"],
    ["❓ HÄUFIGE FRAGEN", "❓ OFTE STILLEDE SPØRGSMÅL"],
    ["Fragen & Antworten zum Hypochlorous System", "Spørgsmål & svar om Hypochlorous-systemet"],
    ["⚡ KOSTENLOSER DHL-VERSAND • 30 TAGE GELD-ZURÜCK-GARANTIE ⚡", "⚡ GRATIS DHL-LEVERING • 30 DAGES TILFREDSHEDSGARANTI ⚡"],
    ["⚡ FREE DHL SHIPPING • 30-DAY MONEY-BACK GUARANTEE ⚡", "⚡ GRATIS DHL-LEVERING • 30 DAGES TILFREDSHEDSGARANTI ⚡"],
    ["AGE-R Beauty Tech Geräte", "AGE-R Beauty Tech Enheter"],
    ["AGE-R Beauty Devices", "AGE-R Beauty Tech Enheter"],
    ["Hautpflege-Linien", "Hudplejeserier"],
    ["Skincare Lines", "Hudplejeserier"],
    ["Hautpflege", "Hudpleje"],
    ["Skincare", "Hudpleje"],
    ["Zero Poren-Linie (Poren & Sebum)", "Zero Pore-serien (Porominimering & Sebum)"],
    ["Zero Pore Line (Pores & Sebum)", "Zero Pore-serien (Porominimering & Sebum)"],
    ["Zero Poren-Linie", "Zero Pore-serien"],
    ["Zero Pore Line", "Zero Pore-serien"],
    ["Triple Collagen & Glow (Straffung & Elastizität)", "Triple Collagen & Glow (Løft & Fasthed)"],
    ["Triple Collagen & Glow (Lifting & Firmness)", "Triple Collagen & Glow (Løft & Fasthed)"],
    ["Triple Collagen & Glow (Firming & Elasticity)", "Triple Collagen & Glow (Løft & Fasthed)"],
    ["Triple Collagen & Glow", "Triple Collagen & Glow"],
    ["Pink PDRN Linie (Barriere & Peptide)", "Pink PDRN-serien (Barriere & Peptider)"],
    ["Pink PDRN Line (Barrier & Peptides)", "Pink PDRN-serien (Barriere & Peptider)"],
    ["Pink PDRN Regeneration", "Pink PDRN-fornyelse"],
    ["Pink PDRN Linie", "Pink PDRN-serien"],
    ["Pink PDRN Line", "Pink PDRN-serien"],
    ["Exosome Super Cica (Beruhigung)", "Exosome Super Cica (Beroligende)"],
    ["Exosome Super Cica (Calming & Soothing)", "Exosome Super Cica (Beroligende)"],
    ["Exosome Super Cica", "Exosome Super Cica"],
    ["Deep Vitamin C (Anti-Aging & Flecken)", "Deep Vitamin C (Anti-Aging & Glød)"],
    ["Deep Vitamin C (Anti-Aging & Radiance)", "Deep Vitamin C (Anti-Aging & Glød)"],
    ["Deep Vitamin C Anti-Aging", "Deep Vitamin C Anti-Aging"],
    ["Red Akne-Linie (Unreine Haut)", "Red Acne-serien (Uren hud)"],
    ["Red Acne Line (Blemish Care)", "Red Acne-serien (Uren hud)"],
    ["Red Akne-Pflege", "Red Acne-pleje"],
    ["Red Acne Care", "Red Acne-pleje"],
    ["TXA & Kojisäure (Aufhellung)", "TXA & Kojisukker (Lysnende)"],
    ["TXA & Kojic Acid (Brightening)", "TXA & Kojisukker (Lysnende)"],
    ["TXA & Kojisäure Aufhellung", "TXA & Kojisukker lysning"],
    ["Nach Pflegelinie", "Efter hudplejeserie"],
    ["By Skincare Line", "Efter hudplejeserie"],
    ["Nach Kategorie", "Efter kategori"],
    ["By Category", "Efter kategori"],
    ["Reinigung & Cleanser", "Renseprodukter & Cleansers"],
    ["Cleansers & Cleansing", "Renseprodukter & Cleansers"],
    ["Toner & Peeling-Pads", "Tonere & Eksfolierende pads"],
    ["Toners & Exfoliating Pads", "Tonere & Eksfolierende pads"],
    ["Seren & Ampullen", "Sera & Ampuller"],
    ["Serums & Ampoules", "Sera & Ampuller"],
    ["Cremes & Feuchtigkeit", "Cremer & Fugtgivende pleje"],
    ["Creams & Moisturizers", "Cremer & Fugtgivende pleje"],
    ["Gesichtsmasken & Wrapping", "Sheet-masker & Natindpakning"],
    ["Sheet Masks & Night Wrapping", "Sheet-masker & Natindpakning"],
    ["Sheet Masks & Wrapping", "Sheet-masker & Natindpakning"],
    ["Sonnenschutz (SPF)", "Solbeskyttelse (SPF)"],
    ["Sun Protection (SPF)", "Solbeskyttelse (SPF)"],
    ["Sets & Duos", "Sett & Fordelspakker"],
    ["Sets & Bundles", "Sett & Fordelspakker"],
    ["Vorteils-Sets & Duos", "Fordelspakker & Duos"],
    ["Value Sets & Bundles", "Fordelspakker & Duos"],
    ["Bestseller", "Bestselgere"],
    ["Bestsellers", "Bestselgere"],
    ["AGE-R Guide & Anleitung", "AGE-R Veiledning & Instruktioner"],
    ["AGE-R Guide & Instructions", "AGE-R Veiledning & Instruktioner"],
    ["Über uns", "Om os"],
    ["About Us", "Om os"],
    ["Hilfe & Kundenservice", "Hjelp & Kundeservice"],
    ["Help & Support", "Hjelp & Kundeservice"],
    ["Hilfe & Kontakt", "Hjelp & Kundeservice"],
    ["Help & Contact", "Hjelp & Kundeservice"],
    ["Mein Konto / Anmelden", "Min konto / Logg inn"],
    ["My Account / Sign In", "Min konto / Logg inn"],
    ["Alle Produkte", "Alle produkter"],
    ["All Products", "Alle produkter"],
    ["Geräte-Leitgele & Zubehör →", "Enhedsgeler & tilbehør →"],
    ["Device Gels & Accessories →", "Enhedsgeler & tilbehør →"],
    ["Alle Technologien im Überblick →", "Oversigt over alle teknologier →"],
    ["Explore All Technologies →", "Oversigt over alle teknologier →"],
    ["🔥 5-TEILIGES KOMPLETT-SET • 105 € SPAREN (75% VORTEIL)", "🔥 5-DELT KOMPLET SÆT • SPAR 105 € (75% RABATT)"],
    ["🔥 5-PIECE COMPLETE SET • SAVE €105 (75% OFF)", "🔥 5-DELT KOMPLET SÆT • SPAR 105 € (75% RABATT)"],
    ["SPAREN 75%", "SPAR 75%"],
    ["SAVE 75%", "SPAR 75%"],
    ["SPAREN 24%", "SPAR 24%"],
    ["SAVE 24%", "SPAR 24%"],
    ["SPAREN 31%", "SPAR 31%"],
    ["SAVE 31%", "SPAR 31%"],
    ["139,00 € UVP", "139,00 € VEJL."],
    ["€139.00 MSRP", "139,00 € VEJL."],
    ["34,00 € KOMPLETT-SET", "34,00 € KOMPLET SÆT"],
    ["€34.00 COMPLETE SET", "34,00 € KOMPLET SÆT"],
    ["Wissenschaftlich fundiert", "Videnskabeligt dokumenteret"],
    ["Backed by Science", "Videnskabeligt dokumenteret"],
    ["80+ von Experten begutachtete Studien hinter unserer Formel.", "80+ fagfellevurderte studier understøtter vores formel."],
    ["80+ peer-reviewed studies supporting our formula.", "80+ fagfellevurderte studier understøtter vores formel."],
    ["Studien ansehen & mehr erfahren", "Se studier & lær mere"],
    ["View studies & learn more", "Se studier & lær mere"],
    ["Oder in 3 zinsfreien Raten von", "Eller 3 rentefri rater på"],
    ["Or 3 interest-free installments of", "Eller 3 rentefri rater på"],
    ["mit Klarna", "med Klarna"],
    ["with Klarna", "med Klarna"],
    ["Mehr erfahren", "Læs mere"],
    ["Learn more", "Læs mere"],
    ["IN DEN WARENKORB", "LEGG I HANDLEKURV"],
    ["ADD TO CART", "LEGG I HANDLEKURV"],
    ["In den Warenkorb", "Legg i handlekurv"],
    ["Add to Cart", "Legg i handlekurv"],
    ["Add to cart", "Legg i handlekurv"],
    ["Wird hinzugefügt...", "Legger til..."],
    ["Adding...", "Legger til..."],
    ["AUSVERKAUFT", "UTSOLGT"],
    ["SOLD OUT", "UTSOLGT"],
    ["Ausverkauft", "Utsolgt"],
    ["Sold Out", "Utsolgt"],
    ["Sold out", "Utsolgt"],
    ["LIMITIERTES TAGESANGEBOT", "BEGRENSET DAGSTILBUD"],
    ["LIMITED DAILY OFFER", "BEGRENSET DAGSTILBUD"],
    ["Aktion endet in:", "Tilbuddet utløper om:"],
    ["Deal ends in:", "Tilbuddet utløper om:"],
    ["Pflegeroutine wählen:", "Velg din rutine:"],
    ["Choose your routine:", "Velg din rutine:"],
    ["🔥 87% wählen das Bestseller-Set", "🔥 87% velger Bestselger-settet"],
    ["🔥 87% choose the Bestseller Set", "🔥 87% velger Bestselger-settet"],
    ["1x Body Peel", "1x Body Peel"],
    ["280ml • Sanftes Körperpeeling", "280ml • Skånsom kroppseksfoliering"],
    ["280ml • Gentle Body Exfoliator", "280ml • Skånsom kroppseksfoliering"],
    ["1x Face Peel", "1x Face Peel"],
    ["50ml • Klärendes Gesichtsserum", "50ml • Rensende ansigtsserum"],
    ["50ml • Clarifying Facial Serum", "50ml • Rensende ansigtsserum"],
    ["Duo-Set (Body + Face)", "Duo-sett (Kropp + Ansigt)"],
    ["Duo Set (Body + Face)", "Duo-sett (Kropp + Ansigt)"],
    ["+ 1 GRATIS", "+ 1 GRATIS"],
    ["+ 1 FREE", "+ 1 GRATIS"],
    ["2x Body Peel Doppelpack", "2x Body Peel Dobbeltpakke"],
    ["2x Body Peel Value Pack", "2x Body Peel Dobbeltpakke"],
    ["+ 2 GRATIS", "+ 2 GRATIS"],
    ["+ 2 FREE", "+ 2 GRATIS"],
    ["🔥 Meistgewählt", "🔥 Mest populær"],
    ["🔥 Most Popular", "🔥 Mest populær"],
    ["💎 Bester Wert", "💎 Bedste værdi"],
    ["💎 Best Value", "💎 Bedste værdi"],
    ["Spare 11,95 €", "Spar 11,95 €"],
    ["Save €11.95", "Spar 11,95 €"],
    ["Spare 8,00 €", "Spar 8,00 €"],
    ["Save €8.00", "Spar 8,00 €"],
    ["Spare 30,95 €", "Spar 30,95 €"],
    ["Save €30.95", "Spar 30,95 €"],
    ["DEINE GESCHENKE ZUR BESTELLUNG", "DINE GRATIS GAVER MED ORDREN"],
    ["YOUR FREE GIFTS WITH PURCHASE", "DINE GRATIS GAVER MED ORDREN"],
    ["Kostenloser Versand", "Gratis levering"],
    ["Free Shipping", "Gratis levering"],
    ["1x GRATIS Flasche", "1x GRATIS flaske"],
    ["1x FREE Bottle", "1x GRATIS flaske"],
    ["2x GRATIS Flaschen", "2x GRATIS flasker"],
    ["2x FREE Bottles", "2x GRATIS flasker"],
    ["🔒 Ab 2x Vorrat", "🔒 Låses op ved 2x forsyning"],
    ["🔒 Unlocks with 2x Supply", "🔒 Låses op ved 2x forsyning"],
    ["Abo & Sparen (30% Rabatt)", "Abonnér & spar (30% rabatt)"],
    ["Subscribe & Save (30% Off)", "Abonnér & spar (30% rabatt)"],
    ["30% Dauerrabatt auf jede Folgelieferung. Jederzeit mit 1 Klick kündbar.", "30% fast rabatt på hver efterfølgende levering. Opsig når som helst med 1 klik."],
    ["30% recurring discount on every auto-delivery. Cancel anytime in 1 click.", "30% fast rabatt på hver efterfølgende levering. Opsig når som helst med 1 klik."],
    ["Kostenlose Lieferung", "Gratis levering"],
    ["Free Delivery", "Gratis levering"],
    ["30% Rabatt auf jede Folgebestellung", "30% rabatt på enhver genbestilling"],
    ["30% off every follow-up order", "30% rabatt på enhver genbestilling"],
    ["Jederzeit pausieren, anpassen oder mit 1 Klick kündigen", "Sett på pause, tilpas eller opsig når som helst med 1 klik"],
    ["Pause, adjust, or cancel anytime in 1 click", "Sett på pause, tilpas eller opsig når som helst med 1 klik"],
    ["Im 5-teiligen Vorteilspaket enthalten:", "Indeholdt i det 5-delte fordelssett:"],
    ["Included in the 5-Piece Value Bundle:", "Indeholdt i det 5-delte fordelssett:"],
    ["Included in the 5-piece value bundle:", "Indeholdt i det 5-delte fordelssett:"],
    ["Häufig zusammen gekauft", "Købes ofte sammen"],
    ["Frequently Bought Together", "Købes ofte sammen"],
    ["Von Dermatologen empfohlene Routine-Ergänzungen für maximale Ergebnisse:", "Hudlægeanbefalede rutinetilføjelser for maksimale resultater:"],
    ["Dermatologist-recommended routine additions for maximum results:", "Hudlægeanbefalede rutinetilføjelser for maksimale resultater:"],
    ["+ Hinzufügen", "+ Tilføj"],
    ["+ Add", "+ Tilføj"],
    ["Hinzugefügt", "Tilføjet"],
    ["Added", "Tilføjet"],
    ["Größe / Variante:", "Størrelse / Variant:"],
    ["Size / Variant:", "Størrelse / Variant:"],
    ["VORTEILSPACK", "FORDELSPAKKE"],
    ["VALUE PACK", "FORDELSPAKKE"],
    ["Schneller Versand: 1-3 Werktage innerhalb Deutschlands & EU", "Hurtig levering: 1-3 hverdage med DHL"],
    ["Fast Shipping: 1-3 business days delivery via DHL", "Hurtig levering: 1-3 hverdage med DHL"],
    ["100% Original K-Beauty: Direkt vom autorisierten Hersteller", "100% Ægte K-Beauty: Direkte fra autoriseret producent"],
    ["100% Authentic K-Beauty: Direct from authorized manufacturer", "100% Ægte K-Beauty: Direkte fra autoriseret producent"],
    ["30 Tage Zufriedenheits-Garantie: Risikofrei testen", "30 dages tilfredshedsgaranti: Prøv helt risikofrit"],
    ["30-Day Satisfaction Guarantee: Risk-free trial", "30 dages tilfredshedsgaranti: Prøv helt risikofrit"],
    ["30-Tage Geld-zurück-Garantie", "30 dages pengene-tilbage-garanti"],
    ["30-Day Money-Back Guarantee", "30 dages pengene-tilbage-garanti"],
    ["30 Tage risikofrei testen. Nicht zufrieden? Volle Erstattung – ohne Wenn und Aber.", "Prøv risikofrit i 30 dage. Ikke tilfreds? Fuld refusion – uden spørgsmål."],
    ["Try risk-free for 30 days. Not satisfied? Full refund – no questions asked.", "Prøv risikofrit i 30 dage. Ikke tilfreds? Fuld refusion – uden spørgsmål."],
    ["Dazu passt perfekt", "Passer perfekt sammen med"],
    ["Pairs Perfectly With", "Passer perfekt sammen med"],
    ["Koreas Nr. 1 Peeling- & Poren-Pad", "Koreas #1 eksfolierende pore-pad"],
    ["Tiefenregeneration mit Lachs-DNA", "Dybdegående cellefornyelse med lakse-PDRN"],
    ["Deep Cellular Repair with Salmon DNA", "Dybdegående cellefornyelse med lakse-PDRN"],
    ["Hauttyp", "Hudtype"],
    ["Skin Type", "Hudtype"],
    ["Haartyp", "Hårtype"],
    ["Hair Type", "Hårtype"],
    ["Hautbedürfnisse", "Hudtilstande"],
    ["Skin Concerns", "Hudtilstande"],
    ["Pflegebedürfnisse", "Plejebehov"],
    ["Care Needs", "Plejebehov"],
    ["Hauptwirkstoffe", "Vigtigste aktive ingredienser"],
    ["Key Active Ingredients", "Vigtigste aktive ingredienser"],
    ["139,00 € GESAMT-EINZELWERT • HEUTE NUR 34,00 €", "139,00 € SAMLET VÆRDI • I DAG KUN 34,00 €"],
    ["€139.00 TOTAL RETAIL VALUE • TODAY ONLY €34.00", "139,00 € SAMLET VÆRDI • I DAG KUN 34,00 €"],
    ["Was ist im 5-teiligen Komplett-Set enthalten?", "Hvad indeholder det 5-delte komplette sett?"],
    ["What is included in the 5-piece complete set?", "Hvad indeholder det 5-delte komplette sett?"],
    ["DAS HERO-PRODUKT", "HERO-PRODUKTET"],
    ["THE HERO PRODUCT", "HERO-PRODUKTET"],
    ["SCHRITT 1", "TRIN 1"],
    ["STEP 1", "TRIN 1"],
    ["SCHRITT 2", "TRIN 2"],
    ["STEP 2", "TRIN 2"],
    ["SCHRITT 3", "TRIN 3"],
    ["STEP 3", "TRIN 3"],
    ["SCHRITT 4", "TRIN 4"],
    ["STEP 4", "TRIN 4"],
    ["SCHRITT 5", "TRIN 5"],
    ["STEP 5", "TRIN 5"],
    ["HALS & DEKOLLETÉ LIFTING", "HALS & DEKOLLETÉ LØFT"],
    ["NECK & DÉCOLLETÉ LIFTING", "HALS & DEKOLLETÉ LØFT"],
    ["KIEFERKONTUR & DOPPELKINN", "KÆBELINJE & DOBBELTHAGE"],
    ["JAWLINE CONTOUR & DOUBLE CHIN", "KÆBELINJE & DOBBELTHAGE"],
    ["AUGEN-DEPOCKING & GLOW", "MOD HÆVEDE ØJNE & GLØD"],
    ["EYE DE-PUFFING & GLOW", "MOD HÆVEDE ØJNE & GLØD"],
    ["KRÄHENFÜSSE & FALTEN", "SMILERYNKER & FINE LINJER"],
    ["GLASS-SKIN FINISH", "GLASS-SKIN FINISH"],
    ["INSTANT GLOW & LIPPEN", "ØJEBLIKKELIG GLØD & LÆBER"],
    ["INSTANT GLOW & LIPS", "ØJEBLIKKELIG GLØD & LÆBER"],
    ["GEZIELTE AUGENPFLEGE", "MÅLRETTET ØJENPLEJE"],
    ["TARGETED EYE CARE", "MÅLRETTET ØJENPLEJE"],
    ["Einzel-UVP:", "Vejl. udsalgspris:"],
    ["Separate MSRP:", "Vejl. udsalgspris:"],
    ["TRANSPARENTER PREISVORTEIL", "GENNEMSKUELIG PRISFORDEL"],
    ["TRANSPARENT VALUE BREAKDOWN", "GENNEMSKUELIG PRISFORDEL"],
    ["SET JETZT SICHERN", "SIKR DIG DIT SÆT NU"],
    ["CLAIM YOUR SET NOW", "SIKR DIG DIT SÆT NU"],
    ["EINFACH & SCHNELL • NUR 5 MINUTEN TÄGLICH", "HURTIGT & NEMT • KUN 5 MINUTTER OM DAGEN"],
    ["FAST & EASY • JUST 5 MINUTES A DAY", "HURTIGT & NEMT • KUN 5 MINUTTER OM DAGEN"],
    ["Deine tägliche 5-Schritte Youth-Lock Routine", "Din daglige 5-trins Youth-Lock rutine"],
    ["Your Daily 5-Step Youth-Lock Regimen", "Din daglige 5-trins Youth-Lock rutine"],
    ["2–3x / WOCHE • 15 MIN", "2–3x / UGE • 15 MIN"],
    ["2–3x / WEEK • 15 MIN", "2–3x / UGE • 15 MIN"],
    ["V-Line Band anlegen", "Påfør V-Line maske"],
    ["Apply V-Line Band", "Påfør V-Line maske"],
    ["TÄGLICH MORGENS • 10 MIN", "DAGLIGT MORGEN • 10 MIN"],
    ["DAILY MORNING • 10 MIN", "DAGLIGT MORGEN • 10 MIN"],
    ["Augenpartie entstauen", "Dæmp hævelser omkring øjnene"],
    ["De-Puff Eye Area", "Dæmp hævelser omkring øjnene"],
    ["MORGENS & ABENDS • 30 SEK", "MORGEN & AFTEN • 30 SEK"],
    ["MORNING & EVENING • 30 SEC", "MORGEN & AFTEN • 30 SEK"],
    ["Falten präzise glätten", "Udjævn fine linjer præcist"],
    ["Target Fine Lines", "Udjævn fine linjer præcist"],
    ["TÄGLICH • 2 MINUTEN", "DAGLIGT • 2 MINUTTER"],
    ["DAILY • 2 MINUTES", "DAGLIGT • 2 MINUTTER"],
    ["Gua Sha Neck Massage", "Gua Sha halsmassage"],
    ["JEDERZEIT • FINISH & GLOW", "NÅR SOM HELST • FINISH & GLØD"],
    ["ANYTIME • FINISH & GLOW", "NÅR SOM HELST • FINISH & GLØD"],
    ["Glass-Skin Glow to-go", "Glass-Skin glød på farten"],
    ["On-The-Go Glass Skin Glow", "Glass-Skin glød på farten"],
    ["INTEGRIERTES GUA SHA TOOL • KEIN ZERBRECHLICHER STEIN", "INTEGRERET GUA SHA VÆRKTØJ • INGEN SKØR JADESTEN"],
    ["INTEGRATED GUA SHA TOOL • NO FRAGILE JADE STONE", "INTEGRERET GUA SHA VÆRKTØJ • INGEN SKØR JADESTEN"],
    ["Die richtige Gua Sha Technik: So massierst du wie die K-Beauty Profis", "Den korrekte Gua Sha teknik: Massér som K-Beauty eksperterne"],
    ["The Proper Gua Sha Technique: Massage Like Korean Aesthetic Professionals", "Den korrekte Gua Sha teknik: Massér som K-Beauty eksperterne"],
    ["1. Hals-Lifting gegen Tech-Neck", "1. Halsløft mod Tech-Neck"],
    ["1. Neck Lift Against Tech-Neck", "1. Halsløft mod Tech-Neck"],
    ["2. Jawline & V-Line Definition", "2. Kæbelinje & V-linje definition"],
    ["3. Dekolleté & Lymphatische Drainage", "3. Dekolleté & lymfatisk drænage"],
    ["3. Décolleté & Lymphatic Drainage", "3. Dekolleté & lymfatisk drænage"],
    ["Chirurgischer Edelstahl (Kühlend & Desinfizierbar)", "Kirurgisk rustfrit stål (Kølende & hygiejnisk)"],
    ["Surgical Stainless Steel (Cooling & Easy to Sanitize)", "Kirurgisk rustfrit stål (Kølende & hygiejnisk)"],
    ["Hygienischer Drehverschluss (Auslaufsicher)", "Hygiejnisk drejelås (Ingen lækager)"],
    ["Hygienic Twist-Lock Dispenser (Leak-Proof)", "Hygiejnisk drejelås (Ingen lækager)"],
    ["Präzise Dosierung während der Massage", "Præcis dosering under massagen"],
    ["Precise Cream Dispensing During Massage", "Præcis dosering under massagen"],
    ["Tiefe horizontaler Halsfalten nach 14 Tagen", "Dybde af tværgående halsrynker efter 14 dage"],
    ["Depth of horizontal neck lines after 14 days", "Dybde af tværgående halsrynker efter 14 dage"],
    ["DERMATOLOGISCHE KLINISCHE FORMEL", "DERMATOLOGISK KLINISK FORMEL"],
    ["DERMATOLOGICAL CLINICAL FORMULATION", "DERMATOLOGISK KLINISK FORMEL"],
    ["Die duale Wissenschaft hinter dem Set", "Den dobbelte videnskab bag settet"],
    ["The Dual-Action Science Behind the Regimen", "Den dobbelte videnskab bag settet"],
    ["PDRN (Lachs-DNA)", "PDRN (Lakse-DNA)"],
    ["PDRN (Salmon DNA)", "PDRN (Lakse-DNA)"],
    ["Zelluläre DNA-Reparatur", "Cellulær DNA-reparation"],
    ["Cellular DNA Repair", "Cellulær DNA-reparation"],
    ["5% Volufiline™ (Frankreich)", "5% Volufiline™ (Frankrig)"],
    ["5% Volufiline™ (France)", "5% Volufiline™ (Frankrig)"],
    ["Natürlicher Aufpolsterungseffekt", "Naturlig volumenopbyggende vævseffekt"],
    ["Natural Lipofilling Plumping Effect", "Naturlig volumenopbyggende vævseffekt"],
    ["Mechanische Gua Sha Lymphdrainage", "Mekanisk Gua Sha lymfedrænage"],
    ["Mechanical Gua Sha Lymphatic Drainage", "Mekanisk Gua Sha lymfedrænage"],
    ["Mikrozirkulation & Gewebestimulation", "Stimulering af mikrocirkulation & væv"],
    ["Microcirculation & Tissue Stimulation", "Stimulering af mikrocirkulation & væv"],
    ["KLINISCH GETESTET AN 34 PROBANDEN (4 WOCHEN)", "KLINISK TESTET PÅ 34 DELTAGERE (4 UGER)"],
    ["CLINICALLY TESTED ON 34 PARTICIPANTS (4 WEEKS)", "KLINISK TESTET PÅ 34 DELTAGERE (4 UGER)"],
    ["Messbare klinische Ergebnisse statt leerer Versprechen", "Målbare kliniske resultater, ikke tomme løfter"],
    ["Measurable Clinical Results Instead of Empty Promises", "Målbare kliniske resultater, ikke tomme løfter"],
    ["Straffere Kieferkontur & V-Shape", "Mere defineret kjevelinje & V-form"],
    ["Firmer Jawline & V-Contour", "Mere defineret kjevelinje & V-form"],
    ["Glattere Hals- & Dekolleté-Zone", "Glatte hals- & dekolletélinjer"],
    ["Smoother Neck & Décolleté Area", "Glatte hals- & dekolletélinjer"],
    ["Sofortige Frische & Kühleffekt", "Øjeblikkelig friskhed & køling"],
    ["Instant Freshness & Cooling Relief", "Øjeblikkelig friskhed & køling"],
    ["HÄUFIG GESTELLTE FRAGEN", "OFTE STILLEDE SPØRGSMÅL"],
    ["FREQUENTLY ASKED QUESTIONS", "OFTE STILLEDE SPØRGSMÅL"],
    ["Alles, was du über das 5-teilige Set wissen musst", "Alt hvad du behøver at vide om det 5-delte sett"],
    ["Everything You Need to Know About the 5-Piece Set", "Alt hvad du behøver at vide om det 5-delte sett"],
    ["In welcher genauen Reihenfolge soll ich die 5 Produkte anwenden?", "I hvilken rækkefølge skal produkterne anvendes?"],
    ["In what exact order should I apply the 5 products?", "I hvilken rækkefølge skal produkterne anvendes?"],
    ["LIMITIERTE AKTION • 75% RABATT", "BEGRÆNSET TILBUD • SPAR 75%"],
    ["LIMITED OFFER • 75% OFF", "BEGRÆNSET TILBUD • SPAR 75%"],
    ["Bereit für deine straffeste Kontur & jugendlichen Glow?", "Er du klar til din mest definerede kjevelinje og ungdommelige glød?"],
    ["Ready for your firmest contour & youthful glow?", "Er du klar til din mest definerede kjevelinje og ungdommelige glød?"],
    ["Hol dir jetzt alle 5 K-Beauty Bestseller im Vorteilspaket für nur", "Få alle 5 K-Beauty bestsellere i en eksklusiv fordelspakke til kun"],
    ["Get all 5 K-Beauty bestsellers in the exclusive value bundle for only", "Få alle 5 K-Beauty bestsellere i en eksklusiv fordelspakke til kun"],
    ["statt 139,00 € UVP", "vejl. pris 139,00 €"],
    ["instead of €139.00 MSRP", "vejl. pris 139,00 €"],
    ["Schneller DHL-Versand (1-3 Tage)", "Hurtig DHL-levering (1-3 hverdage)"],
    ["Fast DHL Shipping (1-3 Days)", "Hurtig DHL-levering (1-3 hverdage)"],
    ["Kundenbewertungen", "Kundeanmeldelser"],
    ["Customer Reviews", "Kundeanmeldelser"],
    ["Verifizierte Erfahrungen", "Verificerede oplevelser"],
    ["Verified Experiences", "Verificerede oplevelser"],
    ["Bewertung schreiben", "Skriv en anmeldelse"],
    ["Write a Review", "Skriv en anmeldelse"],
    ["5 Sterne", "5 stjerner"],
    ["5 Stars", "5 stjerner"],
    ["4 Sterne", "4 stjerner"],
    ["4 Stars", "4 stjerner"],
    ["3 Sterne", "3 stjerner"],
    ["3 Stars", "3 stjerner"],
    ["2 Sterne", "2 stjerner"],
    ["2 Stars", "2 stjerner"],
    ["1 Stern", "1 stjerne"],
    ["1 Star", "1 stjerne"],
    ["Basierend auf", "Baseret på"],
    ["Based on", "Baseret på"],
    ["verifizierten Bewertungen", "verificerede anmeldelser"],
    ["verified reviews", "verificerede anmeldelser"],
    ["Verifiziert", "Verificeret"],
    ["Verified", "Verificeret"],
    ["Hilfreich", "Nyttig"],
    ["Helpful", "Nyttig"],
    ["Vorteile & Wirkung", "Fordele & Virkning"],
    ["Benefits & Efficacy", "Fordele & Virkning"],
    ["Klinische Studien & Wirksamkeit", "Kliniske studier & Resultater"],
    ["Clinical Studies & Results", "Kliniske studier & Resultater"],
    ["Reinheitsgarantie & Inhaltsstoffe", "Ren formel & Ingredienser"],
    ["Clean Formula & Ingredients", "Ren formel & Ingredienser"],
    ["Anwendung & Routine-Schritte", "Anvendelse & Rutinetrin"],
    ["How to Use & Routine Steps", "Anvendelse & Rutinetrin"],
    ["Häufig gestellte Fragen (FAQ)", "Ofte stillede spørgsmål (FAQ)"],
    ["Frequently Asked Questions (FAQ)", "Ofte stillede spørgsmål (FAQ)"],
    ["Vorteile des Abonnements (30% Rabatt)", "Abonnementsfordele (30% rabatt)"],
    ["Subscription Benefits (30% Off)", "Abonnementsfordele (30% rabatt)"],
    ["✓ Ohne Duftstoffe", "✓ Uden parfume"],
    ["✓ Fragrance-Free", "✓ Uden parfume"],
    ["✓ Ohne Parabene", "✓ Uden parabener"],
    ["✓ Paraben-Free", "✓ Uden parabener"],
    ["✓ Ohne Silikone", "✓ Uden silikone"],
    ["✓ Silicone-Free", "✓ Uden silikone"],
    ["✓ Ohne Sulfate", "✓ Uden sulfater"],
    ["✓ Sulfate-Free", "✓ Uden sulfater"],
    ["✓ Cruelty-Free", "✓ Cruelty-Free (Ikke testet på dyr)"],
    ["✓ Nicht-komedogen", "✓ Non-comedogen (Tilstopper ikke porerne)"],
    ["✓ Non-Comedogenic", "✓ Non-comedogen (Tilstopper ikke porerne)"],
    ["Dein Warenkorb ist noch leer", "Din indkøbskurv er tom i øjeblikket"],
    ["Your cart is currently empty", "Din indkøbskurv er tom i øjeblikket"],
    ["Dein Warenkorb", "Din indkøbskurv"],
    ["Your Cart", "Din indkøbskurv"],
    ["Warenkorb", "Indkøbskurv"],
    ["Cart", "Indkøbskurv"],
    ["ZUR KASSE • SICHERE ZAHLUNG", "GÅ TIL KASSEN • SIKKER BETALING"],
    ["CHECKOUT • SECURE PAYMENT", "GÅ TIL KASSEN • SIKKER BETALING"],
    ["Zur Kasse", "Gå til kassen"],
    ["Checkout", "Gå til kassen"],
    ["Kostenloser Versand freigeschaltet!", "Gratis levering opnået!"],
    ["Free shipping unlocked!", "Gratis levering opnået!"],
    ["Jetzt im Trend:", "Trender lige nu:"],
    ["Trending Now:", "Trender lige nu:"],
    ["Koreanische Skincare", "Koreansk hudpleje"],
    ["Korean Skincare", "Koreansk hudpleje"],
    ["Geräte", "Enheter"],
    ["Devices", "Enheter"],
    ["ALLE ANZEIGEN", "SE ALLE"],
    ["VIEW ALL", "SE ALLE"],
    ["JETZT SHOPPEN", "KJØP NÅ"],
    ["SHOP NOW", "KJØP NÅ"],
    ["Jetzt shoppen", "Kjøp nå"],
    ["Shop Now", "Kjøp nå"],
    ["ECHTE ERFAHRUNGEN UNSERER COMMUNITY", "ÆGTE OPLEVELSER FRA VORES FÆLLESSKAB"],
    ["REAL EXPERIENCES FROM OUR COMMUNITY", "ÆGTE OPLEVELSER FRA VORES FÆLLESSKAB"],
    ["100% dermatologisch", "100% testet af"],
    ["100% Dermatologist", "100% testet af"],
    ["getestet.", "hudlæger."],
    ["Tested.", "hudlæger."],
    ["Klinisch bewiesene<br>K-Beauty Formeln.", "Klinisk dokumenterede<br>K-Beauty formler."],
    ["Clinically Proven<br>K-Beauty Formulas.", "Klinisk dokumenterede<br>K-Beauty formler."],
    ["Klinisch bewiesene K-Beauty Formeln.", "Klinisk dokumenterede K-Beauty formler."],
    ["Clinically proven K-Beauty formulas.", "Klinisk dokumenterede K-Beauty formler."]
  ];
